// Mainly for the main application, not the frontend

export default {
  customer_accounts: {
    tab: 'Locaties & contacten',
    load_failed: 'Locaties en contactpersonen konden niet worden geladen',
    save_failed: 'Opslaan is mislukt',
    archive: 'Archiveren',
    archived: 'Gearchiveerd',
    restore: 'Herstellen',
    show_archived: 'Toon gearchiveerd',
    sites: {
      title: 'Locaties',
      subtitle:
        'Installatieadressen van deze klant. Iedere offerte, project en werkbon hoort bij één locatie; de factuur gaat altijd naar de klant.',
      add: 'Locatie toevoegen',
      edit: 'Locatie bewerken',
      add_contact: 'Bewoner / contact op locatie',
      search: 'Zoek op adres, label, referentie of bewoner',
      no_results: 'Geen locaties gevonden',
      empty_title: 'Nog geen locaties',
      empty_description:
        'Voeg installatieadressen toe, of plak een lijst adressen in één keer vanuit Excel.',
      created: 'Locatie toegevoegd',
      updated: 'Locatie bijgewerkt',
      updated_synced: 'Locatie bijgewerkt, adres doorgezet naar {count} open project(en)/werkbon(nen)',
      archived: 'Locatie gearchiveerd',
      restored: 'Locatie hersteld',
      archive_title: '{name} archiveren?',
      archive_description:
        'De locatie verdwijnt uit de keuzelijsten. Bestaande offertes, projecten en facturen blijven ongewijzigd.',
      archive_open_warning:
        'Er staan nog {count} open werkbon(nen) op deze locatie. Die blijven bestaan, maar de locatie verdwijnt uit de keuzelijsten.',
      sync_hint:
        'Een adreswijziging wordt doorgezet naar de open projecten en werkbonnen van deze locatie ({count} open werkbon(nen)).',
      usage: {
        proposals: 'Offertes: {count}',
        projects: 'Projecten: {count}',
        open_work_orders: 'Open werkbonnen: {count}',
      },
      fields: {
        label: 'Naam / label',
        label_placeholder: 'Bijv. Blok A, Woning 12 of Kantoor Utrecht',
        external_ref: 'Referentie klant',
        external_ref_placeholder: 'Bijv. bouwnummer of projectnummer',
        address: 'Installatieadres',
        access_notes: 'Toegang & bijzonderheden',
        access_notes_placeholder: 'Sleutel bij beheerder, parkeren achterom, bel aan bij nr. 14…',
        notes: 'Interne notities',
      },
      validation: {
        address_required: 'Vul minimaal een straat, postcode of plaats in',
      },
      bulk: {
        open: 'Meerdere plakken',
        title: 'Meerdere locaties toevoegen',
        intro:
          'Eén adres per regel. Plak direct vanuit Excel (kolommen: label, straat, huisnummer, postcode, plaats) of typ vrije tekst.',
        lines: 'Adressen',
        placeholder: 'Dorpsstraat 12, 1234 AB Utrecht',
        count: '{count} regel(s)',
        submit: '{count} locatie(s) toevoegen',
        created: '{count} locatie(s) toegevoegd',
        failed_title: '{count} regel(s) niet herkend',
        failed_hint: 'Deze regels staan hieronder klaar om te verbeteren.',
      },
    },
    contacts: {
      title: 'Contactpersonen',
      subtitle:
        'Algemene contactpersonen van de klant, zoals inkoop, administratie of uitvoerder. Bewoners voeg je toe bij de locatie.',
      add: 'Contactpersoon toevoegen',
      edit: 'Contactpersoon bewerken',
      empty: 'Nog geen extra contactpersonen. Mails gaan naar het hoofdadres van {name}.',
      whole_customer: 'Hele klant (geen specifieke locatie)',
      created: 'Contactpersoon toegevoegd',
      updated: 'Contactpersoon bijgewerkt',
      archived: 'Contactpersoon gearchiveerd',
      restored: 'Contactpersoon hersteld',
      archive_title: '{name} archiveren?',
      archive_description:
        'Deze persoon ontvangt geen mails meer. Bestaande offertes en projecten blijven ongewijzigd.',
      primary_hint_site: 'Eerste aanspreekpunt op deze locatie',
      primary_hint_customer: 'Eerste aanspreekpunt voor de hele klant',
      roles: {
        quote: 'Offertes',
        invoice: 'Facturen',
        planning: 'Planning',
      },
      role_hints: {
        quote: 'Ontvangt offertes als er geen andere ontvanger is gekozen',
        invoice: 'Ontvangt facturen als de klant geen apart factuur-e-mailadres heeft',
        planning: 'Ontvangt afspraakbevestigingen voor werk op locatie',
      },
      fields: {
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        email: 'E-mailadres',
        phone: 'Telefoon',
        job_title: 'Functie / rol',
        job_title_placeholder: 'Bijv. inkoper, uitvoerder, bewoner',
        site: 'Locatie',
        roles: 'Ontvangt',
        is_primary: 'Hoofdcontact',
        notes: 'Notities',
      },
      validation: {
        name_or_email: 'Vul een naam of e-mailadres in',
        invalid_email: 'Ongeldig e-mailadres',
      },
    },
    picker: {
      site: 'Installatieadres',
      site_none: 'Adres van de klant',
      site_hint: 'De factuur gaat altijd naar de klant; dit adres staat als werkadres op de offerte.',
      contact: 'Ter attentie van',
      contact_default: 'Standaard (offertecontact of hoofdadres)',
      updated: 'Locatie en contactpersoon bijgewerkt',
      manage: 'Locaties beheren',
    },
    duplicate: {
      action: 'Dupliceren naar locaties',
      title: 'Offerte dupliceren naar andere locaties',
      intro:
        'Per gekozen locatie wordt een eigen offerte en deal aangemaakt met dezelfde regels. De factuur gaat later gewoon naar de klant.',
      select_all: 'Alles selecteren',
      submit: 'Dupliceer naar {count} locatie(s)',
      created: '{count} offerte(s) aangemaakt',
      partial: '{created} offerte(s) aangemaakt, {failed} mislukt',
      none_available: 'Er zijn geen andere locaties. Voeg eerst locaties toe bij de klant.',
      current: 'huidige offerte',
    },
    project: {
      site: 'Locatie',
      contact: 'Contact op locatie',
      access_notes: 'Toegang',
      residents: 'Bewoners / contacten',
    },
    invoice: {
      installation_address: 'Werkadres',
    },
  },
  resources: {
    title: 'Materieel',
    description:
      'Bussen, steigers en gereedschap: wat je hebt, waar het ligt en wanneer het nodig is.',
    nav: 'Materieel',
    kinds: {
      vehicle: 'Bus',
      equipment: 'Materieel',
      tool: 'Gereedschap',
    },
    statuses: {
      available: 'Beschikbaar',
      maintenance: 'In onderhoud',
      lost: 'Kwijt / defect',
      retired: 'Afgevoerd',
    },
    requirement_statuses: {
      required: 'Nodig',
      reserved: 'Gereserveerd',
      rented: 'Gehuurd',
      on_site: 'Op locatie',
      returned: 'Retour',
    },
    fulfillment: {
      own: 'Eigen materieel',
      rent: 'Huren',
    },
    tabs: {
      vehicles: 'Bussen',
      equipment: 'Materieel',
      rentals: 'Huur',
    },
    kpi: {
      vehicles: 'Bussen',
      equipment: 'Materieel & gereedschap',
      rented_now: 'Open huur',
      conflicts: 'Conflicten (14 dagen)',
    },
    fields: {
      kind: 'Type',
      name: 'Naam',
      code: 'Code',
      license_plate: 'Kenteken',
      category: 'Categorie',
      category_placeholder: 'Bijv. steiger, ladder, boormachine',
      category_hint: 'Werkbonnen kunnen om een categorie vragen in plaats van een specifiek item.',
      quantity: 'Aantal',
      parent_vehicle: 'Standaard in bus',
      no_parent: 'Niet in een bus (loods/depot)',
      height_mm: 'Werkhoogte (mm)',
      status: 'Status',
      status_until: 'Tot en met',
      status_note: 'Toelichting',
      status_note_placeholder: 'Bijv. APK, reparatie, wie heeft het laatst gezien',
      default_users: 'Vaste monteurs',
      default_users_placeholder: 'Kies monteurs',
      notes: 'Notities',
    },
    actions: {
      add: 'Toevoegen',
      add_vehicle: 'Bus toevoegen',
      add_equipment: 'Materieel toevoegen',
      add_to_vehicle: 'Item in deze bus',
      add_requirement: 'Materieel toevoegen',
      derive: 'Afleiden uit producten',
      open_timeline: 'Tijdlijn',
      mark_reserved: 'Reserveren',
      mark_rented: 'Huur vastleggen',
      mark_on_site: 'Op locatie',
      mark_returned: 'Retour gemeld',
      rental_details: 'Huurgegevens',
      back_to_required: 'Terug naar nodig',
    },
    empty: {
      vehicles_title: 'Nog geen bussen',
      vehicles_description: 'Voeg je bussen toe om per dag te zien wat er meegaat.',
      equipment_title: 'Nog geen materieel',
      equipment_description:
        'Voeg steigers, ladders en gereedschap toe, los of als inventaris van een bus.',
      rentals_title: 'Geen openstaande huur',
      rentals_description: 'Gehuurd materieel dat nog niet retour is verschijnt hier.',
      no_results: 'Geen materieel gevonden voor deze filters.',
    },
    messages: {
      load_failed: 'Materieel laden mislukt',
      created: 'Materieel toegevoegd',
      updated: 'Materieel bijgewerkt',
      deleted: 'Materieel verwijderd',
      save_failed: 'Opslaan mislukt',
      delete_failed: 'Verwijderen mislukt',
      delete_title: 'Materieel verwijderen?',
      delete_description:
        '"{name}" wordt verwijderd. Inventaris in deze bus blijft bestaan zonder bus.',
      delete_confirm: 'Ja, verwijder',
      requirement_added: 'Materieel toegevoegd aan werkbon',
      requirement_updated: 'Materieel bijgewerkt',
      requirement_removed: 'Materieel verwijderd van werkbon',
      requirement_failed: 'Materieel bijwerken mislukt',
      derived: '{count} regel(s) afgeleid uit producten',
      derived_none: 'Geen productregels gevonden voor deze werkbon',
    },
    validation: {
      check_fields: 'Controleer de velden',
      quantity_min: 'Aantal moet minimaal 1 zijn',
      resource_or_category: 'Kies een specifiek item of een categorie',
    },
    drawer: {
      inventory: 'Standaardinventaris',
      no_inventory:
        'Nog niets in deze bus. Voeg materieel toe en kies deze bus als standaardlocatie.',
      default_users: 'Vaste monteurs',
      no_default_users: 'Geen vaste monteurs',
      upcoming: 'Komende inzet',
      no_upcoming: 'Geen geplande inzet in de komende 30 dagen',
      in_vehicle: 'In bus',
      loose: 'Los (loods/depot)',
      availability: 'Beschikbaarheid',
      until: 'tot {date}',
    },
    requirement: {
      title: 'Materieel',
      subtitle: 'Wat moet er mee of gehuurd worden voor deze klus?',
      empty: 'Nog geen materieel gekoppeld. Voeg handmatig toe of leid af uit de producten.',
      source_product_rule: 'Uit product',
      source_manual: 'Handmatig',
      period: 'Periode',
      days_before: 'Dagen vooraf',
      days_after: 'Dagen erna',
      days_hint: 'Relatief aan de afspraakdatum; bij verplaatsen schuift de periode mee.',
      mode_specific: 'Specifiek item',
      mode_category: 'Categorie',
      choose_resource: 'Kies materieel',
      choose_category: 'Kies categorie',
      quantity: 'Aantal',
      note: 'Opmerking',
      fulfillment: 'Invulling',
      conflict: 'Conflict',
      conflict_detail: 'Op {date}: {required} nodig, {capacity} beschikbaar',
      conflict_with: 'Botst met {count} andere werkbon(nen)',
      availability_ok: 'Beschikbaar in deze periode',
      availability_conflict: 'Niet volledig beschikbaar: {days} dag(en) met conflict',
      availability_checking: 'Beschikbaarheid controleren…',
      no_date: 'Werkbon heeft nog geen afspraakdatum; periode volgt zodra er gepland is.',
      remove_title: 'Materieel verwijderen?',
      remove_description: '{label} wordt van deze werkbon gehaald.',
    },
    rental: {
      title: 'Huurgegevens',
      supplier: 'Leverancier',
      supplier_other: 'Andere verhuurder',
      supplier_name: 'Naam verhuurder',
      cost: 'Huurkosten (excl. btw)',
      reference: 'Huurreferentie',
      pickup_date: 'Ophalen / levering',
      return_date: 'Retourdatum',
      create_task: 'Maak een taak voor retour melden',
      task_created: 'Retourtaak aangemaakt',
      save: 'Huur vastleggen',
      open_rentals: 'Openstaande huur',
      none_open: 'Geen openstaande huur',
      total_cost: 'Totale huurkosten',
      overdue: 'Retour te laat',
      return_today: 'Vandaag retour',
      return_in_days: 'Retour over {days} dagen',
      no_return_date: 'Geen retourdatum',
      for_work_order: 'Voor werkbon',
    },
    timeline: {
      title: 'Materieel tijdlijn',
      description: 'Wie heeft wat, wanneer. Rood = meer gevraagd dan beschikbaar.',
      today: 'Vandaag',
      this_week: 'Deze week',
      weeks: '{count} weken',
      no_resources: 'Nog geen materieel om te tonen.',
      legend_planned: 'Gepland',
      legend_rented: 'Gehuurd',
      legend_unavailable: 'Niet beschikbaar',
      legend_conflict: 'Conflict',
      group_vehicles: 'Bussen',
      group_equipment: 'Materieel',
      group_tools: 'Gereedschap',
      category_demand: 'Vraag per categorie',
      capacity: 'capaciteit {capacity}',
      load_failed: 'Tijdlijn laden mislukt',
    },
    planning: {
      conflict_badge: 'Materieel',
      conflict_tooltip: 'Materieelconflict: {detail}',
      conflicts_in_view: '{count} werkbon(nen) met materieelconflict',
    },
    load_list: {
      vehicle: 'Bus',
      vehicles: 'Bussen vandaag',
      no_vehicle: 'Geen vaste bus voor deze monteur(s)',
      inventory: 'Standaardinventaris',
      bring: 'Mee te nemen materieel',
      nothing_to_bring: 'Geen extra materieel nodig',
      rented: 'Gehuurd — {supplier}',
      check_all: 'Alles afvinken',
    },
    project: {
      title: 'Materieel & huur',
      description: 'Per werkbon wat er nodig is en wat de huur kost.',
      total_rental_cost: 'Totale huurkosten',
      no_requirements: 'Nog geen materieel gekoppeld aan werkbonnen in dit project.',
      requirements_count: '{count} regel(s)',
    },
    product: {
      title: 'Benodigd materieel',
      description:
        'Bij het aanmaken van een werkbon met dit product worden deze regels automatisch toegevoegd.',
      add_rule: 'Regel toevoegen',
      category: 'Categorie',
      specific: 'Specifiek item',
      min_height: 'Vanaf hoogte (mm)',
      min_height_hint: 'Alleen toepassen als de montagehoogte minimaal dit is. Leeg = altijd.',
      quantity: 'Aantal',
      days_before: 'Dagen vooraf',
      days_after: 'Dagen erna',
      no_rules: 'Geen materieelregels voor dit product.',
      saved: 'Materieelregels opgeslagen',
      save_failed: 'Materieelregels opslaan mislukt',
    },
  },
  sales_orders: {
    amount: 'Bedrag',
    revisions: 'Revisies',
    confirmed: 'Bevestigd',
    cancelled: 'Geannuleerd',
    cancel: 'Annuleren',
    cancel_confirm: 'Ja, annuleer verkooporder',
    cancel_keep: 'Nee, behouden',
    cancelled_done: 'Verkooporder geannuleerd',
    cancel_failed: 'Verkooporder annuleren mislukt',
    load_failed: 'Verkooporder laden mislukt',
    create: 'Verkooporder maken',
    specs: 'Specificaties',
    no_specs: 'Geen specificaties op deze versie.',
    create_intro: 'Prijzen zijn inclusief btw. Hierna start het project, zonder offerte.',
    create_project_hint:
      'Zonder offerte start het project vanuit een verkooporder. Vul de regels in, daarna wordt het project actief.',
    create_failed: 'Verkooporder maken mislukt',
    line_description: 'Omschrijving',
    line_quantity: 'Aantal',
    line_price: 'Prijs incl. btw',
    add_line: 'Regel toevoegen',
    line_required: 'Voeg minstens één product of regel toe.',
    products: 'Producten',
    other_lines: 'Overige regels',
    add_product: 'Product zoeken en configureren...',
    add_to_order: 'Toevoegen aan verkooporder',
    reconfigure: 'Opnieuw configureren',
    hide_from_customer: 'Verbergen voor klant',
    show_to_customer: 'Tonen aan klant',
    hidden_badge: 'Verborgen',
    hidden_hint:
      'Niet zichtbaar op orderbevestiging en factuur; wel op werkbon, pakbon en bestelling.',
    line_total: 'Regeltotaal incl. btw',
    total_incl: 'Totaal incl. btw',
    pricing: 'Prijs berekenen...',
    pricing_failed: 'Prijs berekenen mislukt',
    price_server_hint:
      'Prijzen komen uit de catalogus, inclusief marge. Dit zijn de bedragen die op de verkooporder komen.',
    customer: 'Klant',
    customer_required: 'Kies een klant.',
    customer_placeholder: 'Zoek een klant...',
    new_project_from_proposal: 'Project vanuit offerte',
    confirm_and_start: 'Bevestigen en project starten',
    save_configuration: 'Configuratie opslaan',
    no_products_yet: 'Nog geen producten. Zoek hierboven een product om te configureren.',
    other_lines_hint: 'Voor montage, voorrijkosten of iets dat niet in de catalogus staat.',
    wizard: {
      steps: 'Stappen',
      step_of: 'Stap {current} van {total}',
      summary: 'Overzicht',
      project: 'Project',
      review: 'Controleren',
      planning: 'Planning',
      customer_heading: 'Voor wie is deze verkoop?',
      customer_hint: 'Kies een bestaande klant. Het adres gebruiken we straks als montageadres.',
      products_heading: 'Wat wordt er verkocht?',
      products_hint:
        'Zoek een product en configureer het. Opties die niet kunnen bij je keuzes worden uitgeschakeld.',
      project_heading: 'Projectgegevens',
      project_hint: 'Alles is optioneel en later aan te passen op het project.',
      review_heading: 'Controleren en bevestigen',
      confirm_hint:
        'Na bevestigen wordt de verkooporder vastgelegd en start het project. Wijzigingen gaan daarna via een nieuwe versie of meerwerk.',
      from_proposal_question: 'Is er al een geaccepteerde offerte?',
      from_proposal_action: 'Start het project vanuit de offerte',
      no_customer: 'Nog geen klant gekozen',
      no_lines: 'Nog geen regels',
      line_count: '{count} regel(s)',
    },
    reasons: {
      accept: 'Verkooporder bevestigd',
      new_version: 'Gereviseerd',
      force_edit: 'Offerte gecorrigeerd',
      meerwerk: 'Meerwerk toegevoegd',
      manual: 'Handmatig ingevoerd',
    },
  },

  // Klanttraject (fase, wie is aan zet, volgende stap)
  journey: {
    card_title: 'Van deal naar project',
    phase_of: 'Fase {current} van {total}',
    since_days: 'sinds {count} dagen',
    phase_skipped: 'overgeslagen',
    phase_hints: {
      request: 'aanvraag binnengekomen',
      proposal: 'offerte maken en versturen',
      measurement: 'inmeting plannen en uitvoeren',
      sold: 'klant is akkoord',
      preparation: 'bestellingen en werkbonnen',
      execution: 'uitvoering op locatie',
      closing: 'factureren en afronden',
    },
    phases: {
      request: 'Aanvraag',
      proposal: 'Offerte',
      measurement: 'Inmeting',
      sold: 'Verkocht',
      preparation: 'Voorbereiding',
      execution: 'Uitvoering',
      closing: 'Afronding',
    },
    ball: {
      us: 'Actie bij ons',
      customer: 'Wacht op klant',
      supplier: 'Wacht op leverancier',
      installer: 'Bij monteur',
    },
    status: {
      open: 'Loopt',
      completed: 'Traject afgerond',
      lost: 'Deal verloren',
    },
    steps: {
      create_proposal: 'Offerte maken',
      send_proposal: 'Offerte versturen',
      await_proposal_decision: 'Klant beslist over de offerte',
      follow_up_proposal: 'Offerte opvolgen, nog geen reactie',
      renew_proposal: 'Offerte is verlopen, vernieuwen',
      create_measurement: 'Inmeting aanmaken',
      schedule_measurement: 'Inmeting inplannen',
      perform_measurement: 'Inmeting uitvoeren',
      create_definitive_proposal: 'Definitieve offerte maken',
      start_project: 'Project starten',
      start_preparation: 'Bestellen of werkbon aanmaken',
      place_order: 'Bestelling plaatsen bij leverancier',
      create_work_order: 'Werkbon aanmaken',
      schedule_work_order: 'Werkbon inplannen',
      await_delivery: 'Levering afwachten',
      execute_work_order: 'Werkzaamheden uitvoeren',
      create_final_invoice: 'Eindfactuur maken',
      send_invoice: 'Factuur versturen',
      await_payment: 'Klant betaalt de factuur',
      send_payment_reminder: 'Betaling te laat, herinnering sturen',
      complete_project: 'Project afronden',
    },
    proposal_steps: {
      proforma: {
        send_proposal: 'Voorlopige offerte versturen',
        await_proposal_decision: 'Klant beslist over de voorlopige offerte',
        follow_up_proposal: 'Voorlopige offerte opvolgen, nog geen reactie',
        renew_proposal: 'Voorlopige offerte is verlopen, vernieuwen',
      },
      definitive: {
        send_proposal: 'Definitieve offerte versturen',
        await_proposal_decision: 'Klant beslist over de definitieve offerte',
        follow_up_proposal: 'Definitieve offerte opvolgen, nog geen reactie',
        renew_proposal: 'Definitieve offerte is verlopen, vernieuwen',
      },
    },
    progress: {
      orders: '{done}/{total} bestellingen binnen',
      work_orders: '{done}/{total} werkbonnen klaar',
    },
    open: {
      proposal: 'Open offerte',
      project: 'Open project',
      order: 'Open bestelling',
      work_order: 'Open werkbon',
      invoice: 'Open factuur',
    },
    deal_actions: {
      create_proposal: 'Naar offertes',
      start_project: 'Project aanmaken',
    },
    board: {
      view: 'Traject',
      all: 'Alles',
      show_more: 'Toon {count} meer',
      empty_column: 'Geen deals in deze fase',
    },
    actions: {
      title: 'Aan zet',
      description:
        'Volgende stappen uit lopende trajecten, inclusief deals zonder eigenaar. Verdwijnen vanzelf zodra ze gedaan zijn.',
      inbox: 'Voor mij',
      mine: 'Mijn deals',
      unassigned: 'Niet toegewezen',
      everyone: 'Iedereen',
      mine_empty: 'Geen deals van jou aan zet.',
      unassigned_empty: 'Geen deals zonder eigenaar.',
      empty: 'Niets aan zet. Alles ligt bij klant, leverancier of monteur.',
      show_all: 'Toon alle {count}',
      show_less: 'Minder tonen',
    },
  },

  // Statistics (herbruikbaar over dashboard componenten)
  stats: {
    periods: {
      last_30_days: 'Afgelopen 30 dagen',
      last_quarter: 'Afgelopen kwartaal',
      year_to_date: 'Dit jaar',
      all_time: 'Alles',
      custom_range: 'Aangepaste periode',
      select_dates: 'Selecteer datums',
    },
    vs_previous: 't.o.v. vorige periode',
    no_data: 'Geen gegevens beschikbaar',
  },

  // Validation
  validation: {
    required: 'Dit veld is verplicht.',
    max_length: 'Maximale lengte is {max} tekens.',
    min_length: 'Minimale lengte is {min} tekens.',
    min_items: 'Minimaal aantal items is {min}.',
    email: 'Ongeldig e-mailadres.',
    min: 'Waarde moet minimaal {min} zijn.',
    max: 'Waarde mag maximaal {max} zijn.',
    required_checkbox: 'Minimaal één optie moet geselecteerd zijn.',
    kvk_nl: 'KVK-nummer moet 8 cijfers zijn.',
    vat_nl: 'BTW-nummer moet de vorm NL000000000B00 hebben.',
  },

  attribution: {
    title: 'Herkomst',
    utm_source: 'Bron',
    utm_medium: 'Medium',
    utm_campaign: 'Campagne',
    utm_content: 'Content',
    utm_term: 'Zoekterm',
    landing_page: 'Landingspagina',
    referrer: 'Referrer',
    gclid: 'Google click ID',
    fbclid: 'Meta click ID',
    ttclid: 'TikTok click ID',
    first_touch_at: 'Eerste bezoek',
  },

  // Navigation & Layout
  navigation: {
    home: 'Home',
    dashboard: 'Dashboard',
    forms: 'Alle funnels',
    integrations: 'Integraties',
    analytics: 'Analytics',
    settings: 'Instellingen',
    support: 'Ondersteuning',
    collapse_sidebar: 'Inklappen',
    expand_sidebar: 'Uitklappen',
    logout: 'Uitloggen',
    main_menu: 'Hoofdmenu',
    tools: 'Tools',
    resources: 'Help',
    automations: 'Automatiseringen',
    documentation: 'Documentatie',
    crm: 'Klanten',
    stats: 'Statistieken',
    products: 'Producten',
    catalog: 'Catalogus',
    discounts: 'Kortingen',
    account: 'Account',
    sign_out: 'Uitloggen',
    admin: 'Beheerder',
    member: 'Lid',
    // Sidebar sections
    builder: 'Builder',
    leads: 'Leads',
    analysis: 'Analyse',
    group_crm: 'CRM',
    group_sales: 'Verkoop',
    group_operations: 'Uitvoering',
    group_finance: 'Financieel',
    group_setup: 'Inrichten',
    // Navigation items
    all_funnels: 'Alle funnels',
    proposals: 'Offertes',
    appointments: 'Afspraken',
    requests: 'Aanvragen',
    more: 'Meer',
    switch_organization: 'Wissel van organisatie',
    // Organization switcher
    choose_organization: 'Kies je organisatie',
    choose_organization_description: 'Kies naar welke organisatie je wilt overschakelen',
    search_organizations_placeholder: 'Zoek een organisatie...',
    organizations_count: '{visible} van {total} organisaties',
    current_organization: 'Huidige organisatie',
    no_organizations_found: 'Geen organisaties gevonden',
    add_another_organization: 'Nog een organisatie toevoegen',
    add_new_organization: 'Nieuwe organisatie toevoegen',
    add_new_organization_description: 'Voeg een nieuwe organisatie toe aan je account',
    operations: 'Operations',
    projects: 'Projecten',
    orders: 'Bestellingen',
    jobs: 'Opdrachten', // Deprecated, kept for backward compatibility
    planning: 'Planning',
    service: 'Service',
    deals: 'Deals',
    invoices: 'Facturen',
    submissions: 'Aanvragen',
    tasks: 'Taken',
    my_account: 'Mijn gegevens',
    owner: 'Eigenaar',
    anonymous_mode: 'Anonieme modus',
    anonymous_mode_on: 'Gefingeerde namen',
    anonymous_mode_off: 'Voor schermdelen',
  },

  // Telefonie-integratie: terugbellijst
  callbacks: {
    title: 'Terugbellijst',
    description: 'Open terugbelverzoeken vanuit het telefoniesysteem.',
    filter_open: 'Openstaand',
    filter_completed: 'Afgerond',
    filter_all: 'Alles',
    empty_title: 'Geen terugbelverzoeken openstaand',
    empty_description: 'Zodra er een terugbelverzoek binnenkomt, verschijnt het hier.',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    no_due_date: 'Geen datum',
    unknown_lead: 'Onbekende lead',
    unassigned: 'Niet toegewezen',
    from_telephony: 'Telefoniesysteem',
    from_telephony_tooltip: 'Aangemaakt door de telefonie-integratie',
    action_call: 'Bellen',
    action_complete: 'Voltooien',
    action_reopen: 'Heropenen',
    action_open_lead: 'Open lead',
    completed_toast: 'Terugbelverzoek voltooid',
    reopened_toast: 'Terugbelverzoek heropend',
    action_failed: 'Actie mislukt',
    load_failed: 'Kon terugbellijst niet laden',
  },

  // Telefonie-integratie: gespreksverslag
  call_activity: {
    inbound_call: 'Inkomend gesprek',
    outbound_call: 'Uitgaand gesprek',
    call: 'Gesprek',
    summary: 'Samenvatting',
    action_items: 'Actiepunten',
    show_transcript: 'Transcript bekijken',
    hide_transcript: 'Transcript verbergen',
    listen_recording: 'Beluister opname',
    via_phone_system: 'via telefoniesysteem',
  },

  // Home (samenvatting / dagstart)
  home: {
    load_failed: 'Kon overzicht niet laden',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    no_due_date: 'Geen datum',
    just_now: 'Zojuist',
    minutes_ago: '{n} min geleden',
    hours_ago: '{n} uur geleden',
    days_ago: '{n} dagen geleden',
    greeting: {
      morning: 'Goedemorgen',
      afternoon: 'Goedemiddag',
      evening: 'Goedenavond',
      night: 'Goedenacht',
    },
    tasks: {
      title: 'Mijn taken',
      view_all: 'Alle taken',
      empty_title: 'Geen openstaande taken',
      empty_description: 'Je hebt geen taken die nog gedaan moeten worden.',
    },
    requests: {
      title: 'Nieuwe aanvragen',
      view_all: 'Alle aanvragen',
      empty_title: 'Geen nieuwe aanvragen',
      empty_description: 'Nieuwe aanvragen vanuit je funnels verschijnen hier.',
      untitled: 'Aanvraag',
    },
    proposals: {
      title: 'Openstaande offertes',
      view_all: 'Alle offertes',
      empty_title: 'Geen openstaande offertes',
      empty_description: 'Verstuurde of concept offertes verschijnen hier.',
      untitled: 'Offerte',
    },
    drafts: {
      title: 'Te versturen offertes',
      view_all: 'Alle offertes',
      empty_title: 'Geen concept offertes',
      empty_description: 'Offertes die nog verstuurd moeten worden verschijnen hier.',
      untitled: 'Offerte',
    },
    appointments: {
      title: 'Aankomende afspraken',
      view_all: 'Alle afspraken',
      empty_title: 'Geen aankomende afspraken',
      empty_description: 'Geplande afspraken voor deze week verschijnen hier.',
      untitled: 'Afspraak',
    },
    chat: {
      placeholder: 'Vraag iets over je workspace...',
      send: 'Versturen',
      send_failed: 'Bericht versturen mislukt',
      new_conversation: 'Nieuw gesprek',
      show_overview: 'Toon overzicht',
      hide_overview: 'Verberg overzicht',
      spike_notice: 'AI-assistent · acties moet je altijd zelf bevestigen.',
      suggestion_summary: 'Geef me een samenvatting van vandaag',
      suggestion_invoices: 'Hoeveel heb ik deze maand gefactureerd?',
      suggestion_proposals: 'Welke offertes lopen langer dan 5 dagen?',
      suggestion_today: 'Wat staat er vandaag op de planning?',
      action: {
        confirm: 'Bevestig',
        dismiss: 'Annuleer',
        confirmed: 'Uitgevoerd',
        expired: 'Deze actie is verlopen — vraag opnieuw',
        dismissed: 'Geannuleerd',
        failed: 'Uitvoeren mislukt',
        confirmed_toast: 'Actie uitgevoerd',
        confirm_failed: 'Actie kon niet worden uitgevoerd',
        expired_toast: 'Deze actie is verlopen — vraag de assistent opnieuw',
        tools: {
          create_task: 'Taak aanmaken',
          complete_task: 'Taak afronden',
          move_deal: 'Deal verplaatsen',
          send_invoice: 'Factuur versturen',
          generic: 'Voorgestelde actie',
        },
      },
      tool_result: {
        empty: 'Geen resultaten',
        unknown: 'Resultaat',
        truncated:
          'Het volledige resultaat was te groot om hier te tonen — vraag eventueel om een specifieker overzicht.',
        show_all: 'Toon alle ({n} extra)',
        stats_range: 'Periode: {from} t/m {to}',
        invoices: {
          label: 'Openstaande facturen',
          empty: 'Geen openstaande facturen — netjes!',
          view_all: 'Alle facturen',
        },
        tasks: {
          label: 'Openstaande taken',
          empty: 'Geen openstaande taken',
          view_all: 'Alle taken',
        },
        overdue_tasks: {
          label: 'Achterstallige taken',
        },
        submissions: {
          label: 'Recente aanvragen',
          empty: 'Nog geen nieuwe aanvragen',
          view_all: 'Alle aanvragen',
        },
        proposals: {
          label: 'Openstaande offertes',
          empty: 'Geen openstaande offertes',
          view_all: 'Alle offertes',
        },
        appointments: {
          label: 'Aankomende afspraken',
          empty: 'Geen aankomende afspraken',
          view_all: 'Alle afspraken',
        },
        leads: {
          label: 'Leads',
          empty: 'Geen leads gevonden',
          view_all: 'Naar CRM',
        },
        deals: {
          label: 'Deals',
          empty: 'Geen deals gevonden',
          view_all: 'Alle deals',
        },
        invoice_stats: {
          label: 'Facturatie',
          invoiced: 'Gefactureerd',
          paid: 'Ontvangen',
          outstanding: 'Openstaand',
          open: 'open',
        },
        deal_stats: {
          label: 'Pipeline',
          total: 'Totaal',
          won: 'Gewonnen',
          pipeline: 'Pipeline',
          open: 'open',
        },
      },
    },
  },

  tasks_view: {
    title: 'Taken',
    description:
      'Alle taken op één plek, met deal- of projectcontext en deadlines direct zichtbaar.',
    search_label: 'Zoeken',
    search_placeholder: 'Zoek op taaknaam...',
    status_label: 'Status',
    status_all: 'Alle statussen',
    status_pending: 'Openstaand',
    status_in_progress: 'In uitvoering',
    status_completed: 'Afgerond',
    status_cancelled: 'Geannuleerd',
    assigned_to_label: 'Toegewezen aan',
    assigned_to_all: 'Iedereen',
    select_all: 'Alle selecteren',
    reset_filters: 'Filters wissen',
    load_failed: 'Kon taken niet laden',
    empty_title: 'Geen taken gevonden',
    empty_description: 'Taken verschijnen hier zodra ze zijn aangemaakt.',
    empty_context_title: 'Nog geen open taken',
    empty_context_description: 'Maak een taak aan voor dit project.',
    no_due_date: 'Geen datum',
    unassigned: 'Niet toegewezen',
    assign_success: 'Taak toegewezen',
    assign_failed: 'Taak toewijzen mislukt',
    create_task: 'Taak',
    description_placeholder: 'Korte toelichting (optioneel)',
    help_deal: 'Deze taak hoort bij de deal (verkoop).',
    help_project: 'Deze taak hoort bij het project.',
    open_project_tasks: '{count} open taken op het project',
    home_deal: 'Deal',
    home_project: 'Project',
    home_work_order: 'Werkbon',
    home_general: 'Algemeen',
    home_label: 'Context',
    view_deal: 'Naar deal',
    view_work_order: 'Naar werkbon',
    view_lead: 'Naar klant',
    bulk_selected: '{count} geselecteerd',
    bulk_action_label: 'Bulkactie',
    bulk_action_placeholder: 'Kies actie',
    bulk_complete: 'Afronden',
    bulk_complete_success: 'Taken afgerond',
    bulk_assign: 'Toewijzen',
    bulk_assign_placeholder: 'Toewijzen aan...',
    bulk_assign_success: 'Taken toegewezen',
    bulk_button_complete: '{count} afronden',
    bulk_button_assign: '{count} toewijzen',
    bulk_button_delete: '{count} verwijderen',
    bulk_delete_success: 'Taken verwijderd',
    bulk_delete_confirm_title: 'Taken verwijderen?',
    bulk_delete_confirm_description:
      'Je staat op het punt om {count} geselecteerde taken te verwijderen. Dit kan niet ongedaan worden gemaakt.',
    bulk_action_failed: 'Bulkactie mislukt',
    fields: {
      name: 'Naam',
      description: 'Omschrijving',
      type: 'Type',
      due_date: 'Vervaldatum',
      due_time: 'Tijd',
      assigned_to: 'Toegewezen aan',
      priority: 'Prioriteit',
    },
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welkom terug',
    overview: 'Overzicht',
    recent_forms: 'Recente Formulieren',
    recent_submissions: 'Recente aanvragen',
    quick_actions: 'Snelle Acties',
    create_form: 'Formulier Maken',
    view_analytics: 'Analytics Bekijken',
    no_forms: 'Nog geen formulieren gemaakt',
    no_submissions: 'Nog geen aanvragen',
    insights_over_time: 'Inzichten over tijd',
    stats: {
      total_forms: 'Totaal Formulieren',
      total_submissions: 'Totaal aanvragen',
      conversion_rate: 'Conversieratio',
      avg_completion_time: 'Gem. Voltooiingstijd',
    },
  },

  // Forms
  forms: {
    title: 'Formulieren',
    create: 'Formulier Maken',
    edit: 'Bewerken',
    duplicate: 'Dupliceren',
    delete: 'Verwijderen',
    publish: 'Publiceren',
    unpublish: 'Depubliceren',
    preview: 'Voorbeeld',
    settings: 'Instellingen',
    submissions: 'Inzendingen',
    analytics: 'Analytics',
    status: {
      draft: 'Concept',
      published: 'Gepubliceerd',
      archived: 'Gearchiveerd',
    },
    empty_state: {
      title: 'Nog geen formulieren',
      description: 'Maak je eerste formulier om te beginnen',
      action: 'Formulier Maken',
    },
  },

  // Form Card
  form_card: {
    edit_funnel: 'Funnel bewerken',
    open_funnel_title: 'Funnel openen',
    open_funnel_description: 'Hoe wil je deze funnel openen?',
    open_normal: 'Normale funnel openen',
    open_normal_description: 'Open de funnel zoals je klanten hem zien',
    open_extended: 'Uitgebreide funnel openen',
    open_extended_description: 'Open de funnel in uitgebreide modus met interne opties en prijzen',
    type_configurator: 'Configurator',
    type_funnel: 'Funnel',
    copy_share_link: 'Deel link kopiëren',
    delete_funnel: 'Funnel verwijderen',
    delete_flow_title: 'Flow verwijderen',
    delete_flow_description:
      'Weet je zeker dat je deze flow wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    delete_blocked_by_bookings:
      'Deze funnel kan niet worden verwijderd omdat er nog afspraken aan gekoppeld zijn. Verwijder of annuleer eerst de afspraken.',
    share_link_copied: 'Deel link is gekopieerd naar het klembord',
  },

  // CRM
  crm: {
    title: 'CRM',
    description: 'Bekijk en beheer al je leads',
    table_view: 'Tabel weergave',
    pipeline_view: 'Pipeline weergave',
    lead_details: 'Lead details',
    lead_status_updated: 'Lead status bijgewerkt',
    lead_updated: 'Lead succesvol bijgewerkt',
    no_name_entered: 'Geen naam opgegeven',
    search_placeholder: 'Zoek op naam, adres, postcode, plaats, telefoon, e-mail...',
    statuses: {
      new: 'Nieuw',
      contacted: 'Gecontacteerd',
      introduction: 'Introductie',
      qualified: 'Gekwalificeerd',
      converted: 'Geconverteerd',
      lost: 'Verloren',
    },
    create_lead: {
      button: 'Lead toevoegen',
      title: 'Nieuwe lead aanmaken',
      edit_title: 'Klantgegevens bewerken',
      description: 'Voeg een nieuwe lead toe aan je CRM.',
      contact_info: 'Contactgegevens',
      name_placeholder: 'Bijv. Jan Jansen',
      email_placeholder: 'E-mailadres',
      phone_placeholder: 'Bijv. 06 12345678',
      address_placeholder: 'Straat, huisnummer, postcode, stad',
      save: 'Lead aanmaken',
      save_edit: 'Wijzigingen opslaan',
      success: 'Lead succesvol aangemaakt',
      update_success: 'Klantgegevens bijgewerkt',
      already_exists: 'Lead bestaat al',
      restored_from_archive: 'Lead opgehaald uit archief',
      error: 'Er is een fout opgetreden bij het aanmaken van de lead',
      update_error: 'Er is een fout opgetreden bij het bijwerken van de lead',
      customer_type_label: 'Type klant',
      customer_type_person_title: 'Particulier',
      customer_type_person_description: 'Een persoon zonder bedrijf.',
      customer_type_company_title: 'Zakelijk',
      customer_type_company_description: 'Een bedrijf of organisatie met KVK-nummer.',
      company_section: 'Bedrijfsgegevens',
      company_name: 'Bedrijfsnaam',
      company_name_placeholder: 'Bijv. ACME B.V.',
      kvk_number: 'KVK-nummer',
      kvk_number_placeholder: '12345678',
      kvk_number_help: 'NL: 8 cijfers, te vinden op kvk.nl.',
      vat_number: 'BTW-nummer',
      vat_number_placeholder: 'NL000000000B00',
      vat_number_help: 'Optioneel. Verplicht voor BTW-verlegd binnen de EU.',
      legal_form: 'Rechtsvorm',
      legal_form_placeholder: 'Selecteer rechtsvorm',
      legal_form_options: {
        bv: 'BV',
        nv: 'NV',
        vof: 'VOF',
        eenmanszaak: 'Eenmanszaak',
        stichting: 'Stichting',
        vereniging: 'Vereniging',
        cv: 'CV',
        maatschap: 'Maatschap',
        other: 'Anders',
      },
      vat_reverse_charge: 'BTW verleggen (B2B EU buitenland)',
      vat_reverse_charge_help:
        'Aanvinken voor zakelijke EU-klanten buiten Nederland waar BTW verlegd wordt.',
      billing_section: 'Afwijkende factuurgegevens',
      billing_section_help:
        'Optioneel — gebruik dit als facturen naar een ander adres of e-mail moeten dan de contactgegevens.',
      billing_email: 'Factuur e-mailadres',
      billing_email_placeholder: "facturatie{'@'}bedrijf.nl",
      billing_address: 'Factuuradres',
      show_billing: 'Afwijkende factuurgegevens toevoegen',
      hide_billing: 'Afwijkende factuurgegevens verbergen',
    },
  },

  // Quotes
  quotes: {
    title: 'Offertes',
    description: 'Bekijk en beheer al je offertes',
  },

  automations_page: {
    title: 'Automations',
    description: 'Automatiseer follow-ups, taken en integraties',
    add: 'Nieuwe automation',
    add_group: 'Groep toevoegen',
    empty_title: 'Nog geen automations',
    empty_description: 'Maak je eerste automation aan om workflows te automatiseren.',
    ungrouped: 'Ongegroepeerd',
    columns: {
      name: 'Naam',
      updated: 'Bijgewerkt',
      runs: 'Runs',
      succeeded: 'Gelukt',
      failed: 'Mislukt',
      status: 'Status',
    },
    status: {
      active: 'Actief',
      inactive: 'Inactief',
      draft: 'Draft',
    },
    group_name: 'Groepsnaam',
    group_placeholder: 'bijv. Offerte, Project, Nazorg',
    group_add: 'Groep toevoegen',
    group_edit: 'Groep bewerken',
    group_save: 'Wijzigingen opslaan',
    group_delete_title: 'Groep verwijderen?',
    group_delete_description:
      'Automations in "{name}" worden ongegroepeerd. Dit verwijdert de groep, niet de automations.',
    drop_hint: 'Sleep automations hierheen',
    new_in_group: 'Nieuwe automation',
    toggle_on: 'Aanzetten',
    toggle_off: 'Uitzetten',
    delete: 'Verwijderen',
    delete_title: 'Automation verwijderen?',
    delete_description:
      'Weet je zeker dat je "{name}" wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
    deleted: 'Automation verwijderd',
    delete_failed: 'Kon automation niet verwijderen',
    toggled_on: 'Automation geactiveerd',
    toggled_off: 'Automation gedeactiveerd',
    toggle_failed: 'Kon automation status niet bijwerken',
    group_created: 'Groep aangemaakt',
    group_updated: 'Groep bijgewerkt',
    group_deleted: 'Groep verwijderd',
    group_save_failed: 'Kon groep niet opslaan',
    group_delete_failed: 'Kon groep niet verwijderen',
    group_name_taken: 'Er bestaat al een groep met deze naam',
    reorder_failed: 'Kon volgorde niet opslaan',
    runs: 'Runs',
    run_status: {
      pending: 'In wachtrij',
      in_progress: 'Bezig',
      completed: 'Gelukt',
      failed: 'Mislukt',
      scheduled: 'Gepland',
    },
    no_runs: 'Deze automation heeft nog niet gedraaid.',
    run_error: 'Fout',
    run_deal: 'Deal',
    run_proposal: 'Offerte',
    run_submission: 'Inzending',
    run_steps: 'Stappen',
    run_selected: 'Geselecteerde run',
    run_clear: 'Wis selectie',
    save: 'Opslaan',
    active: 'Actief',
    back: 'Terug',
  },

  // Deals
  deals: {
    title: 'Deals',
    description: 'Beheer je sales pipeline en deals',
    untitled: 'Naamloze deal',
    add_deal: 'Deal toevoegen',
    export: 'Exporteren',
    export_success: 'Export gestart, het bestand wordt gedownload',
    export_failed: 'Exporteren mislukt',
    create_deal: 'Deal aanmaken',
    select_pipeline: 'Selecteer pipeline',
    search_placeholder: 'Zoek op naam, bedrag...',
    filter_owner_all: 'Alle eigenaren',
    filter_tags: 'Tags',
    filter_by_tags: 'Filter op tags',
    filter_no_tags: 'Geen tags beschikbaar',
    filter_reset: 'Wissen',
    filter_clear_all: 'Filters wissen',
    list_view: 'Lijst',
    kanban_view: 'Bord',
    statistics: 'Statistieken',
    open_statistics: 'Open statistieken',
    filter_owner: 'Eigenaar',
    activity_just_now: 'zojuist',
    activity_minutes_ago: '{count}m geleden',
    activity_hours_ago: '{count}u geleden',
    activity_days_ago: '{count}d geleden',
    age_minutes: '{count}m',
    age_hours: '{count}u',
    age_days: '{count}d',
    status_new_in_stage: 'Nieuw in fase',
    status_inactive: 'Inactief',
    status_proposal_viewed: 'Offerte bekeken',
    status_task_overdue: 'Taak verlopen',
    status_new_note: 'Nieuwe notitie',
    status_more_signals: '{count} meer meldingen',
    assign_owner: 'Eigenaar toewijzen',
    unassigned: 'Niet toegewezen',
    action_edit: 'Bewerken',
    action_select: 'Selecteren',
    stage_actions: 'Fase-acties',
    stage_deal_count: '{count} deals',
    stage_add_deal: 'Deal toevoegen',
    total_deals: 'Deals',
    total_value: 'Totale waarde',
    weighted_value: 'Gewogen waarde',
    selected_count: '{count} geselecteerd',
    bulk_move: 'Verplaatsen',
    bulk_move_to: 'Verplaats naar',
    bulk_move_success: 'Deals verplaatst',
    bulk_move_failed: 'Verplaatsen mislukt',
    bulk_archive: 'Archiveren',
    bulk_archive_success: 'Deals gearchiveerd',
    bulk_archive_failed: 'Archiveren mislukt',
    archive_column: 'Archief',
    archive_expand: 'Archief openen',
    archive_collapse: 'Archief inklappen',
    archive_empty: 'Geen gearchiveerde deals',
    archive_drop: 'Sleep een deal hierheen om te archiveren',
    no_pipelines_title: 'Geen pipelines',
    no_pipelines_description: 'Maak eerst een pipeline aan in de instellingen',
    create_pipeline: 'Pipeline aanmaken',
    no_deals_in_stage: 'Geen deals in deze fase',
    no_deals_filtered_title: 'Geen deals gevonden',
    no_deals_filtered_description: 'Pas de filters aan of wis ze om meer deals te zien.',
    in_stage: 'in fase',
    // Lead deals
    empty_state_lead: {
      title: 'Nog geen deals',
      description: 'Maak een deal aan om de voortgang van deze lead te volgen.',
    },
    show_more_activities: '+{count} meer activiteiten',
    deal_details: 'Deal details',
    stage_updated: 'Deal verplaatst',
    stage_update_failed: 'Verplaatsen mislukt',
    deal_created: 'Deal aangemaakt',
    deal_updated: 'Deal bijgewerkt',
    update_failed: 'Bijwerken mislukt',
    deal_deleted: 'Deal verwijderd',
    delete_failed: 'Verwijderen mislukt',
    delete_blocked_title: 'Deal kan niet worden verwijderd',
    delete_blocked_has_projects:
      'Aan deze deal is een project gekoppeld. Een deal met een project kun je niet verwijderen. Verwijder eerst het project, of zet de deal op verloren als hij niet doorgaat.',
    delete_blocked_has_project_named:
      'Aan deze deal is project {project} gekoppeld. Een deal met een project kun je niet verwijderen. Verwijder eerst het project, of zet de deal op verloren als hij niet doorgaat.',
    delete_confirm: 'Weet je zeker dat je deze deal wilt verwijderen?',
    no_deal_selected: 'Geen deal geselecteerd',
    select_deal_to_view: 'Selecteer een deal om details te bekijken',
    mark_won: 'Gewonnen',
    mark_lost: 'Verloren',
    reopen: 'Heropenen',
    create_project: 'Project aanmaken',
    deal_won: 'Deal gewonnen',
    deal_lost: 'Deal verloren',
    no_reason: 'Geen reden opgegeven',
    marked_as_won: 'Deal gemarkeerd als gewonnen',
    marked_as_lost: 'Deal gemarkeerd als verloren',
    mark_won_failed: 'Markeren als gewonnen mislukt',
    mark_lost_failed: 'Markeren als verloren mislukt',
    mark_won_confirm_title: 'Deal als gewonnen markeren',
    mark_won_confirm_proposals:
      'Er zijn {count} offerte(s) die nog niet geaccepteerd zijn. Wil je deze ook op geaccepteerd zetten?',
    mark_won_accept_proposals: 'Ja, accepteer en markeer als gewonnen',
    mark_won_skip_proposals: 'Nee, alleen deal gewonnen',
    enter_lost_reason: 'Voer een reden in voor het verliezen van deze deal (optioneel)',
    deal_reopened: 'Deal heropend',
    reopen_failed: 'Heropenen mislukt',
    won: 'Gewonnen',
    lost: 'Verloren',
    deal_value: 'Deal waarde',
    contact: 'Contact',
    lead: 'Lead',
    owner: 'Eigenaar',
    expected_close_date: 'Verwachte sluiting',
    pipeline: 'Pipeline',
    stage: 'Fase',
    select_stage: 'Selecteer fase',
    select_contact: 'Selecteer contact',
    select_lead: 'Selecteer lead',
    contact_help: 'Optioneel - koppel een bestaande lead',
    lead_help: 'Elke deal moet aan een lead gekoppeld zijn',
    select_owner: 'Selecteer eigenaar',
    title_placeholder: 'Bijv. Zonnepanelen Familie Jansen',
    title_required: 'Titel is verplicht',
    lead_required: 'Lead is verplicht',
    pipeline_required: 'Pipeline is verplicht',
    stage_required: 'Fase is verplicht',
    value: 'Waarde',
    value_placeholder: '0',
    internal_notes: 'Interne notities',
    internal_notes_placeholder: 'Notities voor intern gebruik...',
    danger_zone: 'Gevaarlijke acties',
    delete_deal: 'Deal verwijderen',
    tabs: {
      details: 'Details',
      submissions: 'Aanvragen',
      proposals: 'Offertes',
      documents: 'Documenten',
      activities: 'Activiteiten',
      activity: 'Activiteit',
      tasks: 'Taken',
      form_links: 'Nieuwe offerte',
      project: 'Project',
      settings: 'Instellingen',
    },
    project_cancelled_with_deal: 'Het project is geannuleerd omdat de deal verloren is.',
    settings: {
      general: 'Algemeen',
      notes: 'Notities',
      deal_details: 'Dealgegevens',
      deal_name: 'Naam van de deal',
      source_locked: 'Automatisch ingevuld door de funnel',
      merge_description: 'Voor dubbele aanvragen van dezelfde klant',
      delete_description: 'Offertes en activiteit van deze deal gaan mee weg',
    },
    tags: {
      label: 'Tags',
      add: 'Tag',
      add_first: 'Tag toevoegen',
      search_placeholder: 'Zoek tags...',
      no_tags: 'Nog geen tags',
      create: 'Aanmaken',
      create_placeholder: 'Nieuwe tag...',
      create_failed: 'Tag aanmaken mislukt',
      update_failed: 'Tags bijwerken mislukt',
    },
    source_placeholder: 'Bijv. Website, LinkedIn, Referral...',
    danger_zone_description:
      'Het verwijderen van deze deal is permanent en kan niet ongedaan worden gemaakt.',
    no_submissions: 'Geen aanvragen voor deze deal',
    no_proposals: 'Geen offertes voor deze deal',
    form_name: 'Formulier',
    contact_name: 'Contact',
    total_price: 'Totaalprijs',
    created_at: 'Aangemaakt op',
    // Activities
    activities: 'Activiteiten',
    log_activity: 'Activiteit loggen',
    no_activities: 'Geen activiteiten',
    activity_type: 'Type',
    activity_subject: 'Onderwerp',
    activity_subject_placeholder: 'Bijv. Eerste telefonisch contact',
    activity_description: 'Beschrijving',
    activity_description_placeholder: 'Optionele details...',
    activity_outcome: 'Uitkomst',
    save_activity: 'Opslaan',
    activity_logged: 'Activiteit gelogd',
    activity_log_failed: 'Loggen mislukt',
    activity_deleted: 'Activiteit verwijderd',
    activity_delete_failed: 'Verwijderen mislukt',
    delete_activity_confirm: 'Weet je zeker dat je deze activiteit wilt verwijderen?',
    auto_generated: 'Automatisch gegenereerd',
    mail_inbox: 'Klantmail',
    mail_compose: 'Mail sturen',
    mail_reply: 'Beantwoorden',
    mail_view: 'Bekijken',
    mail_send: 'Versturen',
    mail_sent: 'Mail verstuurd',
    mail_send_failed: 'Versturen mislukt',
    mail_subject: 'Onderwerp',
    mail_to: 'Aan',
    mail_body: 'Bericht',
    mail_no_subject: '(geen onderwerp)',
    mail_bounced: 'Niet bezorgd',
    mail_thread_empty: 'Geen berichten in deze conversatie',
    mail_thread_empty_description: 'Deze mailconversatie kon niet worden geladen.',
    mail_thread_no_body: '(geen tekst)',
    mail_photo: 'Foto',
    mail_attachment: 'Bijlage',
    mail_thread_load_failed: 'Mail kon niet worden geladen',
    mail_inbox_needs_reply: 'Te beantwoorden',
    mail_inbox_unmatched: 'Ongekoppeld',
    mail_inbox_empty: 'Geen mails',
    mail_inbox_empty_needs_reply: 'Geen openstaande klantmails.',
    mail_inbox_empty_unmatched: 'Alle inkomende mails zijn aan een deal gekoppeld.',
    mail_inbox_load_failed: 'Inbox kon niet worden geladen',
    mail_unknown_sender: 'Onbekende afzender',
    mail_search_deal: 'Zoek deal om te koppelen…',
    mail_linked: 'Mail gekoppeld aan deal',
    mail_link_failed: 'Koppelen mislukt',
    activity_types: {
      call: 'Telefoontje',
      email: 'E-mail',
      whatsapp: 'WhatsApp',
      note: 'Notitie',
      meeting: 'Meeting',
    },
    outcomes: {
      positive: 'Positief',
      neutral: 'Neutraal',
      negative: 'Negatief',
      no_answer: 'Geen antwoord',
    },
    system: 'Systeem',
    add_note_placeholder: 'Notitie toevoegen of activiteit loggen...',
    quick_types: {
      note: 'Notitie',
      call: 'Gebeld',
      email: 'E-mail',
      meeting: 'Afspraak',
    },
    timeline: {
      stage_to: 'Naar {stage}',
      stage_from: 'van {stage}',
      stage_placed: 'Geplaatst in fase',
      created_via: 'via {source}',
      view_submission: 'Bekijk inzending',
      just_now: 'Zojuist',
      minutes_ago: '{count} min geleden',
      one_hour_ago: '1 uur geleden',
      hours_ago: '{count} uur geleden',
      one_day_ago: '1 dag geleden',
      days_ago: '{count} dagen geleden',
      source: {
        configurator: 'Configurator',
        form_submission: 'Formulier',
        manual: 'handmatig',
        import: 'import',
        merge: 'samenvoegen',
      },
    },
    // Form Links
    form_links: 'Formulierlinks',
    form_links_description:
      'Genereer unieke links naar formulieren die automatisch aan deze deal worden gekoppeld',
    create_form_link: 'Link genereren',
    no_form_links: 'Geen formulierlinks',
    select_form: 'Selecteer formulier',
    select_form_placeholder: 'Kies een formulier...',
    prefill_contact_data: 'Contactgegevens voorinvullen',
    prefill_contact_help: 'Vult automatisch bekende gegevens van de contactpersoon in',
    generate_link: 'Genereer link',
    link_generated: 'Link gegenereerd',
    link_generated_description: 'Kopieer de link en deel deze met je klant:',
    open_link: 'Openen',
    prefill_enabled: 'Voorinvullen',
    times_used: '{count}x gebruikt',
    last_used: 'Laatst gebruikt: {time}',
    expires: 'Verloopt: {date}',
    create_link_failed: 'Link genereren mislukt',
    delete_link_confirm: 'Weet je zeker dat je deze link wilt verwijderen?',
    link_deleted: 'Link verwijderd',
    delete_link_failed: 'Verwijderen mislukt',
    // Configurators
    create_proposal: 'Offerte maken',
    create_proposal_description:
      'Open een configurator om een nieuwe offerte te maken voor deze deal',
    no_configurators: 'Geen configurators beschikbaar',
    configurator: 'Configurator',
    open_configurator: 'Openen',
    // New proposal button
    new_proposal: 'Nieuwe offerte',
    no_configurator_forms_hint: 'Maak eerst een configurator formulier aan',
    create_proposal_hint: 'Maak een nieuwe offerte via de knop hierboven',
    proposal_locked_title: 'Deze deal heeft al een geaccepteerde offerte',
    proposal_locked_description:
      'Maak voor een nieuwe aanvraag een nieuwe deal aan, zodat de omzet van beide opdrachten behouden blijft. Wil je de bestaande offerte vervangen? Trek deze dan eerst in.',
    proposal_locked_create_deal: 'Nieuwe deal aanmaken',
    proposal_count_one: '1 offerte bij deze deal',
    proposal_count_other: '{count} offertes bij deze deal',
    proposal_hints: {
      draft: 'Deze offerte staat nog in concept. Verstuur hem naar de klant zodra hij klopt.',
      sent: 'De offerte ligt bij de klant. Blijft het stil, volg hem dan op.',
      accepted: 'De offerte is geaccepteerd. Ga verder in het tabblad Project.',
      rejected:
        'Er loopt geen offerte meer. Maak een nieuwe offerte of markeer de deal als verloren.',
      proforma_draft:
        'Deze pro forma staat nog in concept. Verstuur hem naar de klant; na akkoord plan je de inmeting en maak je de definitieve offerte.',
      proforma_sent:
        'De pro forma ligt bij de klant. Zodra hij akkoord geeft, plan je de inmeting in.',
      proforma_accepted:
        'De pro forma is akkoord. Plan de inmeting en maak daarna de definitieve offerte.',
      definitive_draft:
        'De definitieve offerte staat nog in concept. Verstuur hem naar de klant; die vervangt de pro forma.',
      definitive_sent:
        'De definitieve offerte ligt bij de klant. Blijft het stil, volg hem dan op.',
    },
    // Tasks
    new_task: 'Nieuwe taak',
    task_placeholder: 'Wat moet er gebeuren?',
    no_tasks: 'Geen taken',
    task_created: 'Taak aangemaakt',
    task_create_failed: 'Taak aanmaken mislukt',
    task_completed: 'Taak afgerond',
    task_reopened: 'Taak heropend',
    task_update_failed: 'Taak bijwerken mislukt',
    completed_tasks: 'Afgeronde taken',
    overdue_tasks: 'Verlopen',
    today_tasks: 'Vandaag',
    upcoming_tasks: 'Aankomend',
    completed_by: 'Afgerond door',
    priority_high: 'Hoog',
    priority_medium: 'Medium',
    priority_low: 'Laag',
    task_type_general: 'Algemeen',
    task_type_callback: 'Terugbelverzoek',
    task_type_follow_up: 'Follow-up',
    task_ui: {
      quick_add_placeholder: 'Nieuwe taak, bijv. terugbellen over de offerte',
      add: 'Toevoegen',
      me: 'Mij',
      today: 'Vandaag',
      tomorrow: 'Morgen',
      in_three_days: 'Over 3 dagen',
      next_week: 'Volgende week',
      pick_date: 'Kies datum',
      more_options: 'Meer opties',
      empty_title: 'Nog geen taken voor deze deal',
      empty_description:
        'Plan een opvolging, zodat de deal niet stil komt te staan. Een taak verschijnt ook op het homescherm van de collega aan wie je hem toewijst.',
      quick_callback: 'Morgen terugbellen',
      quick_callback_title: 'Terugbellen',
      quick_follow_up: 'Offerte opvolgen over 3 dagen',
      quick_follow_up_title: 'Offerte opvolgen',
      created_by: 'Aangemaakt door {name}',
      created_at: 'Aangemaakt op {date}',
      unknown_user: 'onbekend',
      open_customer: 'Klantkaart openen',
      save: 'Opslaan',
      saved: 'Taak bijgewerkt',
      no_description: 'Geen aanvullende informatie',
      description_placeholder: 'Aanvullende informatie, afspraken of context…',
    },
    customer_history: {
      tab: 'Klant',
      open_card: 'Klantkaart openen',
      customer_since: 'Klant sinds {date}',
      requests: 'Aanvragen',
      no_requests: 'Nog geen aanvragen van deze klant',
      deals: 'Deals van deze klant',
      no_other_deals: 'Geen andere deals voor deze klant',
      current_deal: 'Deze deal',
      no_customer: 'Deze deal is niet aan een klant gekoppeld.',
      unknown_form: 'Onbekend formulier',
      load_failed: 'Klanthistorie laden mislukt',
    },
    // Drawer
    no_industry: 'Geen branche',
    untitled_deal: 'Naamloze deal',
    expected_date: 'Verwacht',
    in_pipeline: 'In pipeline',
    days: 'dagen',
    source: 'Bron',
    unknown_source: 'Onbekende bron',
    call: 'Bellen',
    email: 'E-mail',
    schedule: 'Plannen',
    schedule_coming_soon: 'Planning functie binnenkort beschikbaar',
    note: 'Notitie',
    task: 'Taak',
    assign: 'Toewijzen',
    days_in_stage: '{count}d in fase',
    previous_deal: 'Vorige deal',
    next_deal: 'Volgende deal',
    more_actions: 'Meer acties',
    move_to_next_stage: 'Naar {stage}',
    move_to_stage: 'Verplaats naar fase',
    choose_stage: 'Kies een fase',
    current: 'huidig',
    added_to_favorites: 'Toegevoegd aan favorieten',
    removed_from_favorites: 'Verwijderd uit favorieten',
    favorite_failed: 'Favoriet bijwerken mislukt',
    // Merge
    merge_deals: 'Deals samenvoegen',
    merge_deals_description:
      'Selecteer deals die je wilt samenvoegen met deze deal. Alle activiteiten, taken, aanvragen en offertes worden overgenomen.',
    search_deals_placeholder: 'Zoek op naam, e-mail of bedrag...',
    no_deals_found: 'Geen deals gevonden',
    selected_deals: '{count} deal(s) geselecteerd',
    merge: 'Samenvoegen',
    merge_confirm_title: 'Deals samenvoegen?',
    merge_confirm_description:
      'De geselecteerde deals worden samengevoegd met deze deal. Dit kan niet ongedaan worden gemaakt.',
    merge_success: 'Deals succesvol samengevoegd',
    merge_failed: 'Samenvoegen mislukt',
    // Experimental banner
    experimental_banner_title: 'Experimentele feature',
    experimental_banner_message:
      'Deze functie is nieuw en nog in ontwikkeling. We werken hard om deze te verbeteren!',
  },

  // Settings - Pipelines
  pipelines: {
    title: 'Pipelines',
    description: 'Beheer je sales pipelines en fases',
    create_pipeline: 'Pipeline aanmaken',
    create_pipeline_description: 'Maak een nieuwe sales pipeline met aangepaste fases',
    edit_pipeline: 'Pipeline bewerken',
    edit_pipeline_description: 'Werk pipeline naam en beschrijving bij',
    delete_pipeline: 'Pipeline verwijderen',
    name: 'Naam',
    name_placeholder: 'Bijv. Standaard Pipeline',
    description_label: 'Beschrijving',
    description_placeholder: 'Optionele beschrijving...',
    default: 'Standaard',
    set_as_default: 'Instellen als standaard',
    stages: 'fases',
    pipeline_created: 'Pipeline aangemaakt',
    pipeline_updated: 'Pipeline bijgewerkt',
    pipeline_deleted: 'Pipeline verwijderd',
    save_failed: 'Opslaan mislukt',
    default_set: 'Standaard pipeline ingesteld',
    default_failed: 'Instellen als standaard mislukt',
    delete_confirm: 'Weet je zeker dat je deze pipeline wilt verwijderen?',
    delete_failed: 'Verwijderen mislukt',
    add_stage: 'Fase toevoegen',
    add_stage_description: 'Maak een nieuwe fase in deze pipeline',
    edit_stage: 'Fase bewerken',
    edit_stage_description: 'Werk fase instellingen en eigenschappen bij',
    delete_stage: 'Fase verwijderen',
    stage_name: 'Fase naam',
    stage_name_placeholder: 'Bijv. Onderhandeling',
    color: 'Kleur',
    probability: 'Kans',
    auto_trigger: 'Automatische trigger',
    no_auto_trigger: 'Geen automatische trigger',
    trigger_proposal_sent: 'Offerte verstuurd',
    trigger_proforma_sent: 'Voorlopige offerte verstuurd',
    trigger_proforma_accepted: 'Voorlopige offerte geaccepteerd',
    trigger_proposal_accepted: 'Offerte geaccepteerd',
    trigger_proposal_rejected: 'Offerte afgewezen',
    auto_trigger_help: 'Deal wordt automatisch naar deze fase verplaatst bij dit event',
    is_won_stage: 'Dit is de "Gewonnen" fase',
    is_lost_stage: 'Dit is de "Verloren" fase',
    won_stage: 'Gewonnen',
    lost_stage: 'Verloren',
    stage_created: 'Fase aangemaakt',
    stage_updated: 'Fase bijgewerkt',
    stage_deleted: 'Fase verwijderd',
    stage_save_failed: 'Opslaan mislukt',
    delete_stage_confirm: 'Weet je zeker dat je deze fase wilt verwijderen?',
    stage_delete_failed: 'Verwijderen mislukt',
    stages_reordered: 'Fases opnieuw geordend',
    reorder_failed: 'Herschikken fases mislukt',
  },

  // Discounts (period campaigns)
  discounts: {
    title: 'Kortingen',
    description: 'Stel tijdelijke kortingen in op producten of categorieën.',
    overview: 'Kortingen overzicht',
    create: 'Korting aanmaken',
    create_title: 'Nieuwe korting',
    edit_title: 'Korting bewerken',
    search_placeholder: 'Zoek kortingen...',
    empty_title: 'Nog geen kortingen',
    empty_description: 'Maak een periode-korting aan voor producten, categorieën of alles.',
    load_failed: 'Kortingen laden mislukt',
    created: 'Korting aangemaakt',
    updated: 'Korting bijgewerkt',
    deleted: 'Korting verwijderd',
    delete_failed: 'Korting verwijderen mislukt',
    delete_title: 'Korting verwijderen?',
    delete_description: 'Weet je zeker dat je “{title}” wilt verwijderen?',
    columns: {
      title: 'Titel',
      status: 'Status',
      method: 'Methode',
      scope: 'Bereik',
      type: 'Type',
      period: 'Looptijd',
      uses: 'Gebruikt',
    },
    status: {
      active: 'Actief',
      scheduled: 'Gepland',
      expired: 'Verlopen',
      disabled: 'Gepauzeerd',
    },
    method: {
      automatic: 'Automatisch',
      code: 'Kortingscode',
    },
    type: {
      percentage: 'Percentage',
      fixed: 'Vast bedrag',
    },
    scope: {
      all: 'Alle producten',
      categories: '{n} categorieën',
      products: '{n} producten',
    },
    period: {
      open: 'Geen einddatum',
      from: 'Vanaf {date}',
      until: 'Tot {date}',
    },
    summary: {
      percentage: '{value}% korting',
      percentage_capped: '{value}% korting (max €{max})',
      fixed: '€{value} korting',
    },
    form: {
      title: 'Titel',
      title_placeholder: 'Bijv. Zomeractie 15%',
      method: 'Methode',
      method_automatic: 'Automatisch',
      method_code: 'Kortingscode',
      code: 'Kortingscode',
      code_placeholder: 'Bijv. ZOMER10',
      code_hint: 'Klanten vullen deze code in bij de offerte. Letters, cijfers en koppeltekens.',
      type: 'Type',
      type_percentage: 'Percentage',
      type_fixed: 'Vast bedrag (€)',
      value_percentage: 'Percentage',
      value_fixed: 'Bedrag (€)',
      max_amount: 'Maximum kortingsbedrag (€)',
      max_amount_placeholder: 'Bijv. 250',
      max_amount_hint: 'Optioneel. Bij een percentage nooit meer dan dit bedrag per product.',
      scope: 'Geldt voor',
      scope_all: 'Alle producten',
      scope_categories: 'Categorieën',
      scope_products: 'Specifieke producten',
      categories: 'Categorieën',
      products: 'Producten',
      select_categories: 'Selecteer categorieën...',
      select_products: 'Selecteer producten...',
      search_categories: 'Zoek categorieën',
      search_products: 'Zoek producten',
      starts_at: 'Startdatum',
      ends_at: 'Einddatum',
      period_hint:
        'Laat beide leeg om de korting direct te laten lopen zonder einddatum. Alleen startdatum = gepland. Alleen einddatum = actief tot die datum.',
      is_active: 'Actief',
      show_badge: 'Toon kortingsbadge in configurator',
      create: 'Aanmaken',
      save: 'Opslaan',
      errors: {
        title_required: 'Titel is verplicht',
        value_invalid: 'Voer een geldige waarde in',
        max_amount_invalid: 'Voer een bedrag groter dan 0 in, of laat het leeg',
        code_invalid: 'Gebruik 2–32 letters, cijfers of koppeltekens',
        code_taken: 'Deze code bestaat al',
        categories_required: 'Selecteer minstens één categorie',
        products_required: 'Selecteer minstens één product',
        save_failed: 'Opslaan mislukt',
      },
    },
  },

  // Products
  products: {
    add_product: 'Product toevoegen',
    units: {
      none: 'Geen eenheid',
      piece: 'Stuks',
      pair: 'Paar',
      meter: 'Meter',
      square_meter: 'Vierkante meter (m²)',
    },
    units_short: {
      piece: 'st',
      pair: 'paar',
      meter: 'm',
      square_meter: 'm²',
    },
    search: {
      placeholder: 'Zoek op naam of code…',
      no_results: 'Geen producten gevonden',
      min_chars: 'Typ minimaal 2 tekens',
      error: 'Zoeken is mislukt',
    },
    import: {
      button: 'Importeren',
      title: 'Producten importeren',
      steps_label: 'Importstappen',
      step_upload: 'Bestand',
      step_map: 'Kolommen',
      step_preview: 'Controle',
      choose_file: 'Kies CSV of Excel',
      drop_hint: 'Of sleep het bestand hierheen.',
      download_template: 'Download sjabloon',
      change_file: 'Ander bestand',
      row_count: '{n} rijen',
      mapped_count: '{mapped} van {total} kolommen gekoppeld',
      map_column: 'Koppel kolom {column}',
      no_sample: 'Geen voorbeeld',
      skip_column: 'Niet importeren',
      existing_products: 'Als het product al in deze feed staat',
      match_by: 'Herkennen via',
      match_none: 'Niet herkennen',
      match_sku: 'SKU',
      match_title: 'Titel',
      on_duplicate: 'Bij een match',
      duplicate_skip: 'Overslaan',
      duplicate_update: 'Bijwerken',
      duplicate_create: 'Toch nieuw maken',
      create_missing_categories: 'Nieuwe categorieën aanmaken',
      preview: 'Controleren',
      preview_loading: 'Controle voorbereiden…',
      confirm: 'Importeren',
      back: 'Terug',
      close: 'Sluiten',
      summary: '{created} nieuw, {updated} bijwerken, {skipped} overslaan',
      summary_done: '{created} nieuw, {updated} bijgewerkt, {skipped} overgeslagen',
      summary_errors: '{n} rijen met een fout',
      created: 'Nieuw',
      updated: 'Bijgewerkt',
      skipped: 'Overgeslagen',
      errors: 'Fouten',
      row: 'Rij',
      action: 'Actie',
      status: 'Status',
      preview_truncated: 'Eerste 50 van {n} rijen',
      error_too_large: 'Het bestand is groter dan 5 MB.',
      error_unsupported: 'Gebruik een CSV- of Excel-bestand.',
      error_empty: 'Het bestand bevat geen rijen.',
      error_parse: 'Het bestand kon niet worden gelezen.',
      error_title_required: 'Koppel een kolom aan Titel.',
      error_duplicate_fields: 'Elk productveld mag maar één kolom hebben.',
      error_preview: 'Controle laden is mislukt.',
      error_import: 'Importeren is mislukt.',
      empty_title: 'Nog geen producten',
      empty_description: 'Voeg een product toe of importeer een CSV of Excel-bestand.',
      actions: {
        create: 'Nieuw',
        update: 'Bijwerken',
        skip: 'Overslaan',
        error: 'Fout',
      },
      fields: {
        title: 'Titel',
        description: 'Beschrijving',
        url: 'URL',
        image_url: 'Afbeelding-URL',
        price: 'Prijs',
        sale_price: 'Actieprijs',
        base_sku: 'SKU',
        label: 'Label',
        production_notes: 'Productienotities',
        proposal_notes: 'Offertenotities',
        standard_hours: 'Normuren',
        unit: 'Eenheid',
        usps: 'USPs',
        categories: 'Categorieën',
        vat_rate: 'BTW-tarief',
        target_margin_pct: 'Doelmarge %',
        min_margin_pct: 'Minimummarge %',
        prices_include_vat: 'Prijs inclusief BTW',
        position: 'Positie',
      },
      success: '{created} nieuw, {updated} bijgewerkt',
    },
    product_feeds: 'Product feeds',
    product_feeds_description: 'Bekijk en beheer al je product feeds',
    product_feed_description: 'Bekijk en beheer al je producten in deze feed',
    add_feed: 'Feed toevoegen',
    product_feeds_overview: 'Product feeds overzicht',
    feed_name: 'Feed naam',
    feed_description: 'Feed beschrijving',
    load_more: 'Meer laden',
    remaining: 'over',
    copy_options: {
      button: 'Optie kopiëren',
      title: 'Opties kopiëren van product',
      intro:
        "Kies een product en selecteer opties of hele groepen om te kopiëren. Er worden nieuwe ID's aangemaakt; daarna kun je ze hier los bewerken.",
      source_product: 'Bronproduct',
      source_product_placeholder: 'Selecteer een product…',
      loading: 'Opties laden…',
      no_options: 'Dit product heeft geen opties.',
      select_all: 'Alles selecteren',
      clear_selection: 'Selectie wissen',
      selected_count: '{n} geselecteerd',
      choice_count: '{n} keuzes',
      ungrouped: 'Zonder groep',
      submit: 'Kopieer ({n})',
      success: '{n} optie(s) gekopieerd',
    },
    supplier_mapping_statuses: {
      not_mapped: 'Niet gemapt',
      mapped: 'Gemapt',
      partial: 'Deels gemapt',
    },
    supplier_mapping: {
      save_success: 'Leveranciermapping opgeslagen',
      save_failed: 'Opslaan van leveranciermapping mislukt',
    },
    pricing_rules: {
      title: 'Geavanceerde Prijsregels',
      description: 'Configureer complexe prijsberekeningen voor je configurator',
      templates: 'Regel Templates',
      active_rules: 'Actieve Regels',
      no_rules: 'Nog geen prijsregels',
      no_rules_description: 'Voeg prijsregels toe om geavanceerde berekeningen mogelijk te maken',
      add_first_rule: 'Eerste Regel Toevoegen',
      add_rule: 'Regel Toevoegen',
      conditions: 'Voorwaarden',
      pricing: 'Prijsstelling',
      preview: 'Prijs Voorbeeld',
      total: 'Totaal',
      templates: {
        matrix: 'Matrix Prijsstelling',
        matrix_desc: 'Breedte × Hoogte berekeningen (€/m²)',
        tiered: 'Staffel Prijsstelling',
        tiered_desc: 'Volume kortingen en staffels',
        bundle: 'Bundel Prijsstelling',
        bundle_desc: 'Combinatie kortingen',
        formula: 'Formule Prijsstelling',
        formula_desc: 'Aangepaste berekeningsformules',
      },
      types: {
        matrix: 'Matrix',
        tiered: 'Staffel',
        bundle: 'Bundel',
        formula: 'Formule',
        fixed: 'Vast Bedrag',
        percentage: 'Percentage',
      },
    },
  },

  email_preview: {
    title: 'Dit ontvangt de klant',
    description:
      'Controleer de e-mail en bijlagen zoals de klant ze ontvangt voordat je verstuurt.',
    from: 'Van',
    to: 'Aan',
    bcc: 'BCC',
    reply_to: 'Antwoorden naar',
    subject: 'Onderwerp',
    attachments: 'Bijlagen',
    no_attachments: 'Geen bijlagen',
    layout_unavailable:
      'De volledige e-mailopmaak kon niet worden geladen; hieronder zie je alleen de inhoud.',
    back: 'Terug naar bewerken',
    send: 'Versturen',
  },

  // Proposals
  proposals: {
    title: 'Offertes',
    stats_toggle: 'Statistieken',
    add_proposal: 'Offerte toevoegen',
    number: 'Nummer',
    title_field: 'Titel',
    status: 'Status',
    total_amount: 'Bedrag (excl.)',
    contact: 'Contact',
    created_at: 'Aangemaakt op',
    valid_until: 'Geldig tot',
    actions: 'Acties',
    edit: 'Bewerken',
    duplicate: 'Dupliceren',
    send: 'Versturen',
    delete: 'Verwijderen',
    view: 'Bekijken',
    resend: 'Opnieuw versturen',
    untitled: 'Naamloze offerte',
    default_title: 'Offerte',
    // Statistieken
    stats: {
      total_sent: 'Totaal verstuurd',
      pending: 'Openstaand',
      accepted: 'Geaccepteerd',
      rejected: 'Afgewezen',
      conversion_rate: 'Conversie',
      reject_reasons: 'Afwijsredenen',
      ytd_total: 'Dit jaar',
      total_value: 'Totale waarde',
      proposal_singular: 'offerte',
      proposal_plural: 'offertes',
      proposals_label: 'offertes',
    },
    create_new_proposal: 'Nieuwe offerte maken',
    create_new_proposal_lead: 'Maak een nieuwe offerte voor deze lead.',
    create_new_proposal_general: 'Maak een nieuwe offerte.',
    open_configurator_title: 'Configurator openen',
    open_configurator_description: 'Hoe wil je de configurator openen voor deze offerte?',
    open_standard: 'Standaard',
    open_standard_description: 'Open zoals de klant het ziet',
    open_extended: 'Uitgebreid',
    open_extended_description: 'Interne opties en prijzen zichtbaar',
    open_stage_preliminary: 'Voorlopig',
    open_stage_preliminary_description:
      'Nog niet ingemeten, bijv. in de showroom. Offerte onder voorbehoud van inmeting.',
    open_stage_definitive: 'Definitief',
    open_stage_definitive_description: 'Ingemeten, met exacte maten. De offerte wordt definitief.',
    open_extended_keeps_preliminary_description:
      'Interne opties en prijzen zichtbaar. De offerte blijft voorlopig.',
    edit_proposal: 'Offerte bewerken',
    edit_proposal_description: 'Bewerk deze offerte.',
    duplicate_proposal: 'Offerte dupliceren',
    duplicate_proposal_description:
      'Maak een variant van deze offerte op dezelfde deal (vergelijkingsoptie). ' +
      'Alleen bij een al gewonnen deal wordt een nieuwe deal aangemaakt. ' +
      'Voor een nieuwe opdracht bij dezelfde klant: maak een nieuwe offerte/deal.',
    duplicate_for_lead: 'Dupliceren voor',
    copy_suffix: '(Kopie)',
    view_proposal: 'Offerte bekijken',
    view_proposal_description: 'Bekijk deze offerte.',
    delete_proposal: 'Offerte verwijderen',
    delete_proposal_confirmation:
      'Weet je zeker dat je deze offerte wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    proposal_duplicated: 'Offerte succesvol gedupliceerd',
    proposal_deleted: 'Offerte verwijderd',
    error_duplicating: 'Fout bij dupliceren van offerte',
    error_deleting: 'Fout bij verwijderen van offerte',
    // Withdraw proposal
    withdraw: 'Intrekken',
    withdraw_proposal: 'Offerte intrekken',
    withdraw_proposal_confirmation:
      'Weet je zeker dat je deze offerte wilt intrekken? De offerte wordt niet meer actief en krijgt de status "ingetrokken".',
    withdraw_reason_label: 'Reden voor intrekking (optioneel)',
    withdraw_reason_placeholder: 'Bijv: Prijzen aangepast, offerte niet meer actueel...',
    proposal_withdrawn: 'Offerte succesvol ingetrokken',
    error_withdrawing: 'Fout bij intrekken van offerte',
    // Reject proposal
    reject: 'Afwijzen',
    reject_proposal: 'Offerte afwijzen',
    reject_proposal_confirmation:
      'Weet je zeker dat je deze offerte wilt afwijzen? De offerte krijgt de status "afgewezen".',
    reject_reason_label: 'Reden voor afwijzing',
    reject_reason_placeholder: 'Bijv: Klant heeft ander aanbod gekozen...',
    reject_reason_note_label: 'Toelichting (optioneel)',
    reject_reason_note_placeholder: 'Eventuele extra toelichting...',
    reject_reason_required: 'Kies een reden',
    reject_reasons: {
      too_expensive: 'Te duur',
      other_quote: 'Andere offerte',
      other_provider: 'Andere aanbieder',
      postponed: 'Project uitgesteld',
      not_a_fit: 'Aanbod past niet',
      lead_time: 'Levertijd te lang',
      other: 'Anders',
      unknown: 'Geen reden',
    },
    proposal_rejected: 'Offerte succesvol afgewezen',
    error_rejecting: 'Fout bij afwijzen van offerte',
    // Restore proposal
    restore: 'Herstellen',
    restore_proposal: 'Offerte herstellen',
    restore_proposal_confirmation:
      'Weet je zeker dat je deze offerte wilt herstellen? De offerte wordt weer actief met de status "verzonden".',
    proposal_restored: 'Offerte succesvol hersteld',
    error_restoring: 'Fout bij herstellen van offerte',
    restore_to_sent: 'Terugzetten naar verzonden',
    restore_to_sent_confirmation:
      'Weet je zeker dat je deze offerte terug wilt zetten naar "verzonden"? De huidige status wordt ongedaan gemaakt.',
    restore_to_sent_from_accepted_confirmation:
      'Weet je zeker dat je deze geaccepteerde offerte terug wilt zetten naar "verzonden"?',
    proposal_restored_to_sent: 'Offerte teruggezet naar verzonden',
    error_restoring_to_sent: 'Fout bij terugzetten naar verzonden',
    // Mark as accepted/rejected
    mark_accepted: 'Markeer als geaccepteerd',
    mark_rejected: 'Markeer als afgewezen',
    mark_accepted_title: 'Offerte markeren als geaccepteerd',
    mark_accepted_confirmation: 'Weet je zeker dat je deze offerte als geaccepteerd wilt markeren?',
    mark_rejected_title: 'Offerte markeren als afgewezen',
    mark_rejected_confirmation: 'Weet je zeker dat je deze offerte als afgewezen wilt markeren?',
    proposal_marked_accepted: 'Offerte is gemarkeerd als geaccepteerd',
    proposal_marked_rejected: 'Offerte is gemarkeerd als afgewezen',
    error_marking_accepted: 'Fout bij markeren als geaccepteerd',
    error_marking_rejected: 'Fout bij markeren als afgewezen',
    accept_reason_label: 'Reden (optioneel)',
    accept_reason_placeholder:
      'Voeg een reden toe waarom deze offerte als geaccepteerd wordt gemarkeerd',
    // Edit anyway
    edit_anyway: 'Bewerk toch',
    edit_anyway_title: 'Offerte bewerken',
    edit_anyway_warning:
      'Je staat op het punt een offerte te bewerken. De status blijft behouden. Weet je zeker dat je door wilt gaan?',
    edit_anyway_confirm: 'Ja, bewerk toch',
    edit_sent_warning: 'Je bewerkt een offerte. De status blijft behouden.',
    title_section_locked_title: 'Offertenummer en -datum vergrendeld',
    title_section_locked_warning:
      'Het offertenummer en de offertedatum kunnen niet aangepast worden wanneer de offerte al verzonden is. Je kunt in dit scherm nog wel de vervaldatum aanpassen, bijvoorbeeld om de offerte te verlengen.',
    // Edit accepted (signed) proposal
    edit_accepted_title: 'Getekende offerte bewerken?',
    edit_accepted_warning:
      'Deze offerte is geaccepteerd door de klant. Wijzigingen werken door in de projectspecificaties zodra het project wordt bijgewerkt, en beïnvloeden de dealwaarde en omzet.',
    edit_accepted_hint:
      'Gaat het om extra werk op dit project? Maak een meerwerkofferte — de getekende offerte blijft intact. Is het een nieuwe aanvraag, maak dan een nieuwe deal. Bewerk alleen als je een fout in déze offerte corrigeert.',
    edit_accepted_how_title: 'Hoe werkt een meerwerkofferte?',
    edit_accepted_how_1: 'Je maakt een aparte offerte op dezelfde deal.',
    edit_accepted_how_2: 'De getekende offerte blijft zoals de klant die heeft geaccepteerd.',
    edit_accepted_how_3:
      'Na tekenen komen de extra regels op het project, apart van de oorspronkelijke specificatie.',
    edit_accepted_how_4:
      'Facturatie telt dit extra bedrag bovenop wat al geoffreerd of gefactureerd is.',
    additional_price_hint_title: 'De prijs gaat omhoog',
    additional_price_hint:
      'Extra werk hoort in een meerwerkofferte. Dan blijft deze getekende offerte intact; na tekenen komen extra regels op het project. Bewaar hier alleen als je een fout in déze offerte corrigeert.',
    additional_creating_title: 'Meerwerkofferte',
    additional_creating_hint:
      'Dit is extra werk op dezelfde deal. De originele getekende offerte blijft intact. Na acceptatie komen deze regels extra op het project.',
    additional_leave_unsaved:
      'We openen een meerwerkofferte. Wijzigingen op de getekende offerte zijn niet opgeslagen.',
    edit_accepted_confirm: 'Toch bewerken',
    edit_accepted_additional: 'Meerwerkofferte maken',
    default_additional_title: 'Meerwerk',
    scope_sync: {
      title: 'Project bijgewerkt',
      body: 'De projectregels zijn bijgewerkt naar deze offerte.',
      additional_hint:
        'Voor extra werk in de toekomst: maak een meerwerkofferte in plaats van de getekende offerte te wijzigen.',
      credit_hint:
        'Sommige regels staan al op een verzonden factuur. De factuur zelf is niet aangepast. Als er te veel is gefactureerd, maak dan een creditnota vanaf het project.',
      skipped_removals: '{count} al gefactureerde regel(s) zijn niet verwijderd.',
      over_invoiced: 'Er is al meer gefactureerd dan het nieuwe projectbedrag.',
      create_additional: 'Meerwerkofferte maken',
      view_project: 'Naar project',
      close: 'Sluiten',
    },
    unsaved_changes_title: 'Weet je het zeker?',
    unsaved_changes_confirm:
      'U heeft niet-opgeslagen wijzigingen. Weet u zeker dat u wilt sluiten?',
    // Toolbar
    download: 'Downloaden',
    download_bare: 'Download kale offerte',
    status: 'Status',
    pdf_downloaded: 'PDF succesvol gedownload',
    error_downloading_pdf: 'Fout bij downloaden van PDF',
    // Bulk delete
    delete_selected: 'Verwijder geselecteerd ({count})',
    bulk_delete_title: 'Offertes verwijderen',
    bulk_delete_confirmation:
      'Weet je zeker dat je {count} offerte(s) wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    bulk_delete_skipped:
      '{count} geselecteerde offerte(s) worden overgeslagen omdat alleen concepten verwijderd kunnen worden.',
    bulk_delete_no_drafts:
      'Geen van de geselecteerde offertes kunnen worden verwijderd. Alleen concepten kunnen worden verwijderd.',
    bulk_delete_success: '{count} offerte(s) succesvol verwijderd',
    error_bulk_deleting: 'Fout bij het verwijderen van offertes',
    // Bulk send
    send_selected: 'Verstuur geselecteerd ({count})',
    bulk_send_title: 'Offertes versturen',
    bulk_send_confirmation:
      'Weet je zeker dat je {count} offerte(s) wilt versturen? De klant ontvangt direct een e-mail met de offerte.',
    bulk_send_skipped:
      '{count} geselecteerde offerte(s) worden overgeslagen omdat alleen concepten verstuurd kunnen worden.',
    bulk_send_no_drafts:
      'Geen van de geselecteerde offertes kan worden verstuurd. Alleen concepten kunnen worden verstuurd.',
    bulk_send_success: '{count} offerte(s) worden verstuurd',
    bulk_send_failed:
      '{count} offerte(s) konden niet worden verstuurd en zijn teruggezet naar concept.',
    bulk_send_taking_longer: '{count} offerte(s) duren langer dan verwacht om te versturen.',
    bulk_send_skip_reason: {
      not_draft: '{count} offerte(s) overgeslagen — alleen concepten kunnen worden verstuurd.',
      no_recipient: '{count} offerte(s) overgeslagen — de lead heeft geen e-mailadres.',
      same_deal_conflict:
        '{count} offerte(s) overgeslagen — een nieuwer concept in dezelfde deal is in plaats daarvan verstuurd.',
      has_successor: '{count} offerte(s) overgeslagen — er bestaat al een nieuwere versie.',
      send_failed: '{count} offerte(s) konden niet worden verstuurd door een fout.',
      default: '{count} offerte(s) overgeslagen.',
    },
    error_bulk_sending: 'Fout bij het versturen van offertes',
    // Revise configuration
    revise_configuration: 'Wijzig configuratie',
    revise_configuration_error: 'Kon configuratie niet openen',
    revise_configuration_line_hint:
      'Open de configurator opnieuw om deze configuratie aan te passen',
    revise_mode_title: 'Configuratie wijzigen',
    revise_mode_description: 'Kies hoe je de configurator wilt openen.',
    revise_has_successor_error:
      'Deze offerte is al opgevolgd door een nieuwere offerte. Open de opvolgende offerte om verder te werken.',
    revise_products_unavailable_error:
      'Deze offerte kan niet geopend worden: {products} bestaat niet meer in de productcatalogus. Verwijder of vervang die regel eerst.',
    revise_products_unavailable_error_unnamed:
      'Deze offerte kan niet geopend worden: een of meer producten bestaan niet meer in de productcatalogus. Verwijder of vervang die regels eerst.',
    revise_accepted_title: 'Geaccepteerde offerte wijzigen',
    revise_accepted_description:
      'Deze offerte is al geaccepteerd en ondertekend. Als je de configuratie wijzigt wordt de huidige offerte vervangen en moet deze opnieuw worden verstuurd en geaccepteerd.',
    revise_accepted_confirm: 'Toch wijzigen',
    revise_ready_title: 'Configuratie klaar om te openen',
    revise_ready_description:
      'Klik op de onderstaande knop om de configurator te openen in een nieuw tabblad.',
    open_configurator: 'Open configurator',
    error_opening_configurator: 'Kon configurator niet openen',
    configurator: {
      title: 'Product configureren',
      product: 'Product',
      select_option: 'Kies een optie',
      select_options: 'Kies opties',
      no_options: 'Geen configureerbare opties voor dit product.',
      total: 'Totaal',
      add_to_proposal: 'Toevoegen aan offerte',
      reconfigure: 'Wijzig configuratie',
      product_not_found: 'Product niet gevonden',
      pricing_failed: 'Prijs berekenen mislukt. Het product is niet toegevoegd.',
      choice_unavailable: 'Niet beschikbaar bij de huidige keuzes',
      missing_required: 'Nog {count} verplicht(e) veld(en) invullen',
      measure_out_of_range: '{label} moet tussen {min} en {max} liggen',
      price_incl: 'Prijs incl. btw',
      calculating: 'Prijs berekenen...',
      price_failed: 'Prijs berekenen mislukt',
    },
    // Send Proposal
    send_modal: {
      title: 'Offerte versturen',
      description: 'Bekijk deze offerte en verstuur het',
      expired_valid_until_title: 'Vervaldatum ligt al in het verleden',
      expired_valid_until_warning:
        'De vervaldatum van deze offerte ligt al in het verleden. De offerte wordt zo verstuurd — de datum wordt niet automatisch aangepast. Toch versturen?',
      expired_valid_until_confirm: 'Toch versturen',
      accepted_message: 'Je offerte is geaccepteerd!',
      rejected_message: 'Deze offerte is afgewezen.',
      withdrawn_message: 'Deze offerte is ingetrokken.',
      view_proposal: 'Offerte bekijken',
      sent_at: 'Verstuurd op',
      accepted_at: 'Geaccepteerd op',
      accepted_by: 'Geaccepteerd door',
      rejected_at: 'Afgewezen op',
      rejection_reason: 'Reden voor afwijzing',
      withdrawn_at: 'Ingetrokken op',
      withdrawal_reason: 'Reden voor intrekking',
      ip_address: 'IP adres',
      sent_message: 'Offerte is verstuurd op',
      share_placeholder: 'Deel je offerte om een deelbare link te krijgen',
      copy: 'Kopiëren',
      resend_proposal: 'Offerte opnieuw versturen',
      recipients: 'Ontvangers',
      recipients_placeholder: 'Voer e-mailadres in en druk op enter',
      email_subject: 'E-mail onderwerp',
      email_subject_placeholder: 'Voer e-mail onderwerp in',
      email_content: 'E-mail inhoud',
      email_content_placeholder: 'Voer e-mail inhoud in',
      send_button: 'Offerte versturen',
      resend_button: 'Offerte opnieuw versturen',
      proposal_sent_success: 'Offerte verstuurd naar je lead!',
      sending: 'Offerte wordt verzonden…',
      pending_banner: 'Offerte wordt verzonden. Dit duurt meestal enkele seconden.',
      send_failed: 'Versturen mislukt — probeer opnieuw.',
      taking_longer: 'Verzending duurt langer dan gewoonlijk. Controleer later de offertestatus.',
      status_unknown: 'Status van de verzending kon niet worden opgehaald.',
      error_saving: 'Er is een fout opgetreden bij het opslaan van de offerte',
      link_copied: 'Link gekopieerd!',
      whatsapp_title: 'Ook via WhatsApp versturen?',
      whatsapp_description: 'Wil je de offerte ook via WhatsApp delen met de klant?',
      whatsapp_yes: 'Ja, open WhatsApp',
      send_whatsapp: 'Verstuur via WhatsApp',
      share_proposal: 'Deel offerte',
      resend_email: 'Verstuur per e-mail',
      copy_link: 'Kopieer link',
      no_phone_number: 'Geen telefoonnummer beschikbaar voor deze klant',
      attachments: 'Bijlagen',
      attachments_hint:
        'PDF-bijlagen worden meegestuurd met de e-mail en zijn te downloaden op de offertepagina.',
      add_attachment: 'PDF toevoegen',
      default_attachment_badge: 'Standaard',
      default_attachment_tooltip:
        'Standaardbijlage (instelbaar via Instellingen → Offertes). Met het kruisje stuur je hem niet mee met deze offerte.',
      product_attachment_badge: 'Product',
      product_attachment_tooltip:
        'Deze bijlage hoort bij een product op de offerte (instelbaar bij het product). Met het kruisje stuur je hem niet mee met deze offerte.',
      attachment_excluded_badge: 'Niet meesturen',
      remove_attachment: 'Bijlage verwijderen',
      restore_attachment: 'Toch meesturen',
      attachments_total: 'Totaal bijlagen: {size} (maximaal {max} per e-mail)',
      attachments_over_limit:
        'De bijlagen zijn samen te groot om per e-mail te versturen ({size}, maximaal {max}). Verwijder een of meer bijlagen.',
      attachment_upload_failed: 'Uploaden van bijlage mislukt',
      attachment_only_pdf: 'Alleen PDF-bestanden zijn toegestaan',
      attachment_too_large: 'Bestand is te groot (maximaal 5MB)',
      proposal_pdf_badge: 'Offerte',
      proposal_pdf_name: 'Offerte als PDF',
      proposal_pdf_tooltip:
        'De offerte zelf als PDF (uit te schakelen via Instellingen → Organisatie)',
      proposal_pdf_pending: 'wordt gegenereerd bij versturen',
      terms_badge: 'Voorwaarden',
      terms_tooltip: 'Algemene voorwaarden (instelbaar via Instellingen → Organisatie)',
      review_button: 'Controleren en versturen',
      preview_loading: 'Voorbeeld wordt opgehaald…',
      preview_failed: 'Voorbeeld kon niet worden opgehaald',
    },
    // Proposal form
    form: {
      fields: {
        address: {
          street: 'Straat',
          house_number: 'Huisnummer',
          postal_code: 'Postcode',
          city: 'Stad',
          select_country: 'Land',
        },
      },
      basic_information: 'Basisinformatie',
      proposal_subject: 'Offerte onderwerp',
      lead: 'Lead',
      proposal_date: 'Offerte datum',
      valid_for_days: 'Geldig voor (dagen)',
      valid_until_hint: 'Geldig voor {days} dagen',
      notes: 'Notities',
      client_notes: 'Klant notities',
      internal_notes: 'Interne notities',
      items: 'Items',
      prices_include_vat: 'Prijzen inclusief BTW',
      description: 'Beschrijving',
      configuration_details: 'Configuratie details',
      quantity: 'Aantal',
      unit_price: 'Eenheidsprijs',
      vat_rate: 'BTW tarief',
      total: 'Totaal',
      clone: 'Dupliceren',
      remove: 'Verwijderen',
      hide_from_quote: 'Verbergen op offerte',
      show_on_quote: 'Tonen op offerte',
      hidden_line_badge: 'Verborgen',
      hidden_line_hint:
        'Deze regel staat niet op de offerte, PDF of factuur. Het bedrag wordt verwerkt in de prijs van het eerste zichtbare product met hetzelfde btw-tarief, zodat de bedragen bij de klant blijven kloppen.',
      hidden_lines_summary:
        '{amount} verborgen kosten zijn verwerkt in de prijs van {carrier}. De klant ziet daar een hoger bedrag staan, niet een aparte regel.',
      hidden_lines_carrier_fallback: 'het eerste product',
      hidden_lines_unabsorbed:
        'Let op: {amount} verborgen kosten kunnen nergens in verwerkt worden, want er is geen zichtbaar product met hetzelfde btw-tarief. Voeg zo\u2019n product toe of zet het btw-tarief van de verborgen regel gelijk, anders telt de offerte bij de klant niet op.',
      add_item: 'Item toevoegen',
      summary: 'Samenvatting',
      subtotal: 'Subtotaal',
      total_vat: 'Totaal BTW',
      save: 'Opslaan',
      review_and_send: 'Controleren en versturen',
      save_first_message: 'Sla je offerte eerst op voordat je deze verstuurt',
      lead_information: 'Lead informatie',
      search_leads: 'Zoek leads...',
      no_leads_found: 'Geen leads gevonden',
      select_lead: 'Selecteer een lead',
      at_least_one_item_required: 'Minimaal één item is vereist',
      description_required: 'Beschrijving is vereist',
      quantity_min_1: 'Aantal moet minimaal 1 zijn',
      unit_price_greater_than_0: 'Eenheidsprijs moet groter zijn dan 0',
      proposal_updated: 'Offerte succesvol bijgewerkt',
      proposal_created: 'Offerte succesvol aangemaakt',
      proposal_duplicated_success: 'Offerte succesvol gedupliceerd',
      error_saving: 'Er is een fout opgetreden bij het opslaan van de offerte',
      error_accepted_locked:
        'Items, kortingen en btw van een geaccepteerde offerte kun je alleen wijzigen nadat je op "Toch bewerken" hebt geklikt.',
      lead_required_hint: 'Selecteer eerst een contact',
      valid_until_before_proposal_date: 'De vervaldatum kan niet vóór de offertedatum liggen',
      proposal_date_pending_hint:
        'Deze datums zijn een voorbeeld op basis van vandaag en worden pas definitief ingesteld op het moment dat je de offerte verstuurt.',
      proposal_date_override_title: 'Offertedatum handmatig instellen',
      proposal_date_override_warning:
        'Weet je zeker dat je de offertedatum handmatig wilt instellen? Als je dit aan Funnelflow overlaat, wordt automatisch de datum gebruikt waarop de offerte wordt verzonden.',
      proposal_date_override_button: 'Activeer handmatige selectie',
      error_preparing_send: 'Fout bij het voorbereiden van de offerte voor verzending',
      // Discounts
      discounts: 'Kortingen',
      add_discount: 'Korting toevoegen',
      no_discounts: 'Geen kortingen toegevoegd',
      discount_number: 'Korting {number}',
      discount_type: 'Type',
      discount_type_percentage: 'Percentage',
      discount_type_fixed: 'Vast bedrag',
      discount_value: 'Waarde',
      discount_value_percentage: 'Percentage',
      discount_value_amount: 'Bedrag (€)',
      discount_description: 'Beschrijving (optioneel)',
      discount_description_placeholder: 'Bijv. Early bird korting',
      remove_discount: 'Verwijderen',
      subtotal_after_discounts: 'Subtotaal na kortingen (excl. BTW)',
      title_required: 'Titel is verplicht',
      lead_required: 'Selecteer een contact',
      items_required: 'Voeg minimaal één regel toe',
      item_description_required: 'Elke regel moet een omschrijving hebben',
    },
    // Proposal statuses
    statuses: {
      draft: 'Concept',
      sent: 'Verstuurd',
      viewed: 'Bekeken',
      accepted: 'Geaccepteerd',
      rejected: 'Afgewezen',
      superseded: 'Vervangen',
      withdrawn: 'Ingetrokken',
      sending: 'Wordt verstuurd',
    },
    // Proposal types (pro forma flow)
    types: {
      definitive: 'Definitief',
      proforma: 'Voorlopig',
      additional: 'Meerwerk',
    },
    type_field: 'Type',
    succeeded_by: 'Opgevolgd door',
    based_on: 'Gebaseerd op',
    revise_carries_lines:
      '{count} handmatig toegevoegde regel(s) worden automatisch meegenomen naar de nieuwe offerte.',
    revise_carries_lines_with_hidden:
      '{count} handmatig toegevoegde regel(s) worden meegenomen, waarvan {hiddenCount} verborgen voor de klant.',
    make_definitive: 'Definitief maken',
    make_definitive_description:
      'Opent de configurator met de originele waarden zodat je exacte maten kunt invullen na inmeting.',
    auto_accepted_banner: 'Deze definitieve offerte is automatisch geaccepteerd.',
    auto_accepted_price_change:
      'Prijswijziging t.o.v. voorlopige offerte: {change}% (binnen marge {tolerance}%)',
    manual_approval_required: 'Handmatige goedkeuring vereist',
    manual_approval_description:
      'Prijsstijging {change}% t.o.v. voorlopige offerte (boven marge van {tolerance}%).',
    proforma_accepted_banner: 'Voorlopige offerte geaccepteerd',
    proforma_accepted_description:
      'De klant heeft de voorlopige offerte ondertekend. Plan nu een inmeting in om de definitieve offerte op te stellen.',
    create_project_and_measurement: 'Project + inmeting aanmaken',
    create_project_only: 'Alleen project aanmaken',
    proforma_standalone_info:
      'Dit is een voorlopige offerte. Na inmeting ontvangt de klant een definitieve offerte met exacte specificaties.',
    superseded_message: 'Deze offerte is vervangen door een nieuwere versie.',
    superseded_info: 'U kunt deze offerte niet meer bewerken of versturen.',
    open_successor: 'Open offerte {number}',
    // Moneybird layout
    extra: 'Extra',
    change_status: 'Wijzig status',
    days_open: 'dagen open',
    expires_on: 'Verloopt op',
    expired_on: 'Verlopen op',
    accepted_on: 'Geaccepteerd op',
    rejected_on: 'Afgewezen op',
    not_sent_yet: 'Nog niet verzonden',
    validity_period: 'Geldigheid',
    of: 'van',
    days_passed: 'dagen verstreken',
    activities: 'Activiteiten',
    signature_info: 'Handtekening',
    signed_by: 'Getekend door',
    email: 'E-mail',
    ip_address: 'IP-adres',
    signed_at: 'Getekend op',
    mark_as_sent_manually: 'Handmatig als verzonden beschouwen',
    mark_as_sent_manually_checkbox: 'Handmatig als verzonden beschouwen (geen e-mail versturen)',
    mark_as_sent_manually_description:
      'Markeer deze offerte als verzonden zonder e-mail te versturen.',
    marked_as_sent_manually: 'Offerte handmatig als verzonden gemarkeerd',
    error_marking_sent: 'Fout bij markeren als verzonden',
    view_online: 'Bekijk online',
    pages: {
      title: "Pagina's",
      navigation: "Pagina's van de offerte",
      actions: 'Offerte-acties',
      cover: 'Voorblad',
      proposal: 'Offerte',
      closing: 'Slotpagina',
      from_template: 'uit template',
      layout_rail: "Pagina's in zijbalk tonen",
      layout_dock: "Pagina's in balk onderaan tonen",
    },
    delete_proposal: 'Offerte verwijderen',
    delete_proposal_confirmation:
      'Weet je zeker dat je deze offerte wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    proposal_deleted: 'Offerte verwijderd',
    error_deleting: 'Fout bij verwijderen van offerte',
    withdraw: 'Intrekken',
    withdraw_proposal: 'Offerte intrekken',
    withdraw_confirmation:
      'Als je de offerte intrekt wordt deze ongeldig verklaard voor de klant. De klant kan de offerte dan niet meer accepteren.',
    withdraw_reason_placeholder: 'Reden voor intrekking (optioneel)',
    proposal_withdrawn: 'Offerte ingetrokken',
    error_withdrawing: 'Fout bij intrekken van offerte',
    delivery: {
      banner_title: 'Offerte niet afgeleverd bij {recipients}',
      banner_title_reminder: 'Herinnering niet afgeleverd bij {recipients}',
      banner_title_failed: 'De e-mail met de offerte kon niet worden verzonden',
      banner_hint: 'Controleer het e-mailadres van de klant en verstuur de offerte opnieuw.',
      resend: 'Opnieuw versturen',
      toast: 'Let op: de offerte is niet afgeleverd bij {recipients}. Controleer het e-mailadres.',
      toast_failed: 'Let op: de e-mail met de offerte kon niet worden verzonden.',
      reasons: {
        HardBounce: 'Het e-mailadres bestaat niet of de mailbox is onbereikbaar.',
        SoftBounce: 'De mailbox is tijdelijk onbereikbaar (bijvoorbeeld omdat hij vol is).',
        BadEmailAddress: 'Het e-mailadres is ongeldig.',
        DnsError: 'Het domein van het e-mailadres bestaat niet of is onbereikbaar.',
        Blocked: 'De mailserver van de ontvanger heeft de e-mail geblokkeerd.',
        ManuallyDeactivated:
          'Het adres is geblokkeerd na eerdere mislukte bezorgingen of een spammelding.',
        DMARCPolicy: 'De e-mail is geweigerd door het beveiligingsbeleid van de ontvanger.',
        inactive:
          'Dit adres is eerder onbereikbaar gebleken en wordt door onze mailprovider geblokkeerd.',
        failed: 'Er ging iets mis bij het verzenden van de e-mail.',
        default: 'De e-mail kon niet worden afgeleverd.',
      },
      send_errors: {
        too_large: 'De e-mail is te groot: de bijlagen zijn samen meer dan 10 MB.',
        invalid_recipient: 'Het e-mailadres van de ontvanger is ongeldig.',
        sender_not_allowed: 'Het afzenderadres is niet toegestaan bij onze mailprovider.',
        rate_limited: 'Er worden op dit moment te veel e-mails tegelijk verstuurd.',
      },
      hints: {
        too_large: 'Verwijder een of meer bijlagen en verstuur de offerte opnieuw.',
        retry: 'Probeer het later opnieuw. Lukt het niet, neem dan contact op met support.',
      },
    },
    activity: {
      created: 'Offerte aangemaakt',
      sent: 'Offerte verzonden',
      marked_sent_manually: 'Offerte handmatig als verzonden gemarkeerd',
      viewed: 'Offerte bekeken',
      accepted: 'Offerte geaccepteerd',
      rejected: 'Offerte afgewezen',
      withdrawn: 'Offerte ingetrokken',
      updated: 'Offerte bewerkt',
      content_edited: 'Getekende offerte bewerkt',
      reminder_sent: 'Herinnering verstuurd naar {recipient} (na {interval} dagen)',
      reminder_sent_no_recipient: 'Herinnering verstuurd (na {interval} dagen)',
      bounced: 'Offerte niet afgeleverd bij {recipients}',
      reminder_bounced: 'Herinnering niet afgeleverd bij {recipients}',
      send_failed: 'E-mail met offerte kon niet worden verzonden',
      price_deviation: {
        price_held:
          'Afgesproken prijs vastgehouden: inmeting {difference} ({pct}%), binnen marge {max}%',
        price_not_held:
          'Afgesproken prijs niet vastgehouden: inmeting {difference} ({pct}%) valt buiten marge {max}%',
        price_hold_failed:
          'Afgesproken prijs kon niet worden vastgehouden: inmeting {difference} ({pct}%)',
        price_unchanged: 'Inmeting gelijk aan afgesproken prijs',
        price_difference: 'Prijsverschil na inmeting: {difference} ({pct}%)',
        remeasure: 'Herinmeting: prijs niet vastgehouden ({difference}, {pct}%)',
        auto_accepted: 'Automatisch geaccepteerd',
        auto_accept_skipped: 'Niet automatisch geaccepteerd: {reason}',
        reasons: {
          above_tolerance: 'verschil groter dan de marge, klant moet akkoord geven',
          below_tolerance: 'verschil groter dan de marge, klant moet akkoord geven',
          hold_failed: 'afgesproken prijs kon niet worden vastgehouden, klant moet akkoord geven',
          proforma_not_accepted: 'voorlopige offerte was nog niet geaccepteerd',
          not_from_proforma: 'herinmeting vraagt altijd akkoord van de klant',
          update_failed: 'technische fout bij accepteren',
        },
      },
    },
    // Filter
    filter: {
      status: 'Status',
      filter_by_status: 'Filter op status',
      reset: 'Toon alles',
    },
    // Empty state
    empty_state: {
      title: 'Nog geen offertes',
      description: 'Begin door je eerste offerte te maken.',
    },
    // Search
    search_placeholder: 'Zoek op titel, nummer, contact...',
    no_more_results: 'Alle offertes geladen',
    search_no_results: 'Geen resultaten gevonden',
    search_no_results_description:
      'Er zijn geen offertes gevonden die overeenkomen met je zoekopdracht. Probeer een andere zoekterm.',
    error_loading: 'Fout bij het laden van de offerte',
  },

  // Projects
  projects: {
    title: 'Projecten',
    add_project: 'Project toevoegen',
    view_table: 'Tabel',
    journey_hint:
      'Lopende projecten per fase en wie er aan zet is. Projecten zonder gekoppelde deal staan alleen in de tabel.',
    journey_search: 'Zoek op projectnummer, titel of klant...',
    address_sync_title: 'Adres ook in lopende projecten bijwerken?',
    address_sync_intro:
      'Er staat nog {count} lopend project op het oude adres. Projecten gebruiken een kopie van het klantadres, dus die verandert niet automatisch mee.',
    address_sync_new_address: 'Nieuw klantadres',
    address_sync_empty: 'Geen adres',
    address_sync_work_orders: '{count} open werkbon(nen)',
    address_sync_note:
      'Open werkbonnen krijgen het nieuwe adres ook. Al verzonden leveranciersbestellingen, pakbonnen en facturen blijven ongewijzigd.',
    address_sync_keep: 'Laat staan',
    address_sync_apply: 'Projecten bijwerken',
    address_sync_success: '{count} project(en) bijgewerkt',
    address_sync_partial: '{updated} bijgewerkt, {failed} mislukt',
    address_sync_failed: 'Bijwerken van de projectadressen is mislukt',
    details: 'Projectgegevens',
    project_number: 'Projectnummer',
    sales_order: 'Verkooporder',
    proposal: 'Offerte',
    customer_reference: 'Uw kenmerk',
    customer_reference_placeholder: 'Bijv. PO-00297',
    customer_reference_help: 'Inkoopordernummer of referentie van de klant. Komt op de factuur.',
    title_field: 'Titel',
    title_placeholder: 'Voer een projectnaam in',
    description: 'Omschrijving',
    description_placeholder: 'Korte omschrijving van het project',
    status: 'Status',
    customer: 'Klant',
    proposal: 'Offerte',
    select_proposal: 'Selecteer een offerte',
    orders_count: 'Bestellingen',
    invoicing: 'Facturatie',
    invoicing_tooltip: 'Gefactureerd / projecttotaal (incl. btw)',
    invoicing_paid: 'Betaald',
    invoicing_open: 'Open',
    expected_start: 'Verwachte startdatum',
    expected_completion: 'Verwachte oplevering',
    installation_address: 'Installatieadres',
    use_lead_address: 'Gebruik adres van lead',
    use_custom_address: 'Aangepast adres',
    street: 'Straat + huisnummer',
    postal_code: 'Postcode',
    city: 'Plaats',
    internal_notes: 'Interne notities',
    internal_notes_placeholder: 'Notities voor intern gebruik',
    actions: 'Acties',
    view: 'Bekijken',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    create_project: 'Project aanmaken',
    create_new_project: 'Nieuw project aanmaken',
    create_from_proposal: 'Project aanmaken',
    create_from_deal: 'Project aanmaken',
    view_project: 'Naar project',
    project_created_success: 'Project succesvol aangemaakt',
    edit_project: 'Project bewerken',
    delete_project: 'Project verwijderen',
    delete_project_confirmation: 'Weet je zeker dat je dit project wilt verwijderen?',
    linked_deal: 'Gekoppelde deal',
    salesperson: 'Verkoper',
    no_project_yet: 'Nog geen project',
    no_project_yet_description:
      'Een project wordt automatisch aangemaakt zodra de definitieve offerte is geaccepteerd. Wil je nu al werkbonnen inplannen of bestellingen beheren, maak het dan handmatig aan.',
    create_project_for_deal: 'Project nu al aanmaken',
    draft_banner: 'Dit project is in concept. Zodra de deal gewonnen is, wordt het project actief.',
    planning_banner:
      'Dit project wacht op inmeting. Na de inmeting wordt een definitieve offerte opgesteld.',
    proforma_zero_banner:
      'Dit is een voorlopige offerte. Er is nog geen definitieve offerte, daarom staat het projectbedrag op €0.',
    orders_not_available_draft: 'Bestellingen zijn pas mogelijk wanneer de deal is gewonnen.',
    reopen_project: 'Project heropenen',
    reopen_confirm: 'Wil je dit project heropenen?',
    project_reopened: 'Project heropend',
    reopen_failed: 'Project heropenen mislukt',
    complete_project: 'Project afronden',
    complete_confirm: 'Weet je zeker dat je dit project wilt afronden?',
    project_completed: 'Project afgerond',
    select_proposal_for_order: 'Selecteer een offerte als bron voor de bestelling',
    no_accepted_proposals: 'Er zijn geen geaccepteerde offertes beschikbaar.',
    deal: 'Deal',
    progress: 'Voortgang',
    work_orders_progress: '{completed}/{total} werkbonnen',
    orders_progress: '{completed}/{total} bestellingen',
    statuses: {
      draft: 'Concept',
      planning: 'Inmeting',
      active: 'Actief',
      on_hold: 'On Hold',
      completed: 'Voltooid',
      cancelled: 'Geannuleerd',
    },
    empty_state: {
      title: 'Nog geen projecten',
      description: 'Begin door je eerste project aan te maken.',
    },
    filter: {
      status: 'Status',
      filter_by_status: 'Filter op status',
      reset: 'Toon alles',
    },
  },

  // Orders
  orders: {
    title: 'Bestellingen',
    add_order: 'Bestelling toevoegen',
    loose: {
      button: 'Losse artikelen bestellen',
      title: 'Losse artikelen bestellen',
      supplier: 'Leverancier',
      supplier_placeholder: 'Kies een leverancier',
      add_article: 'Artikel toevoegen',
      search_placeholder: 'Zoek op artikelcode of naam',
      empty: 'Nog geen artikelen. Zoek hierboven op code of naam.',
      quantity: 'Aantal',
      length_m: 'Lengte per stuk (m)',
      note: 'Regelopmerking',
      note_placeholder: 'Bijv. op maat zagen',
      remove: 'Verwijderen',
      submit: 'Opslaan en controleren',
      no_project: 'Losse bestelling',
      length_required: 'Vul bij alle meterartikelen een lengte per stuk in.',
      failed: 'Bestelling opslaan mislukt',
    },
    order_number: 'Bestelnummer',
    title_field: 'Titel',
    title_placeholder: 'Voer een titel voor de bestelling in',
    status: 'Status',
    project: 'Project',
    select_project: 'Selecteer een project',
    customer: 'Klant',
    supplier: 'Leverancier',
    select_supplier: 'Selecteer een leverancier',
    items: 'Producten',
    expected_delivery: 'Verwachte levering',
    actual_delivery_date: 'Werkelijke leverdatum',
    appointment_date: 'Afspraak',
    actions: 'Acties',
    view: 'Bekijken',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    create_order: 'Bestelling aanmaken',
    request_failed: 'Actie op bestelling mislukt',
    order_created: 'Bestelling aangemaakt',
    order_updated: 'Bestelling bijgewerkt',
    order_status_updated: 'Status bijgewerkt',
    order_deleted: 'Bestelling verwijderd',
    order_exported: 'Bestelling naar leverancier verstuurd',
    proposal_must_be_accepted:
      'De offerte moet eerst geaccepteerd zijn. Open de offerte en kies rechtsboven Wijzig status → Markeer als geaccepteerd. Bij een concept verstuur je hem eerst.',
    proposal_not_accepted:
      'De gekoppelde offerte is nog niet geaccepteerd (status: {status}). Markeer de offerte eerst als geaccepteerd.',
    proposal_accept_hint_draft:
      'Deze offerte is nog een concept, daarom kun je geen bestelling maken. Verstuur de offerte eerst. Open hem daarna en kies rechtsboven Wijzig status → Markeer als geaccepteerd.',
    proposal_accept_hint_sent:
      'Deze offerte is verstuurd, maar nog niet geaccepteerd. Open de offerte en kies rechtsboven Wijzig status → Markeer als geaccepteerd. Daarna kun je de bestelling aanmaken.',
    proposal_accept_hint_rejected:
      'Deze offerte is afgewezen. Open de offerte en kies rechtsboven Wijzig status → Markeer als geaccepteerd als de klant alsnog akkoord is.',
    proposal_accept_hint_replaced:
      'Deze offerte telt niet meer. Open de nieuwste offerte en kies rechtsboven Wijzig status → Markeer als geaccepteerd. Daarna kun je de bestelling aanmaken.',
    draft_project_no_orders: 'Bestellingen zijn pas mogelijk wanneer de deal is gewonnen.',
    create_new_order: 'Nieuwe bestelling aanmaken',
    edit_order: 'Bestelling bewerken',
    delete_order: 'Bestelling verwijderen',
    delete_order_confirmation: 'Weet je zeker dat je deze bestelling wilt verwijderen?',
    update_status: 'Status bijwerken',
    export_to_supplier: 'Bestelling versturen',
    resend_to_supplier: 'Opnieuw versturen naar leverancier',
    // Status update modal
    current_status: 'Huidige status',
    new_status: 'Nieuwe status',
    select_status: 'Selecteer een status',
    supplier_order_reference: 'Leverancier referentie',
    supplier_order_reference_placeholder: 'Bijv. ORDER-12345',
    delivery_notes: 'Leveringsnotities',
    delivery_notes_placeholder: 'Notities over de levering',
    installation_notes: 'Installatienotities',
    installation_notes_placeholder: 'Notities voor de installatie',
    cancellation_reason: 'Reden voor annulering',
    cancellation_reason_placeholder: 'Waarom wordt deze bestelling geannuleerd?',
    status_notes: 'Notities',
    status_notes_placeholder: 'Optionele notities bij deze statuswijziging',
    auto_generate_work_order: 'Werkbon automatisch aanmaken',
    supplier_notes: 'Notities voor leverancier',
    supplier_notes_placeholder: 'Notities voor bij de leverancier',
    internal_notes: 'Interne notities',
    internal_notes_placeholder: 'Notities voor intern gebruik',
    // Planning fields
    planning_optional: 'Planning (optioneel)',
    planning_hint:
      'Je kunt nu al een voorlopige afspraak inplannen, ook als het product nog niet binnen is.',
    tentative_appointment: 'Voorlopige afspraak',
    statuses: {
      pending: 'Concept',
      ordered: 'Besteld',
      confirmed: 'Bevestigd',
      received: 'Binnen',
      cancelled: 'Geannuleerd',
      cancelled_by_supplier: 'Geannuleerd door leverancier',
      installed: 'Geïnstalleerd',
    },
    empty_state: {
      title: 'Nog geen bestellingen',
      description: 'Begin door je eerste bestelling aan te maken.',
    },
    details: 'Details',
    products: 'Producten',
  },

  // Work Orders
  work_orders: {
    title: 'Werkbonnen',
    untitled: 'Werkbon',
    work_order_number: 'Werkbonnummer',
    types: {
      installation: 'Installatie',
      measurement: 'Inmeting',
      service: 'Service',
    },
    type_field: 'Type',
    type_changed: 'Type werkbon aangepast',
    type_change_failed: 'Kon het type niet aanpassen',
    type_in_measurement_title: 'Project staat nog op inmeting',
    type_in_measurement_description:
      'Er is nog geen definitieve offerte geaccepteerd. Weet je zeker dat je deze werkbon wilt omzetten naar installatie?',
    type_in_measurement_confirm: 'Ja, zet om naar installatie',
    description: 'Omschrijving',
    installer_notes: 'Notities voor de monteur',
    order: 'Bestelling',
    project: 'Project',
    customer: 'Klant',
    address: 'Adres',
    installer: 'Monteur',
    appointment_date: 'Afspraak',
    status: 'Status',
    actions: 'Acties',
    view: 'Bekijken',
    edit: 'Bewerken',
    complete: 'Voltooien',
    generate_work_order: 'Werkbon genereren',
    schedule: 'Inplannen',
    scheduled_success: 'Werkbon ingepland',
    scheduled_error: 'Fout bij inplannen werkbon',
    statuses: {
      pending: 'In afwachting',
      scheduled: 'Ingepland',
      ready_for_installation: 'Klaar voor installatie',
      open: 'Open',
      in_progress: 'Bezig',
      completed: 'Voltooid',
      cancelled: 'Geannuleerd',
    },
    fill_form: 'Formulier invullen',
    select_form: 'Selecteer formulier',
    open_form: 'Openen in nieuw tabblad',
    no_forms_available: 'Geen configurator-formulieren beschikbaar.',
    add_work_order: 'Werkbon aanmaken',
    measurement_already_definitive:
      'Er is al een definitieve offerte. Een nieuwe inmeting maakt een nieuwe versie.',
    remeasure_confirm_title: 'Opnieuw inmeten',
    remeasure_confirm_description:
      'Er is al een geaccepteerde definitieve offerte. We maken een nieuwe versie. ' +
      'Blijft de prijs binnen de ingestelde marge, dan wordt die automatisch geaccepteerd. ' +
      'Anders moet de klant opnieuw akkoord geven.',
    remeasure_confirm_submit: 'Configuratie openen',
    empty_state: {
      title: 'Nog geen werkbonnen',
      description: 'Maak een werkbon aan om taken in te plannen.',
    },
    products: {
      section_title: 'Producten op deze werkbon',
      select_products: 'Producten kiezen',
      choose_title: 'Producten voor werkbon',
      choose_description:
        'Kies welke producten van het project op deze werkbon staan. ' +
        'De pakbon en montage gebruiken deze selectie.',
      all_products: 'Alle projectproducten',
      select_all: 'Alles selecteren',
      deselect_all: 'Alles deselecteren',
      none_selected: 'Geen producten geselecteerd',
      no_products: 'Dit project heeft (nog) geen producten in de scope.',
      already_assigned: 'Al op {labels}',
      already_assigned_generic: 'Al op een werkbon',
      standard_hours: '{hours} u',
      estimated_duration: 'Geschatte duur: {duration}',
      estimated_duration_fallback: 'Geen normuren ingesteld — standaard 2 uur bij inplannen.',
      save: 'Selectie opslaan',
      updated: 'Producten bijgewerkt',
      update_error: 'Kon producten niet bijwerken',
      // Sync
      sync: 'Opnieuw syncen',
      scope_changed:
        'De projectscope is gewijzigd na deze werkbon. Sync opnieuw om de ' +
        'producten bij te werken.',
      synced: 'Producten gesynchroniseerd met het project',
      sync_error: 'Synchroniseren mislukt',
      // Carry-over
      carry_over: 'Vervolgwerkbon',
      carry_over_title: 'Vervolgwerkbon aanmaken',
      carry_over_description:
        'Kies de producten die op een nieuwe vervolgwerkbon moeten komen ' +
        '(bijv. niet gelukt of voor later). Monteur en datum worden niet ' +
        'overgenomen.',
      carry_over_submit: 'Vervolgwerkbon aanmaken',
      carry_over_success: 'Vervolgwerkbon aangemaakt',
      carry_over_error: 'Kon vervolgwerkbon niet aanmaken',
      // Chain
      chain_title: 'Gekoppelde werkbonnen',
      parent_label: 'Vervolg op',
      child_label: 'Vervolgwerkbon',
    },
    outcomes: {
      hint: 'Geef per product aan of de installatie is gelukt.',
      installed: 'Gelukt',
      failed: 'Niet gelukt',
      reason_label: 'Reden',
      reason_placeholder: 'Kies een reden...',
      notes_placeholder: 'Toelichting (optioneel)...',
      reasons: {
        product_missing: 'Product niet aanwezig',
        product_damaged: 'Product beschadigd',
        situation_different: 'Situatie anders dan verwacht',
        other: 'Anders',
      },
      follow_up_notice: 'Voor {count} product(en) wordt automatisch een vervolgwerkbon aangemaakt.',
      complete_with_exceptions: 'Afronden met uitzonderingen',
      completed_with_follow_up: 'Werkbon afgetekend! Vervolgwerkbon {number} aangemaakt.',
      completed_with_exceptions_banner: 'Werkbon afgerond met uitzonderingen',
      outcomes_title: 'Uitkomst per product',
      follow_up_filter: 'Vervolgacties',
    },
  },

  // Submissions
  submissions: {
    title: 'Aanvragen',
    all_submissions: 'Alle aanvragen',
    all_forms: 'Alle formulieren',
    view_all_submissions: 'Bekijk en beheer alle aanvragen van je organisatie',
    view_form_submissions: 'Bekijk en beheer inzendingen voor dit formulier',
    no_submissions: 'Nog geen aanvragen',
    no_submissions_description: 'Er zijn nog geen aanvragen ontvangen.',
    submission_details: 'Aanvraagdetails',
    lead: 'Lead',
    last_updated: 'Laatst bijgewerkt',
    form_data: 'Formuliergegevens',
    no_value_provided: 'Geen waarde opgegeven',
    form_submission: 'Formulierinzending',
    form: 'Formulier',
    status: {
      new: 'Nieuw',
      reviewed: 'Beoordeeld',
      processed: 'Verwerkt',
      archived: 'Gearchiveerd',
      partial: 'Concept',
      complete: 'Voltooid',
    },
    filter_all: 'Alle aanvragen',
    filter_complete: 'Voltooid',
    filter_incomplete: 'Concept',
    export_to_csv: 'Exporteer naar CSV',
    exporting: 'Exporteren...',
    // Filter dropdown
    filter: {
      status: 'Status',
      form: 'Formulier',
      filter_by_status: 'Filter op status',
      filter_by_form: 'Filter op formulier',
      reset: 'Toon alles',
      all_forms: 'Alle formulieren',
    },
    // Stats
    stats: {
      total: 'Totaal',
      completed: 'Voltooid',
      partial: 'In concept',
      failed: 'Mislukt',
      processing: 'In verwerking',
      completion_rate: 'Voltooiingsratio',
    },
  },

  // Lead Details
  lead_details: {
    overview: 'Overzicht',
    proposals: 'Offertes',
    submissions: 'Aanvragen',
    appointments: 'Afspraken',
    deals: 'Deals',
    activity: 'Activiteit',
    contact_details: 'Contactgegevens',
    no_description_provided: 'Klik om te bewerken',
    attribution: 'Herkomst',
    name: 'Naam',
    email: 'E-mail',
    phone: 'Telefoon',
    address: 'Adres',
    description: 'Beschrijving',
    marketing_opt_in: 'Marketing opt-in',
    activity_feed: 'Activiteiten Feed',
    leave_note_placeholder: 'Laat een notitie achter op de tijdlijn...',
    form_submissions: 'Aanvragen',
    no_submissions: 'Nog geen aanvragen',
    no_submissions_description: 'Deze lead heeft nog geen formulieren ingevuld.',
    no_appointments: 'Geen afspraken ingepland',
    no_appointments_description: 'Deze lead heeft nog geen afspraken ingepland.',
    lead_not_found: 'Lead niet gevonden',
    lead_not_found_description: 'De gevraagde lead kon niet worden gevonden.',
    unnamed_lead: 'Naamloze Lead',
    created_at: 'Aangemaakt',
    loading: 'Laden...',
    no_lead_selected: 'Geen lead geselecteerd',
    select_lead_to_view: 'Selecteer een lead uit de tabel om details te bekijken.',
    view_and_manage_lead: 'Bekijk en beheer lead informatie, aanvragen en offertes.',
    no_address_provided: 'Geen adres opgegeven',
    no_phone_provided: 'Geen telefoonnummer opgegeven',
    add_note: 'Notitie Toevoegen',
    form_submission: 'Formulierinzending',
    lead_created: 'Lead aangemaakt',
    updated_lead_fields: 'Lead velden bijgewerkt',
    status_updated: 'Status bijgewerkt',
    updated_lead_field: 'Lead veld bijgewerkt',
    update_field_failed: 'Veld bijwerken mislukt',
    email_already_exists: 'Lead met dit e-mailadres bestaat al: {name} ({email})',
    note_added: 'Notitie toegevoegd',
    lead_details: 'Lead details',
    edit_details: 'Klantgegevens bewerken',
    customer_type: {
      person: 'Particulier',
      company: 'Zakelijk',
    },
    company_details: 'Bedrijfsgegevens',
    company_name: 'Bedrijfsnaam',
    kvk_number: 'KVK-nummer',
    vat_number: 'BTW-nummer',
    legal_form: 'Rechtsvorm',
    vat_reverse_charge_active: 'BTW verlegd',
    billing_details: 'Factuurgegevens',
    billing_email: 'Factuur e-mailadres',
    billing_address: 'Factuuradres',
    no_billing_details: 'Geen afwijkende factuurgegevens',
    // Archive/Restore/Delete
    archive_lead: 'Klant archiveren',
    archive_lead_confirm:
      'Weet je zeker dat je deze klant wilt archiveren? De klant wordt verborgen maar alle gegevens blijven bewaard.',
    archive: 'Archiveren',
    lead_archived: 'Klant gearchiveerd',
    archive_failed: 'Archiveren mislukt',
    restore_lead: 'Klant herstellen',
    lead_restored: 'Klant hersteld',
    restore_failed: 'Herstellen mislukt',
    delete_lead: 'Klant verwijderen',
    delete_lead_confirm:
      'Weet je zeker dat je deze klant permanent wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
    delete: 'Verwijderen',
    lead_deleted: 'Klant verwijderd',
    delete_failed: 'Verwijderen mislukt',
  },

  // Table View
  table_view: {
    leads_overview: 'Leads overzicht',
    name: 'Naam',
    email: 'E-mail',
    phone: 'Telefoon',
    address: 'Adres',
    last_updated_at: 'Laatst bijgewerkt op',
  },

  // Form List
  form_list: {
    title: 'Jouw funnels',
    description: 'Bekijk en beheer al je opgeslagen funnels',
    new_flow: 'Nieuwe flow',
    new_configurator: 'Nieuwe configurator',
    empty_state: {
      title: 'Nog geen funnels',
      description: 'Begin door je eerste funnel te maken.',
      action: 'Nieuwe flow maken',
    },
    modal: {
      title: 'Maak een nieuwe flow',
      description: 'Laat ons weten hoe je je nieuwe flow wilt maken 👏',
    },
    configurator_modal: {
      title: 'Maak een nieuwe configurator',
      description:
        'Maak een product configurator die automatisch formulieren genereert op basis van je producten 🛠️',
    },
  },

  // Appointments
  appointments: {
    title: 'Afspraken',
    refresh: 'Vernieuwen',
    export: 'Exporteren',
    filters: {
      status: 'Status',
      form: 'Formulier',
      all_statuses: 'Alle statussen',
      all_forms: 'Alle formulieren',
    },
    statuses: {
      booked: 'Geboekt',
      available: 'Beschikbaar',
      unavailable: 'Niet beschikbaar',
      confirmed: 'Bevestigd',
      pending: 'In afwachting',
      cancelled: 'Geannuleerd',
      completed: 'Voltooid',
    },
    default_title: 'Afspraak',
    attendees: 'deelnemers',
    forms: {
      intake: 'Intake Formulier',
      demo: 'Demo Aanvraag',
      consultation: 'Consultatie',
    },
    details: {
      date_time: 'Datum & Tijd',
      status: 'Status',
      location: 'Locatie',
      description: 'Beschrijving',
      attendees: 'Deelnemers',
      calendar: 'Agenda',
      assigned_to: 'Toegewezen aan',
      calendar_event: 'Agenda-item',
    },
    location_types: {
      online: 'Online meeting',
      fixed: 'Vaste locatie',
      custom: 'Klantlocatie',
    },
    actions: {
      restore: 'Herstellen',
      cancel: 'Annuleren',
      view_in_calendar: 'Bekijk in agenda',
    },
    errors: {
      restore_failed: 'Er is een fout opgetreden bij het herstellen van de afspraak.',
    },
  },

  planning_page: {
    revenue: {
      this_day: 'Deze dag',
      this_week: 'Deze week',
      this_month: 'Deze maand',
      avg_per_day: 'Gem. per dag',
      excl_vat: 'excl. BTW',
    },
    helpers_busy: {
      title: 'Collega niet beschikbaar',
      intro: '{technician} kan op {date} om {time}, maar {helpers} is die dag al ingepland:',
      intro_unassigned: 'De klus past op {date} om {time}, maar {helpers} is die dag al ingepland:',
      with_technician: 'met {name}',
      option_without: 'Plan zonder {helpers}',
      option_without_hint: 'Alleen {technician}, {range}',
      option_without_hint_moved: 'Alleen {technician}, {range} (eerstvolgende vrije tijd)',
      option_overlap: 'Toch met {helpers} inplannen',
      option_overlap_hint: 'Dubbele boeking voor {helpers}, {range}',
      submit: 'Inplannen',
      cancel: 'Annuleren',
      ghost: 'Collega bezet: laat los voor opties',
      toast_without: 'Ingepland om {time} zonder {helpers}',
      toast_overlap: 'Ingepland om {time}, met overlap voor {helpers}',
    },
  },

  // Settings
  settings: {
    title: 'Instellingen',
    organization: 'Organisatie',
    profile: 'Profiel',
    billing: 'Facturering',
    team: 'Team',
    team_no_members: 'Nog geen teamleden. Nodig iemand uit om te beginnen.',
    team_no_members_title: 'Geen teamleden',
    integrations: 'Integraties',
    general: 'Algemeen',
    branding: 'Branding',
    notifications: 'Meldingen',
    language: 'Taal',
    language_description: 'Kies je voorkeurstaal voor de dashboard interface.',
    save: 'Wijzigingen Opslaan',
    saving: 'Opslaan...',
    saved: 'Instellingen succesvol opgeslagen',
    // Proposal workflow
    proposal_workflow: 'Offerte workflow',
    proposal_workflow_direct: 'Direct',
    proposal_workflow_direct_description: 'Standaard workflow. Elke offerte is direct definitief.',
    proposal_workflow_measurement: 'Met inmeting',
    proposal_workflow_measurement_description:
      'Voorlopige offerte → Inmeting → Definitieve offerte.',
    price_deviation: {
      title: 'Prijsafwijking na inmeting',
      mode_hold: 'Afgesproken prijs vasthouden',
      mode_adjust_accept: 'Nieuwe prijs accepteren',
      mode_off: 'Uit',
      help_hold:
        'Valt de definitieve offerte binnen de marge hoger of lager uit, dan blijft het klantbedrag gelijk aan de geaccepteerde voorlopige offerte en wordt de offerte automatisch geaccepteerd. Jullie nemen het verschil voor je rekening. Buiten de marge moet de klant opnieuw akkoord geven.',
      help_adjust_accept:
        'De definitieve offerte krijgt de nieuwe prijs. Is die lager, of hoger maar binnen de marge, dan wordt hij automatisch geaccepteerd. Bij een grotere stijging moet de klant opnieuw akkoord geven.',
      help_off: 'De klant moet de definitieve offerte altijd opnieuw accepteren.',
      help_legacy:
        'Nog niet ingesteld: jullie eerdere instellingen voor automatisch accepteren en de commerciële cap blijven gelden. Kies een optie om over te stappen.',
      max_percent: 'Maximale afwijking',
      max_percent_help:
        'Ten opzichte van de geaccepteerde voorlopige offerte. Geldt alleen bij de stap van voorlopig naar definitief; een herinmeting vraagt altijd akkoord van de klant.',
    },
    auto_win_deal: 'Deal automatisch gewonnen na acceptatie definitief',
    send_proposal_pdf: 'Offerte als PDF-bijlage meesturen',
    send_proposal_pdf_title: 'Offerte-PDF in de mail',
    send_proposal_pdf_help:
      'Voegt een PDF-kopie van de offerte toe aan de e-mail. Zonder bijlage opent de klant de offerte via de knop in de mail, waardoor je ziet wanneer de offerte is bekeken.',
    proposal_price_visibility: 'Prijsweergave op offerte',
    proposal_price_visibility_line_items: 'Alle regelprijzen',
    proposal_price_visibility_main_products: 'Alleen totaal per hoofdproduct',
    proposal_price_visibility_configuration_subtotals: 'Subtotaal per configuratie',
    proposal_price_visibility_grand_total: 'Alleen eindtotaal',
    proposal_price_visibility_inherit: 'Organisatie-standaard',
    planning: {
      tab: 'Planning',
    },
    appointment_email_notice: {
      title: 'Afspraakbevestiging',
      description:
        'Deze tekst verschijnt in de e-mail bij bevestiging, verplaatsing en herinnering van een montageafspraak. Je kunt hem per organisatie aanpassen.',
      label: 'Tekst in afspraakbevestiging',
      variables:
        'Beschikbare variabelen: [lead_first_name], [lead_last_name], [organization_name]',
    },
    deal_email: {
      label: 'Mailen vanuit CRM',
      help: "Verstuur offertes en dealmails vanaf een FunnelFlow-adres (bijv. akogo{'@'}reply.funnelflow.nl) en log antwoorden op de deal. Standaard uit. Vereist een organisatieslug.",
    },
    sender_contact: {
      label: 'Foto en naam van de verzender onder e-mails',
      help: 'Offertemails krijgen altijd een contactblok met foto en naam van de verzender. Zet [handtekening_gebruiker] in de mailtekst om de plek te bepalen; zonder die variabele komt het blok boven de knoppen. Deze schakelaar doet hetzelfde onder overige dealmails.',
      preview: 'Deze handtekening komt onder de mail te staan.',
    },
    api_keys: {
      tab: 'API',
      title: 'API-keys beheren',
      description:
        'Je API-keys authenticeren verzoeken naar FunnelFlow. Houd ze geheim en deel ze niet publiekelijk.',
      generate: 'Nieuwe API-key genereren',
      name_label: 'Naam',
      name_placeholder: 'bijv. Ads Hub',
      create: 'Key aanmaken',
      create_modal_title: 'Nieuwe API-key',
      create_modal_help:
        'Geef de key een herkenbare naam, bijvoorbeeld de integratie waarvoor je hem gebruikt.',
      loading: 'Keys laden…',
      empty_title: 'Nog geen API-keys',
      empty_description: 'Genereer een key om externe systemen te koppelen.',
      status_active: 'Actief',
      status_revoked: 'Ingetrokken',
      created_at: 'Aangemaakt',
      last_used_at: 'Laatst gebruikt',
      revoked_at: 'Ingetrokken',
      show_revoked: 'Ingetrokken keys tonen',
      revoke: 'Intrekken',
      revoke_title: 'API-key intrekken?',
      revoke_description:
        'Key “{name}” wordt direct ongeldig. Integraties die deze key gebruiken stoppen met werken.',
      cancel: 'Annuleren',
      done: 'Klaar',
      copy: 'Kopiëren naar klembord',
      copied_clipboard: 'Gekopieerd naar klembord',
      copy_failed: 'Kopiëren mislukt',
      toggle_visibility: 'Tonen / verbergen',
      copy_once_help:
        'Kopieer de key nu naar je klembord. Dit is de enige keer dat de volledige key zichtbaar is.',
      create_success: 'API-key aangemaakt',
      create_failed: 'API-key aanmaken mislukt',
      fetch_failed: 'API-keys laden mislukt',
      revoke_success: 'API-key ingetrokken',
      revoke_failed: 'API-key intrekken mislukt',
    },
    planning_work_time: {
      title: 'Werktijden planning',
      description:
        'Standaard werktijden voor routeplanning en bulk inplannen. Monteurs kunnen hier binnen gepland worden.',
      workday_start: 'Start werkdag',
      workday_end: 'Einde werkdag',
      break_minutes: 'Pauze tussen klussen (min)',
      timezone: 'Tijdzone',
    },
    planning_customer: {
      title: 'Klantcommunicatie planning',
      description:
        'Wat de klant automatisch ontvangt rond opdracht en afspraak. Alles staat standaard uit; zet alleen aan wat bij jouw werkwijze past.',
      order_confirmation: {
        label: 'Orderbevestiging na akkoord definitieve offerte',
        help: 'Vervangt de standaard "uw getekende voorstel"-mail. De klant ontvangt de specificaties, het totaalbedrag en de ondertekende offerte als PDF.',
        intro_label: 'Introtekst orderbevestiging',
        intro_help: 'Wordt bovenaan de mail getoond, boven de specificaties.',
      },
      preference: {
        label: 'Klant mag planvoorkeur doorgeven',
        help: 'Voegt een knop "Geef uw voorkeur door" toe aan de orderbevestiging. De klant kiest alleen voorkeursdagen en dagdelen (zacht); jij houdt de regie.',
      },
      handshake: {
        label: 'Voorlopige afspraak ter bevestiging naar klant',
        help: 'Bij een voorlopige afspraak ontvangt de klant "Klopt deze afspraak?" met Akkoord / Past niet. "Past niet" wijzigt niets automatisch; de werkbon komt bovenaan de bel-lijst.',
        silent_accept_hours: 'Automatisch akkoord na (uren)',
        silent_accept_help:
          'Geen reactie binnen deze tijd = afspraak bevestigd en de normale afspraakbevestiging gaat uit. 0 = nooit automatisch bevestigen.',
      },
    },
    // Weekly digest e-mail (per user × organisatie)
    weekly_digest: {
      page_title: 'Notificaties',
      page_description: 'Beheer welke e-mailnotificaties je per organisatie ontvangt.',
      section_title: 'Weekoverzicht',
      intro:
        "Het weekoverzicht wordt elke maandagochtend verstuurd en bevat KPI's, prognose, funnel en openstaande offertes. Je stelt dit per organisatie apart in.",
      toggle_label: 'Weekoverzicht per e-mail ontvangen',
      helper:
        "Elke maandagochtend ontvang je een e-mail met KPI's, funnel en openstaande offertes voor {orgName}. Alleen voor deze organisatie.",
      current_org_badge: 'Huidige organisatie',
      switch_to_edit: 'Wissel naar deze organisatie om de instelling te wijzigen.',
      switch_action: 'Wissel & bewerk',
      super_admin_note: 'Super admins ontvangen geen weekoverzicht.',
      status_on: 'Aan',
      status_off: 'Uit',
      save_success: 'Notificatie-instelling bijgewerkt',
      save_error: 'Bijwerken van notificatie-instelling mislukt',
      load_error: 'Kon notificatie-instellingen niet laden',
      switch_success: 'Gewisseld naar {orgName}',
      switch_error: 'Wisselen van organisatie mislukt',
      empty: 'Je bent nog geen lid van een organisatie.',
      roles: {
        owner: 'Eigenaar',
        admin: 'Admin',
        member: 'Medewerker',
        installer: 'Monteur',
        super_admin: 'Super admin',
      },
    },
    // Configurator settings tabs
    tabs: {
      appearance: 'Weergave',
      behaviour: 'Gedrag',
      notifications: 'Notificaties',
      language: 'Taal',
      parameters: 'Parameters',
      products: 'Producten',
      design: 'Design',
      tools: 'Tools',
    },
    forecast: {
      title: 'Forecast & doelen',
      description: 'Stel een jaarlijks omzetdoel in en kies hoe het over de maanden verdeeld wordt',
      year_label: 'Jaar',
      target_configured: 'Doel ingesteld',
      no_target_for_year: 'Nog geen doel ingesteld voor dit jaar',
      annual_target_card: 'Omzetdoel',
      annual_target_help:
        'Stel het verwachte omzetdoel voor dit jaar in. De waarde wordt automatisch verdeeld over de maanden volgens de gekozen strategie.',
      annual_target_label: 'Jaardoel {year} (excl. BTW)',
      annual_target_info: 'Het bedrag dat je verwacht te verkopen in {year} — exclusief BTW',
      notes_label: 'Notitie (optioneel)',
      distribution_card: 'Verdeling over de maanden',
      distribution_help:
        'Bepaal hoe het jaardoel verdeeld wordt over de twaalf maanden. Een seizoens-benchmark werkt goed voor de meeste branches; eigen historische data is altijd accurater.',
      strategy: {
        benchmark: {
          title: 'Op basis van seizoens-benchmark',
          description: 'Gebruik een door SmartFlow gecureerd patroon dat past bij je branche',
          dropdown_label: 'Branche',
        },
        historical: {
          title: 'Op basis van eigen historische data',
          description:
            'Bereken de verdeling uit je eigen geaccepteerde offertes (laatste 24 maanden)',
          fallback:
            '{available} maanden data beschikbaar — bouw nog {needed} maanden op om je eigen patroon te gebruiken. Tot die tijd valt het systeem terug op de benchmark.',
        },
        custom: {
          title: 'Eigen verdeling per maand',
          description:
            'Geef per maand een percentage. Het totaal hoeft niet exact 100% te zijn — wij normaliseren.',
          total_label: 'Totaal',
          normalisation_hint: '(wordt automatisch herschaald naar 100%)',
        },
        flat: {
          title: 'Vlak (1/12 per maand)',
          description: 'Verdeel het jaardoel gelijk over elke maand',
        },
      },
      preview_card: 'Voorbeeld verdeling',
      preview_set_target_first: 'Stel een jaardoel in om de verdeling te zien',
      preview_save_for_historical:
        'Sla het doel eenmaal op om de historische verdeling te previewen',
      preview_peak: 'Piekmaand',
      preview_low: 'Laagste maand',
      preview_pattern: 'Gebruikt patroon',
      save: 'Opslaan',
      cancel: 'Annuleren',
      delete: 'Verwijderen',
      delete_confirm_title: 'Doel verwijderen?',
      delete_confirm_description:
        'Hiermee wordt het omzetdoel voor {year} verwijderd. Het dashboard valt terug op een lege state tot je een nieuw doel instelt.',
      toast: {
        saved: 'Omzetdoel opgeslagen',
        deleted: 'Omzetdoel verwijderd',
      },
      errors: {
        load_failed: 'Kon omzetdoel niet laden',
        save_failed: 'Opslaan mislukt — probeer het opnieuw',
        delete_failed: 'Verwijderen mislukt',
      },
      manual_revenue: {
        card_title: 'Historische omzet',
        help: 'Voeg omzet toe van vóór Funnelflow (excl. BTW). Dit telt mee in Sold en de forecast op het dashboard — er worden geen facturen aangemaakt.',
        note_label: 'Notitie (optioneel)',
        total_label: 'Totaal handmatig',
        save: 'Historische omzet opslaan',
        toast: {
          saved: 'Historische omzet opgeslagen',
        },
        errors: {
          load_failed: 'Kon historische omzet niet laden',
          save_failed: 'Opslaan van historische omzet mislukt',
        },
      },
    },
  },

  // Common UI Elements
  common: {
    session_access_revoked:
      'Je toegang tot deze organisatie is ingetrokken. Neem contact op met de beheerder.',
    session_account_not_provisioned:
      'Je account is nog niet volledig ingesteld. Neem contact op met de beheerder.',
    organization_suspended: {
      title: 'Dit account is opgeschort',
      body: 'Deze organisatie is tijdelijk geblokkeerd. Als dit onterecht is, neem dan contact op met support via {email}.',
      cta: 'Contact opnemen met support',
      mail_subject: 'Account opgeschort',
    },
    anonymous_read_only: 'Anonieme modus is alleen bekijken. Zet de modus uit om iets te wijzigen.',
    add: 'Toevoegen',
    save: 'Opslaan',
    save_changes: 'Wijzigingen opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    confirm: 'Bevestigen',
    create: 'Maken',
    creating: 'Aanmaken...',
    update: 'Bijwerken',
    close: 'Sluiten',
    copy: 'Kopiëren',
    copied: 'Gekopieerd',
    copied_to_clipboard: 'Gekopieerd naar klembord',
    clear_selection: 'Selectie wissen',
    back: 'Terug',
    next: 'Volgende',
    previous: 'Vorige',
    open_full_page: 'Volledige Pagina Openen',
    page_of: 'Pagina {current} van {total}',
    minutes: 'min',
    loading: 'Laden...',
    search: 'Zoeken',
    filter: 'Filteren',
    sort: 'Sorteren',
    actions: 'Acties',
    name: 'Naam',
    description: 'Beschrijving',
    created: 'Gemaakt',
    updated: 'Bijgewerkt',
    status: 'Status',
    yes: 'Ja',
    no: 'Nee',
    confirm: 'Bevestigen',
    success: 'Succes',
    error: 'Fout',
    warning: 'Waarschuwing',
    info: 'Info',
    updated_at: 'Bijgewerkt op',
    created_at: 'Aangemaakt op',
    pull_to_refresh: 'Sleep om te verversen',
    release_to_refresh: 'Laat los om te verversen',
    refreshing: 'Verversen...',
    refresh: 'Vernieuwen',
    add_image: 'Afbeelding toevoegen',
    remove: 'Verwijderen',
    of: 'van',
    // Time related
    today: 'Vandaag',
    yesterday: 'Gisteren',
    tomorrow: 'Morgen',
    just_now: 'Zojuist',
    hours_ago: '{count} uur geleden',
    days_ago: '{count} dagen geleden',
  },

  builder: {
    base: 'Basis',
    label: 'Titel',
    caption: 'Omchrijving',
    answer_required: 'Antwoord is verplicht',
    default_value: 'Standaardwaarde',
  },

  // Scheduling Settings
  scheduling: {
    // Section headers
    calendar_settings: 'Kalender instellingen',
    round_robin: 'Round Robin',
    locations: 'Locaties',
    meeting_settings: 'Afspraak instellingen',
    // Round Robin
    enable_round_robin: 'Round Robin inschakelen',
    round_robin_description: 'Verdeel afspraken automatisch over meerdere teamleden.',
    team_members: 'Teamleden',
    add_member: 'Lid toevoegen',
    no_team_members:
      'Nog geen teamleden toegevoegd. Voeg een Google Calendar integratie toe om te beginnen.',
    display_name: 'Weergavenaam',
    calendar: 'Kalender',
    available_at_locations: 'Beschikbaar op locaties:',
    custom_working_hours: 'Aangepaste werktijden',
    default_availability: 'Standaard beschikbaarheid',
    // Locations
    locations_description:
      'Definieer waar afspraken kunnen plaatsvinden. Teamleden kunnen worden toegewezen aan specifieke locaties.',
    choose_location_type: 'Kies een locatietype',
    name_this_location: 'Naam van deze locatie',
    your_locations: 'Jouw locaties',
    unnamed_location: 'Naamloze locatie',
    add_location: 'Locatie toevoegen',
    add_location_fixed: 'Vast adres toevoegen',
    add_location_custom: 'Huisbezoek toevoegen',
    add_location_online: 'Online locatie toevoegen',
    no_locations: 'Geen locaties gedefinieerd. Afspraken worden gepland zonder locatiekeuze.',
    location_name: 'Locatienaam',
    location_type: 'Type',
    location_address: 'Adres',
    require_location_selection: 'Locatiekeuze verplicht',
    location_types: {
      fixed: 'Vast adres',
      fixed_description: 'Op je eigen adres, zoals een showroom of kantoor',
      online: 'Online meeting',
      online_description: 'Afspraak via videoverbinding',
      custom: 'Huisbezoek',
      custom_description: 'Jij gaat naar het adres van de klant',
    },
    location_type_already_added:
      'Dit type bestaat al in dit formulier. Wil je een andere afdeling of afspraaktype aanbieden? Maak dan een apart formulier.',
    service_regions: 'Servicegebieden',
    service_regions_hint:
      'Postcodes (PC2) waarvoor deze locatie klantbezoeken aanbiedt. Niets gekozen betekent landelijk.',
    member_service_regions: 'Servicegebieden',
    member_service_regions_hint:
      'Geen gebied geselecteerd betekent dat dit teamlid niet meedoet voor deze locatie. Je kunt gebieden van de locatie overnemen of extra PC2-gebieden toevoegen.',
    edit_service_regions: 'Servicegebieden kiezen',
    service_regions_nationwide: 'Landelijk',
    member_service_regions_nationwide_hint:
      'Deze locatie heeft nog geen servicegebieden, dus dit teamlid werkt landelijk. Kies gebieden om het teamlid te beperken.',
    service_regions_none: 'Geen servicegebieden geselecteerd',
    service_regions_summary: '{count} servicegebieden geselecteerd',
    service_regions_search: 'Zoeken',
    service_regions_search_placeholder: 'Zoek op code of plaats',
    service_regions_select_all: 'Alles selecteren',
    service_regions_clear_all: 'Alles deselecteren',
    service_regions_no_results: 'Geen gebieden gevonden.',
    service_regions_selected_count: '{count} geselecteerd',
    service_regions_save: 'Opslaan',
    calendar_link: 'Agenda koppeling',
    multiple_calendars: "Meerdere agenda's (Round Robin)",
    single_calendar_description: 'Alle afspraken worden in één agenda geboekt.',
    select_agenda: 'Selecteer agenda',
    add: 'Toevoegen',
    unnamed: 'Naamloos',
    remove: 'Verwijderen',
    per_location: 'Per locatie',
    per_location_hours: 'Verschillende werktijden per locatie',
    use_location_hours: 'Gebruik locatie openingstijden',
    copy_location_hours: 'Kopieer locatie openingstijden als basis',
    location_hours: 'Locatie',
    slot_settings: 'Slot instellingen',
    appointment_length: 'Afspraakduur',
    buffer_before: 'Buffer voor afspraak',
    buffer_after: 'Buffer na afspraak',
    minimum_advance: 'Minimale boekingstijd vooraf',
    minimum_advance_hint:
      'Hoe ver van tevoren moet een afspraak minimaal geboekt worden? Bij 24 uur kunnen klanten pas boeken voor overmorgen of later.',
    until: 'tot',
    opening_hours: 'Openingstijden',
    opening_hours_hint:
      'Wanneer deze locatie open is. Deze tijden zijn de basis voor de beschikbaarheid per agenda.',
    location_name_placeholder: 'bijv. Showroom, Online, Bij klant',
    location_name_required: 'Geef deze locatie een naam',
    no_calendar_integration:
      'Geen kalenderintegratie (Google of Outlook) is actief voor dit formulier. Schakel eerst een integratie in.',
    none: 'Geen',
    no_buffer: 'Geen buffer',
    minutes: '{count} minuten',
    hour: '{count} uur',
    hours: '{count} uur',
    one_day: '1 dag (24 uur)',
    days: '{count} dagen ({hours} uur)',
    one_week: '1 week (168 uur)',
    meeting_title: 'Titel van de afspraak',
    meeting_body: 'Tekst van de afspraak in de agenda',
    add_meet_link: 'Google Meet-link toevoegen',
    add_address_to_meeting: 'Adres aan de afspraak toevoegen',
    meeting_address: 'Adres van de afspraak',
    meeting_address_placeholder: 'Vul een adres in of kies een adresveld...',
    weekdays: {
      monday: 'Maandag',
      tuesday: 'Dinsdag',
      wednesday: 'Woensdag',
      thursday: 'Donderdag',
      friday: 'Vrijdag',
      saturday: 'Zaterdag',
      sunday: 'Zondag',
    },
    // Address fields
    address: {
      search: 'Adres van de locatie',
      search_placeholder: 'Zoek op straat, huisnummer of postcode',
      searching: 'Zoeken...',
      no_results: 'Geen adres gevonden. Probeer straat en huisnummer of de postcode.',
      required: 'Kies een adres uit de lijst',
      selected: 'Geselecteerd:',
      clear: 'Adres wissen',
      manual_entry: 'Handmatig invoeren',
      street: 'Straat',
      number: 'Nummer',
      postal_code: 'Postcode',
      city: 'Plaats',
      country: 'Land',
    },
    // Legacy/Single calendar
    select_calendar: 'Selecteer kalender integratie',
    no_calendar_warning:
      'Er is momenteel geen Google Calendar integratie ingeschakeld voor dit formulier. Schakel deze eerst in of maak er een aan.',
    setup_modal_title: 'Kalender koppelen',
    setup_modal_description:
      'Kies een bestaande agenda-integratie en selecteer de agenda voor dit scheduler-veld.',
    setup_select_integration: 'Google-integratie',
    setup_select_calendar: 'Agenda',
    setup_select_calendar_placeholder: 'Kies een agenda...',
    setup_no_integrations:
      'Je hebt nog geen agenda gekoppeld. Voeg er een toe via de link hieronder.',
    setup_not_connected:
      'Deze integratie is nog niet verbonden. Open de integratie-instellingen om te koppelen.',
    setup_open_integration_settings: 'Integratie-instellingen openen',
    setup_loading_calendars: 'Agenda\'s laden...',
    setup_integration_required: 'Selecteer een agenda-integratie.',
    setup_calendar_required: 'Selecteer een agenda.',
    setup_save: 'Aanmaken',
    setup_save_failed: 'Kon de kalenderkoppeling niet opslaan. Probeer het opnieuw.',
    setup_load_integrations_failed: 'Kon integraties niet laden.',
    setup_load_calendars_failed: 'Kon agenda\'s niet laden. Controleer de koppeling.',
    setup_create_integration_title: 'Google Calendar-integratie toevoegen',
    setup_create_integration_description:
      'Koppel Google en kies de agenda die je voor afspraken wilt gebruiken.',
    setup_edit_integration_title: 'Integratie {name} bewerken',
    setup_integration_name: 'Naam van de integratie',
    setup_integration_name_placeholder: 'Bijv. Agenda Amsterdam',
    setup_add_calendar_link: 'Agenda toevoegen',
    setup_choose_provider: 'Kies met welke agenda je wilt koppelen.',
    setup_popup_blocked: 'De popup werd geblokkeerd. Sta popups toe en probeer het opnieuw.',
    setup_outlook_unavailable: 'Outlook is tijdelijk niet beschikbaar.',
    setup_back: 'Terug',
    setup_connect_failed: 'Kon de agenda niet koppelen. Probeer het opnieuw.',
    setup_connect_success: '{name} is gekoppeld.',
    setup_edit_integration_description: 'Koppel Google en selecteer de juiste agenda.',
  },

  // Error Messages
  errors: {
    generic: 'Er is iets misgegaan. Probeer het opnieuw.',
    network: 'Netwerkfout. Controleer je verbinding.',
    unauthorized: 'Je bent niet geautoriseerd om deze actie uit te voeren.',
    not_found: 'De gevraagde resource is niet gevonden.',
    validation: 'Controleer je invoer en probeer het opnieuw.',
    required_field: 'Dit veld is verplicht',
    invalid_email: 'Voer een geldig e-mailadres in',
    password_too_short: 'Wachtwoord moet minimaal 8 tekens lang zijn',
    language_update_failed: 'Kon taal niet bijwerken. Probeer het opnieuw.',
  },

  // Success Messages
  success: {
    saved: 'Wijzigingen succesvol opgeslagen',
    created: 'Succesvol aangemaakt',
    updated: 'Succesvol bijgewerkt',
    deleted: 'Succesvol verwijderd',
    language_updated: 'Taal succesvol bijgewerkt',
  },

  // Confirmation Messages
  confirmations: {
    delete: 'Weet je zeker dat je dit item wilt verwijderen?',
    unsaved_changes_title: 'Weet je het zeker?',
    unsaved_changes_leave: 'Pagina verlaten',
    unsaved_changes_stay: 'Blijven bewerken',
    unsaved_changes: 'Je hebt niet-opgeslagen wijzigingen. Weet je zeker dat je wilt vertrekken?',
  },

  // Date & Time
  date: {
    today: 'Vandaag',
    yesterday: 'Gisteren',
    tomorrow: 'Morgen',
    this_week: 'Deze week',
    this_month: 'Deze maand',
    last_month: 'Vorige maand',
    just_now: 'Zojuist',
    hours_ago: '{count} uur geleden',
    days_ago: '{count} dagen geleden',
    formats: {
      short: 'DD-MM-YYYY',
      long: 'D MMMM YYYY',
      time: 'HH:mm',
      datetime: 'DD-MM-YYYY HH:mm',
    },
  },

  conditions: {
    when_statement_true: 'Wanneer de volgende voorwaarde waar is',
    when: 'Wanneer',
    all: 'ALLE',
    any: 'ÉÉN VAN',
    of_following_true: 'van de volgende waar zijn',
    where: 'Waar',
    select_field: 'Selecteer veld',
    equals: 'Is gelijk aan',
    not_equals: 'Is niet gelijk aan',
    greater_than: 'Groter dan',
    greater_or_equal: 'Groter of gelijk aan',
    less_than: 'Kleiner dan',
    less_or_equal: 'Kleiner of gelijk aan',
    select_value: 'Selecteer waarde',
    true: 'Waar',
    false: 'Onwaar',
    enter_number: 'Voer nummer in',
    enter_value: 'Voer waarde in',
    add_filter: 'Filter toevoegen',
    add_group: 'Groep toevoegen',
  },

  // Authentication
  auth: {
    welcome_back: 'Welkom terug!',
    login_subtitle: 'Log in om verder te gaan met je leads, deals en offertes.',
    or: 'of',
    google_sign_in: 'Inloggen met Google',
    google_connect_calendar: 'Google Agenda koppelen',
    google_connected: 'Gekoppeld met Google',
    google_disconnect: 'Ontkoppelen',
    showcase_configurator_title: 'Klanten stellen zelf hun product samen',
    showcase_configurator_description:
      'Je klant ziet direct een prijsindicatie en jij krijgt een complete aanvraag binnen.',
    showcase_pipeline_title: 'Elke aanvraag overzichtelijk in één overzicht',
    showcase_pipeline_description:
      'Zie per fase welke aanvragen aandacht nodig hebben en wie ermee bezig is.',
    showcase_proposals_title: 'Al je offertes in één overzicht',
    showcase_proposals_description:
      'Zie direct welke offertes bekeken, geaccepteerd of nog niet geopend zijn.',
    showcase_planning_title: 'Inmetingen en montages in één agenda',
    showcase_planning_description:
      'Plan je monteurs per week en zie direct hoeveel omzet er ingepland staat.',
    showcase_pro_forma_title: 'Van pro forma naar definitief zonder overtypen',
    showcase_pro_forma_description:
      'Na de inmeting maak je met één klik de definitieve offerte, met de echte maten en een herberekende prijs.',
    showcase_work_order_title: 'Je monteur weet precies wat er moet gebeuren',
    showcase_work_order_description:
      'Planning, adres en pakbon op één werkbon. Je klant krijgt automatisch een update.',
    no_account: 'Nog geen account?',
    create_account: 'Maak er vandaag een aan!',
    email: 'E-mailadres',
    password: 'Wachtwoord',
    forgot_password: 'Wachtwoord vergeten?',
    sign_in: 'Inloggen',
    login_error_title: 'Inloggen mislukt',
    login_error_description: 'Kan niet inloggen. Probeer het opnieuw.',
    no_organization_title: 'Geen toegang',
    no_organization_description:
      'Je account is niet (meer) gekoppeld aan een organisatie. Neem contact op met de beheerder.',
    accept_invite_success_title: 'Gelukt!',
    accept_invite_success_description: 'Je bent toegevoegd aan de organisatie.',
    accept_invite_failed_title: 'Uitnodiging accepteren mislukt',
    accept_invite_failed_description:
      'Er ging iets mis bij het accepteren van de uitnodiging. Probeer het opnieuw.',
    accept_invite_email_mismatch:
      'Deze uitnodiging is voor een ander e-mailadres. Log in met het account waarnaar de uitnodiging is verstuurd.',
    reset_email_required_title: 'E-mailadres vereist',
    reset_email_required_description: 'Voer je e-mailadres in om je wachtwoord te resetten.',
    reset_rate_limit_title: 'Te veel pogingen',
    reset_rate_limit_description: 'Wacht een paar minuten voordat je het opnieuw probeert.',
    reset_error_title: 'Fout',
    reset_error_description:
      'Kan wachtwoord niet resetten. Controleer je e-mailadres en probeer het opnieuw.',
    reset_sent_title: 'Resetlink verzonden',
    reset_sent_description:
      'Controleer je e-mail om je wachtwoord te resetten. Staat het er niet bij? Kijk dan in je spammap.',
  },

  // Invoices
  invoices: {
    title: 'Facturen',
    description: 'Beheer al je facturen, betalingen en creditnota’s op één plek.',
    tabs: {
      drafts: 'Concepten',
    },
    add_invoice: 'Factuur maken',
    untitled: 'Factuur',
    due: 'Verloopt',
    overdue_by_day: '{n} dag over datum',
    overdue_by_days: '{n} dagen over datum',
    search_placeholder: 'Zoek op factuurnummer of klant…',
    search_no_results: 'Geen resultaten gevonden',
    search_no_results_description: 'Probeer een andere zoekopdracht of wis de filters.',
    no_more_results: 'Alle facturen geladen',
    stats_toggle: 'Statistieken',
    bulk_delete: 'Verwijder selectie ({count})',
    bulk_delete_no_drafts: 'Alleen concepten kunnen worden verwijderd.',
    bulk_delete_title: 'Geselecteerde concepten verwijderen',
    bulk_delete_confirmation: 'Weet je zeker dat je {count} conceptfactu(u)r(en) wilt verwijderen?',
    bulk_delete_skipped: 'Niet-concepten ({count}) worden overgeslagen.',
    bulk_delete_success: '{count} factu(u)r(en) verwijderd.',
    bulk_delete_partial_failure: '{count} factu(u)r(en) konden niet worden verwijderd.',
    bulk_delete_error: 'Bulk verwijderen mislukt.',
    bulk_remind: 'Herinnering sturen ({count})',
    bulk_remind_title: 'Herinnering sturen',
    bulk_remind_confirmation: 'Wil je een betalingsherinnering sturen voor {count} factuur(en)?',
    bulk_remind_skipped: 'Niet-herinnerbare facturen ({count}) worden overgeslagen.',
    bulk_remind_success: 'Herinnering verstuurd voor {count} factuur(en).',
    bulk_remind_partial_failure: '{count} herinnering(en) konden niet worden verstuurd.',
    bulk_remind_error: 'Herinneringen versturen mislukt.',
    bulk_remind_none: 'Selecteer openstaande facturen om een herinnering te sturen.',
    remind_title: 'Herinnering sturen',
    remind_confirmation: 'Wil je een betalingsherinnering sturen voor factuur {number}?',
    remind_success: 'Herinnering verstuurd.',
    remind_error: 'Herinnering versturen mislukt.',
    remind_no_email: 'Deze factuur heeft geen e-mailadres.',
    remind_no_balance: 'Deze factuur heeft geen openstaand bedrag.',

    statuses: {
      draft: 'Concept',
      sending: 'Wordt verzonden',
      sent: 'Verzonden',
      viewed: 'Bekeken',
      partially_paid: 'Deels betaald',
      paid: 'Betaald',
      overdue: 'Achterstallig',
      cancelled: 'Geannuleerd',
      credit_note_issued: 'Creditnota uitgegeven',
    },

    types: {
      full: 'Volledig',
      deposit: 'Aanbetaling',
      partial: 'Deelfactuur',
      final: 'Eindfactuur',
      credit_note: 'Creditnota',
      proforma: 'Proforma',
    },

    columns: {
      number: 'Nummer',
      type: 'Type',
      status: 'Status',
      customer: 'Klant',
      invoice_date: 'Factuurdatum',
      due_date: 'Vervaldatum',
      amount: 'Bedrag',
      balance_due: 'Openstaand',
    },

    filter: {
      status: 'Status',
      type: 'Type',
      all: 'Alle',
      open: 'Openstaand',
      other: 'Overig',
      filter_by_status: 'Filter op status',
      filter_by_type: 'Filter op type',
      reset: 'Reset',
      types_short: {
        full: 'Factuur',
        deposit: 'Aanbetaling',
        partial: 'Deelfactuur',
        final: 'Eindfactuur',
        credit_note: 'Credit',
        proforma: 'Proforma',
      },
    },

    stats: {
      total_invoiced: 'Totaal gefactureerd',
      total_paid: 'Totaal betaald',
      total_outstanding: 'Openstaand',
      total_overdue: 'Achterstallig',
      total_to_refund: 'Terug te betalen',
      avg_days_to_paid: 'Gem. betaaldagen',
    },

    empty_state: {
      title: 'Nog geen facturen',
      description: 'Maak je eerste factuur om te starten met factureren.',
    },

    create: {
      title: 'Factuur maken',
      lead: 'Klant',
      select_lead: 'Selecteer een klant',
      lead_required: 'Selecteer een klant.',
      project: 'Project',
      select_project: 'Selecteer een project',
      project_required: 'Selecteer eerst een project.',
      no_projects_for_lead: 'Deze klant heeft nog geen actieve projecten.',
      billable_items: 'Te factureren items',
      items_summary: '{available} van {total} items beschikbaar',
      no_billable_items: 'Geen items om te factureren voor dit project.',
      already_billed_in: 'Reeds gefactureerd in {number}',
      billable_items_error: 'Kon factureerbare items niet laden.',
      additional_items: 'Extra regels',
      additional_items_hint: 'Alleen kortingen, toeslagen of tekstregels toegestaan.',
      add_additional: 'Regel toevoegen',
      additional_type: 'Type',
      types: {
        discount: 'Korting',
        surcharge: 'Toeslag',
        text: 'Tekst',
      },
      invoice_type: 'Type',
      currency: 'Valuta',
      invoice_date: 'Factuurdatum',
      due_date: 'Vervaldatum',
      customer_reference: 'Uw kenmerk',
      customer_reference_placeholder: 'Bijv. PO-00297',
      items: 'Factuurregels',
      items_required: 'Selecteer minimaal één item of voeg een extra regel toe.',
      client_notes: 'Opmerkingen voor klant',
      client_notes_placeholder: 'Eventuele opmerkingen die op de factuur komen…',
      internal_notes: 'Interne notities',
      internal_notes_placeholder: 'Niet zichtbaar voor de klant…',
      create_invoice: 'Factuur maken',
      success: 'Factuur succesvol aangemaakt.',
      error: 'Kon factuur niet aanmaken.',
      errors: {
        project_required: 'Selecteer eerst een project.',
        item_already_billed:
          'Een of meer items zijn al gefactureerd. De lijst is bijgewerkt — probeer opnieuw.',
      },
    },

    merge: {
      title: 'Concepten samenvoegen',
      button: 'Samenvoegen ({count})',
      intro:
        'Voeg meerdere conceptfacturen voor dezelfde klant samen tot één nieuwe conceptfactuur.',
      lead: 'Klant',
      submit: 'Samenvoegen ({count})',
      no_drafts: 'Geen samenvoegbare conceptfacturen voor deze klant.',
      load_error: 'Kon concepten niet laden.',
      success: 'Conceptfacturen samengevoegd.',
      error: 'Samenvoegen mislukt.',
      different_leads: 'Selecteer alleen concepten van dezelfde klant.',
    },

    detail: {
      title: 'Factuur',
      hidden_line_badge: 'Verborgen',
      hidden_line_hint:
        'Dit bedrag wordt gefactureerd, maar niet als aparte regel: het zit verwerkt in de prijs van het eerste product met hetzelfde btw-tarief op de factuur-PDF en de betaalpagina.',
      not_found: 'Factuur niet gevonden',
      not_found_description: 'Deze factuur bestaat niet of je hebt geen toegang.',
      load_error: 'Kon de factuur niet laden.',
      download_pdf: 'PDF downloaden',
      send: 'Verzenden',
      resend: 'Opnieuw verzenden',
      send_reminder: 'Herinnering sturen',
      record_payment: 'Betaling registreren',
      mark_sent: 'Markeer als verzonden',
      mark_paid: 'Markeer als betaald',
      marked_sent: 'Factuur gemarkeerd als verzonden.',
      change_status: 'Status wijzigen',
      extra: 'Extra',
      view_online: 'Online bekijken',
      view_project: 'Bekijk project',
      view_proposal: 'Bekijk offerte',
      public_url_unavailable: 'Geen publieke link beschikbaar voor deze factuur.',
      edit: 'Bewerken',
      edit_not_implemented: 'Bewerken is nog niet beschikbaar.',
      credit_note: 'Creditnota maken',
      delete: 'Verwijderen',
      delete_title: 'Concept verwijderen',
      delete_description: 'Weet je zeker dat je dit concept wilt verwijderen?',
      deleted: 'Concept verwijderd.',
      delete_error: 'Verwijderen mislukt.',
      cancel_invoice: 'Factuur annuleren',
      cancel_title: 'Factuur annuleren',
      cancel_description: 'Weet je zeker dat je deze factuur wilt annuleren?',
      cancel_reason_label: 'Reden',
      cancel_reason_placeholder: 'Optionele reden…',
      cancelled: 'Factuur geannuleerd.',
      cancel_error: 'Annuleren mislukt.',
      cancellation_reason: 'Annuleringsreden',
      has_credit_note: 'Heeft creditnota',
      credits_invoice: 'Crediteert factuur',
      locked: 'Deze factuur is vergrendeld en kan niet meer worden bewerkt.',
      total: 'Totaal',
      balance_due: 'Openstaand',
      days_until_due: 'dagen tot vervaldag',
      days_overdue: 'dagen achterstallig',
      customer: 'Klantgegevens',
      customer_name: 'Naam',
      company: 'Bedrijf',
      kvk: 'KVK',
      vat_number: 'BTW-nummer',
      email: 'E-mail',
      phone: 'Telefoon',
      address: 'Adres',
      vat_reverse_charge: 'BTW verlegd',
      items: 'Factuurregels',
      totals: 'Totalen',
      vat: 'BTW',
      discount: 'Korting',
      deposit_deduction: 'Aanbetaling verrekend',
      client_notes: 'Opmerkingen voor klant',
      internal_notes: 'Interne notities',
      internal_notes_placeholder: 'Niet zichtbaar voor de klant…',
      no_internal_notes: 'Geen notities',
      notes_saved: 'Notities opgeslagen.',
      dates_saved: 'Datums opgeslagen.',
      payment_terms: 'Betaaltermijn',
      payment_term_label: 'Betaaltermijn (dagen)',
      days_unit: 'dagen',
      info: 'Factuurinformatie',
      invoice_number: 'Factuurnummer',
      invoice_date: 'Factuurdatum',
      due_date: 'Vervaldatum',
      customer_reference: 'Uw kenmerk',
      no_customer_reference: 'Geen kenmerk',
      customer_reference_saved: 'Kenmerk opgeslagen.',
      price_visibility: 'Prijsweergave voor klant',
      price_visibility_inherit: 'Zoals de offerte',
      price_visibility_line_items: 'Alle regelprijzen',
      price_visibility_main_products: 'Alleen totaal per hoofdproduct',
      price_visibility_configuration_subtotals: 'Subtotaal per configuratie',
      price_visibility_grand_total: 'Alleen eindtotaal',
      price_visibility_saved: 'Prijsweergave opgeslagen.',
      price_visibility_save_failed: 'Prijsweergave opslaan mislukt.',
      price_visibility_internal_hint: 'Je ziet hier alle prijzen. De klant ziet: {mode}.',
      sent_at: 'Verzonden op',
      viewed_at: 'Bekeken op',
      paid_at: 'Betaald op',
      project: 'Project',
      proposal: 'Offerte',
      payments: 'Betalingen',
      history: 'Statusgeschiedenis',
      activities: 'Activiteit',
      activity: {
        created: 'Concept aangemaakt',
        sent: 'Verzonden naar klant',
        viewed: 'Bekeken door klant',
        payment_received: 'Betaling ontvangen ({amount})',
        paid: 'Volledig betaald',
        cancelled: 'Geannuleerd',
        credit_note_issued: 'Creditnota uitgegeven',
        reminder_sent: 'Herinnering verstuurd naar {recipient}',
        reminder_sent_generic: 'Herinnering verstuurd',
        reminder_sent_count: '{count} herinneringen verstuurd',
      },
      reminders: 'Herinneringen',
      reminders_sent: 'Herinneringen verstuurd',
      last_reminder: 'Laatste herinnering',
      pdf_error: 'Kon PDF niet downloaden.',
      to: 'Aan',
      notes_label: 'Opmerkingen',
      total_due: 'Totaal te voldoen',
      transfer_to: 'Over te maken op',
      payment_reference: 'Onder vermelding van',
      pay_before: 'Te voldoen voor',
      reference_subtitle: 'Factuurkenmerk',
      payment_term_days: 'Betaaltermijn {days} dagen',
      account_holder: 't.n.v. {name}',
    },

    editor: {
      description: 'Omschrijving',
      description_placeholder: 'Bijv. Installatie zonnepanelen',
      quantity: 'Aantal',
      unit_price: 'Prijs per stuk',
      vat_rate: 'BTW',
      line_total: 'Regeltotaal',
      no_items: 'Nog geen regels toegevoegd.',
      add_line: 'Regel toevoegen',
      subtotal_excl_vat: 'Subtotaal excl. BTW',
      vat_amount: 'BTW',
      total: 'Totaal incl. BTW',
      prices_include_vat: 'Prijzen zijn inclusief BTW',
    },

    payments: {
      record_payment: 'Betaling registreren',
      invoice_number: 'Factuurnummer',
      total_amount: 'Factuurbedrag',
      already_paid: 'Reeds betaald',
      balance_due: 'Openstaand',
      amount: 'Bedrag',
      amount_required: 'Voer een geldig bedrag in.',
      payment_date: 'Betaaldatum',
      payment_method: 'Betaalmethode',
      reference: 'Referentie',
      reference_placeholder: 'Bijv. transactienummer',
      notes: 'Notities',
      notes_placeholder: 'Optionele notities…',
      full_balance: 'Vul openstaand bedrag',
      success: 'Betaling geregistreerd.',
      error: 'Kon betaling niet registreren.',
      delete: 'Verwijder betaling',
      delete_title: 'Betaling verwijderen',
      delete_description: 'Weet je zeker dat je de betaling van {amount} wilt verwijderen?',
      deleted: 'Betaling verwijderd.',
      empty: 'Nog geen betalingen geregistreerd.',
      methods: {
        bank_transfer: 'Bankoverschrijving',
        cash: 'Contant',
        card: 'Pin/Creditcard',
        mollie_ideal: 'iDEAL (Mollie)',
        mollie_qr: 'QR (Mollie)',
        mollie_pos: 'POS (Mollie)',
        mollie_other: 'Mollie',
        other: 'Anders',
        credit_note: 'Verrekend met creditnota',
      },
    },

    send: {
      title: 'Factuur verzenden',
      intro: 'Verzend factuur {number} per e-mail.',
      resend_intro:
        'Verstuur factuur {number} nogmaals met de originele factuurmail. De status blijft ongewijzigd.',
      resent_success: 'Factuur wordt opnieuw verstuurd.',
      to: 'Aan',
      to_placeholder: "klant{'@'}voorbeeld.nl",
      subject: 'Onderwerp',
      subject_placeholder: 'Leeg laten voor het standaardonderwerp',
      message: 'Bericht',
      message_placeholder: 'Leeg laten voor de standaardtekst',
      message_hint:
        'Je bericht vervangt de standaardtekst. De knoppen "Bekijk factuur" en "Betaal nu" worden altijd toegevoegd.',
      bcc_hint: 'BCC naar {emails} (instellingen facturatie)',
      review: 'Controleren en versturen',
      preview_failed: 'Voorbeeld kon niet worden opgehaald',
      number_pending: 'Het factuurnummer wordt toegekend bij verzending.',
      invoice_pdf_badge: 'Factuur',
      invoice_pdf_pending: 'wordt gegenereerd bij versturen',
      default_attachment_badge: 'Standaard',
      submit: 'Verzenden',
      success: 'Factuur verzonden.',
      error: 'Versturen mislukt — probeer opnieuw.',
      sending: 'Factuur wordt verzonden…',
      pending_banner: 'Factuur wordt verzonden. Dit duurt meestal enkele seconden.',
      taking_longer: 'Verzending duurt langer dan gewoonlijk. Controleer later de factuurstatus.',
      status_unknown: 'Status van de verzending kon niet worden opgehaald.',
    },

    credit_note: {
      title: 'Creditnota maken',
      intro: 'Maak een creditnota voor factuur {number}.',
      reason: 'Reden',
      reason_placeholder: 'Geef een reden op voor de creditnota…',
      full: 'Volledige creditnota',
      full_description: 'Crediteer het volledige bedrag van deze factuur.',
      partial: 'Gedeeltelijke creditnota',
      partial_description: 'Crediteer specifieke regels of bedragen.',
      items: 'Te crediteren regels',
      reason_required: 'Vul een reden in voor de creditnota.',
      items_required: 'Voeg minimaal één regel toe met omschrijving en aantal.',
      project_effect: 'Wat gebeurt er met het project?',
      reinvoice: 'Opnieuw te factureren',
      reinvoice_description:
        'Het gecrediteerde bedrag blijft openstaan op het project en kun je opnieuw factureren.',
      write_off: 'Afboeken op het project',
      write_off_description:
        'Dit bedrag wordt niet opnieuw gefactureerd (bijv. al via een ander pakket gefactureerd). Het projectbedrag daalt mee, dus het komt niet terug bij "Nog te factureren".',
      create: 'Creditnota maken',
      send_email: 'Creditnota e-mailen naar {email}',
      issued_immediately:
        'De creditnota krijgt direct een nummer en wordt definitief. De factuur staat daarna niet meer open.',
      success: 'Creditnota {number} uitgegeven.',
      success_sent: 'Creditnota {number} uitgegeven en wordt verstuurd.',
      success_email_failed:
        'Creditnota {number} is uitgegeven, maar de e-mail kon niet worden verstuurd. Verstuur hem later opnieuw.',
      error: 'Kon creditnota niet aanmaken.',
      negative_invoice:
        'Een factuur kan geen negatief totaal hebben. Gebruik "Crediteren" op de oorspronkelijke factuur.',
    },

    email_warning: {
      short: 'E-mail niet afgeleverd',
      banner: 'De e-mail met deze factuur is niet bij de klant aangekomen.',
      resend: 'Opnieuw versturen',
    },

    deposit: {
      title: 'Aanbetalingsfactuur maken',
      intro: 'Maak een aanbetalingsfactuur voor dit project.',
      use_settings: 'Gebruik instellingen',
      use_settings_description: 'Gebruik de standaard aanbetaling vanuit organisatie-instellingen.',
      percentage: 'Percentage',
      percentage_description: 'Specificeer een percentage van het projectbedrag.',
      percentage_label: 'Percentage (%)',
      amount: 'Vast bedrag',
      amount_description: 'Specificeer een vast bedrag.',
      amount_label: 'Bedrag',
      create: 'Aanbetalingsfactuur maken',
      success: 'Aanbetalingsfactuur aangemaakt.',
      error: 'Kon aanbetalingsfactuur niet aanmaken.',
    },

    project_summary: {
      title: 'Facturatie',
      create_invoice: 'Factuur maken',
      deposit: 'Aanbetalingsfactuur',
      deposit_description: 'Vraag een aanbetaling vóór aanvang van het werk.',
      final: 'Eindfactuur',
      final_description: 'Sluit het project af met een eindfactuur.',
      custom: 'Custom factuur',
      custom_description: 'Maak handmatig een factuur voor dit project.',
      project_total: 'Projectbedrag',
      provisional_project_total: 'Voorlopig projectbedrag',
      provisional_project_total_hint: 'Op basis van de voorlopige offerte.',
      proforma_zero_hint: 'Voorlopige offerte, daarom €0.',
      written_off_hint: 'Na afboeking van {amount}',
      over_invoiced_hint: '{amount} te veel gefactureerd',
      write_off: 'Bedrag afboeken',
      write_off_description: 'Boek (een deel van) het restant af, bijv. contant betaald.',
      write_off_title: 'Bedrag afboeken',
      write_off_intro:
        'Het afgeboekte bedrag gaat van het projectbedrag af en komt niet meer op een factuur.',
      write_off_amount_label: 'Bedrag (incl. btw)',
      write_off_amount_hint: 'Nog te factureren: {amount} incl. btw',
      write_off_amount_invalid: 'Vul een bedrag groter dan € 0 in.',
      write_off_amount_too_high: 'Je kunt maximaal {amount} incl. btw afboeken.',
      write_off_result_full:
        'Het volledige restant van {amount} incl. btw wordt afgeboekt. Er blijft niets over om te factureren.',
      write_off_result_partial:
        '{amount} incl. btw wordt afgeboekt. De overige {rest} incl. btw kun je later gewoon factureren.',
      write_off_reason_label: 'Reden',
      write_off_reason_placeholder: 'Bijv. contant betaald',
      write_off_submit: 'Afboeken',
      write_off_success: 'Bedrag afgeboekt.',
      excl_vat: 'excl. btw',
      incl_vat: 'incl. btw',
      invoiced: 'Gefactureerd',
      paid: 'Betaald',
      outstanding: 'Openstaand',
      remaining_to_invoice: 'Nog te factureren',
      paid_short: 'Betaald',
      empty: 'Nog geen facturen',
      empty_description: 'Maak een aanbetalings- of eindfactuur om te starten.',
      cannot_create_final: 'Eindfactuur kan nog niet worden aangemaakt.',
      create_final_title: 'Eindfactuur maken',
      create_final_description:
        'De eindfactuur wordt gemaakt op basis van het projecttotaal minus eerder gefactureerde bedragen.',
      create_final: 'Eindfactuur maken',
      final_created: 'Eindfactuur aangemaakt.',
    },

    public: {
      invoice: 'Factuur',
      number: 'Factuurnummer',
      date: 'Datum',
      due_date: 'Vervaldatum',
      bill_to: 'Factuur aan',
      vat_reverse_charge: 'BTW verlegd',
      notes: 'Opmerkingen',
      payment_instructions: 'Betalingsinstructies',
      not_found: 'Factuur niet gevonden',
      not_found_description: 'Deze link is verlopen of de factuur is niet langer beschikbaar.',
    },

    settings: {
      title: 'Facturatie-instellingen',
      description: 'Beheer hoe facturen worden aangemaakt, genummerd en verzonden.',
      numbering: 'Factuurnummering',
      numbering_description:
        'Bepaal hoe nieuwe factuurnummers worden gegenereerd. Volgnummers lopen door bij wijziging.',
      numbering_preview: 'Voorbeeld:',
      invoice_number_prefix: 'Voorvoegsel',
      invoice_number_prefix_placeholder: 'F',
      invoice_number_prefix_help: 'Bijv. F, INV of leeg laten voor geen voorvoegsel.',
      invoice_number_padding: 'Aantal cijfers',
      invoice_number_padding_help: '4 = 0001, 6 = 000001. Tussen 1 en 10.',
      invoice_number_include_year: 'Jaartal opnemen in factuurnummer',
      invoice_number_include_year_help:
        'Bij activering wordt het jaartal in het nummer gezet (bijv. F-2026-0001) en reset de teller bij elke jaarwisseling.',
      defaults: 'Standaardwaarden',
      payment_term_days: 'Standaard betaaltermijn (dagen)',
      default_vat_rate: 'Standaard BTW-percentage',
      default_currency: 'Standaard valuta',
      prices_include_vat_default: 'Prijzen standaard inclusief BTW',
      deposit: 'Aanbetalingen',
      deposit_enabled: 'Aanbetalingsfacturen inschakelen',
      deposit_trigger_moment: 'Trigger',
      deposit_percentage: 'Aanbetalingspercentage (%)',
      deposit_tiers: 'Staffels',
      deposit_tiers_help:
        'Hoger percentage vanaf een orderbedrag (incl. btw). Daaronder geldt het aanbetalingspercentage. Een verkooporder zonder offerte krijgt direct een concept-aanbetaling.',
      deposit_tier_min_amount: 'Vanaf (€ incl. btw)',
      deposit_tier_percentage: 'Percentage (%)',
      deposit_tier_add: 'Staffel toevoegen',
      deposit_tier_remove: 'Staffel verwijderen',
      deposit_fixed_amount: 'Vast aanbetalingsbedrag',
      deposit_auto_send: 'Automatisch verzenden',
      deposit_trigger: {
        proforma_accepted: 'Bij geaccepteerde voorlopige offerte',
        definitive_accepted: 'Bij geaccepteerde definitieve offerte',
      },
      deposit_layout: 'Layout aanbetalingsfactuur',
      deposit_layout_help:
        'Bepaal hoe de regels op een aanbetalingsfactuur worden weergegeven. Het totaalbedrag blijft altijd correct.',
      deposit_layout_recommended: 'Aanbevolen',
      deposit_layout_itemized_title: 'Regels zoals offerte',
      deposit_layout_itemized_description:
        'Zelfde regels als de offerte, met bedragen naar rato van de aanbetaling. Meest herkenbaar voor de klant.',
      deposit_layout_detailed_title: 'Uitgebreid',
      deposit_layout_detailed_description:
        'Toelichting met de werkzaamheden, gevolgd door één regel per BTW-tarief.',
      deposit_layout_per_vat_rate_title: 'Compact per BTW-tarief',
      deposit_layout_per_vat_rate_description:
        'Eén regel per BTW-tarief, zonder toelichtingsblok. BTW-correct en compact.',
      deposit_layout_simple_title: 'Eén regel',
      deposit_layout_simple_description:
        'Eén regel op het dominante BTW-tarief. Handig bij projecten met één tarief; bij gemengde tarieven niet BTW-correct.',
      deposit_description_template: 'Omschrijving template',
      deposit_description_template_placeholder:
        'Aanbetaling {percentage}% conform offerte {proposal_number}',
      deposit_description_template_help:
        'Gebruik de placeholders {percentage}, {proposal_number}, {project_number} en {vat_rate}. Leeg laten voor de standaardtekst.',
      deposit_description_preview: 'Voorbeeld:',
      final_invoice: 'Eindfactuur',
      final_invoice_trigger: 'Trigger',
      final_invoice_auto_send: 'Automatisch verzenden',
      final_trigger: {
        disabled: 'Uitgeschakeld',
        manual_only: 'Alleen handmatig',
        project_completed: 'Bij voltooid project',
        work_order_completed: 'Wanneer de montage klaar is',
      },
      requires_slim_werken: 'Sommige opties vereisen Slim Werken.',
      requires_slim_innen: 'Sommige opties vereisen Slim Innen.',
      definitive_deviation: 'Afwijking definitieve offerte',
      price_deviation_moved:
        'Of de afgesproken prijs na de inmeting blijft staan, stel je in onder Instellingen → Organisatie → Offertes → Prijsafwijking na inmeting.',
      warn_on_definitive_deviation: 'Waarschuwen bij afwijking van definitieve offerte',
      reminders: 'Herinneringen',
      reminders_enabled: 'Automatische herinneringen inschakelen',
      public_payment: 'Online betalen',
      public_payment_enabled: 'Online betalen via publieke link',
      merging: 'Concepten samenvoegen',
      allow_invoice_merging: 'Concepten samenvoegen toestaan',
      allow_invoice_merging_description:
        'Sta toe dat meerdere conceptfacturen voor dezelfde klant samengevoegd kunnen worden tot één nieuwe conceptfactuur.',
      template: 'Sjabloon',
      payment_instructions: 'Betalingsinstructies',
      payment_instructions_placeholder: 'Tekst die op iedere factuur verschijnt…',
      footer_text: 'Voettekst',
      footer_text_placeholder: 'Optionele voettekst onderaan elke factuur…',
      default_attachments: 'Standaard bijlagen',
      default_attachments_help:
        "Deze PDF's worden meegestuurd met elke factuur-e-mail (ook bij opnieuw verzenden), bijv. algemene voorwaarden. Niet bij herinneringen en creditnota's.",
      add_attachment: 'PDF toevoegen',
      remove_attachment: 'Bijlage verwijderen',
      attachment_only_pdf: 'Alleen PDF-bestanden zijn toegestaan',
      attachment_too_large: '{name} is te groot (maximaal 5MB)',
      attachment_added: 'Bijlage toegevoegd',
      attachment_removed: 'Bijlage verwijderd',
      attachment_save_error: 'Opslaan van bijlage mislukt',
      bcc: 'BCC bij eerste verzending',
      bcc_help:
        'Deze adressen ontvangen een verborgen kopie (BCC) van de factuur bij de eerste verzending. Niet bij opnieuw verzenden of herinneringen. Bij een Basecone-adres komt [VRK] in het onderwerp, zodat de factuur in het verkoopdagboek belandt.',
      bcc_emails: 'BCC e-mailadressen',
      bcc_emails_placeholder: "boekhouding{'@'}bedrijf.nl",
      load_error: 'Kon instellingen niet laden.',
      saved: 'Instellingen opgeslagen.',
      save_error: 'Kon instellingen niet opslaan.',
    },

    payment_link: {
      generate: 'Genereer betaallink',
      title: 'Mollie betaallink',
      intro:
        'Deel deze betaallink of QR-code met de klant. De klant kan direct betalen via Mollie.',
      qr_label: 'Scan om te betalen',
      scan_with_camera: 'Scan met de camera van je telefoon',
      scan_not_bank_app:
        'Open de camera-app en richt op de code. De scanner in je bankapp herkent deze code niet.',
      copy_link: 'Kopieer link',
      copy_success: 'Link gekopieerd.',
      open_link: 'Open in nieuw tabblad',
      expires_at: 'Geldig tot {date}',
      generating: 'Bezig met aanmaken…',
      regenerate: 'Nieuwe link aanmaken',
      error: 'Kon de betaallink niet aanmaken.',
      not_connected_cta: 'Beheer Mollie',
      requires_mollie: 'Verbind eerst Mollie om betaallinks te kunnen aanmaken.',
    },
  },

  // ===========================================================================
  // Mollie / Slim Innen
  // ===========================================================================
  mollie: {
    name: 'Mollie',
    description: 'Laat klanten online betalen via iDEAL, creditcard en meer.',
    badge_test: 'TEST',
    license_required_title: 'Slim Innen vereist',
    license_required:
      'Mollie is alleen beschikbaar binnen de module Slim Innen. Activeer de licentie om online betalen in te schakelen.',

    status: {
      connected: 'Verbonden',
      not_connected: 'Niet verbonden',
      profile: 'Mollie profiel',
      organization: 'Mollie organisatie',
      mode: 'Modus',
      mode_live: 'Live',
      mode_test: 'Test',
      connected_at: 'Verbonden op',
      can_accept_live_payments: 'Kan live betalingen ontvangen',
      kyc_pending: 'Mollie verifieert je gegevens',
      kyc_pending_description:
        'Klanten kunnen nog niet betalen — Mollie moet eerst je organisatie verifiëren. Dit duurt meestal enkele werkdagen.',
      onboarding_incomplete: 'Mollie onboarding nog niet compleet',
      onboarding_incomplete_description:
        'Mollie heeft je onboarding nog niet afgerond. Open Mollie en vul de ontbrekende gegevens in.',
      onboarding_open_link: 'Open Mollie dashboard',
    },

    actions: {
      connect: 'Verbind met Mollie',
      reconnect: 'Opnieuw verbinden',
      manage: 'Beheer Mollie',
      disconnect: 'Verbinding verbreken',
      view_status: 'Bekijk status',
      refresh: 'Status verversen',
    },

    connect: {
      success: 'Mollie succesvol verbonden.',
      failed: 'Verbinden met Mollie is mislukt — probeer opnieuw.',
      cancelled: 'Verbinden met Mollie is afgebroken.',
      popup_blocked: 'Het pop-up venster werd geblokkeerd. Sta pop-ups toe of probeer opnieuw.',
    },

    disconnect: {
      title: 'Mollie verbinding verbreken?',
      description:
        'Klanten kunnen daarna geen factuur meer online betalen via Mollie. Bestaande betalingen blijven zichtbaar.',
      confirm: 'Verbinding verbreken',
      success: 'Mollie verbinding verbroken.',
      error: 'Kon Mollie verbinding niet verbreken.',
    },

    reasons: {
      not_licensed: 'Mollie is alleen beschikbaar in de module Slim Innen.',
      not_connected: 'Verbind eerst je Mollie-account in het Integraties-menu.',
      reauth_required: 'De verbinding met Mollie is verlopen. Verbind opnieuw.',
      not_configured: 'Mollie is op dit moment niet beschikbaar. Probeer later opnieuw.',
      no_access_token: 'De verbinding met Mollie is verlopen. Verbind opnieuw.',
    },

    errors: {
      MOLLIE_NOT_CONNECTED: 'Mollie is niet verbonden — schakel eerst in via Integraties.',
      MOLLIE_REAUTH_REQUIRED: 'De verbinding met Mollie is verlopen — verbind opnieuw.',
      MOLLIE_PROFILE_REQUIRED:
        'Mollie vereist een website-profiel voordat je betaallinks kunt aanmaken. Open Mollie → Instellingen → Profielen → Nieuw profiel.',
      MOLLIE_PROFILE_REQUIRED_action: 'Open Mollie dashboard',
      INVOICE_NOT_PAYABLE: 'Deze factuur is niet (meer) beschikbaar voor betaling.',
      INVOICE_FULLY_PAID: 'Deze factuur is al volledig betaald.',
      INVALID_AMOUNT: 'Het bedrag van deze factuur is ongeldig voor online betaling.',
      MOLLIE_PAY_RATE_LIMIT_EXCEEDED: 'Te veel pogingen. Probeer over een minuut opnieuw.',
      generic: 'Er ging iets mis bij Mollie. Probeer het later opnieuw.',
    },

    public: {
      pay_now: 'Betaal nu',
      pay_now_description: 'Betaal direct online via iDEAL, creditcard en meer.',
      redirecting: 'Je wordt doorgestuurd naar Mollie…',
      already_paid: 'Deze factuur is al volledig betaald.',
      not_payable: 'Deze factuur kan op dit moment niet online betaald worden.',
      check_status: 'Controleren of je betaling is ontvangen…',
      payment_received: 'Bedankt — je betaling is ontvangen.',
    },

    payments_table: {
      mollie_label: 'Verwerkt via Mollie',
      refund_label: 'Terugbetaling',
      chargeback_label: 'Chargeback (terugboeking via bank)',
    },

    work_order_complete: {
      title: 'Klant kan nu betalen',
      subtitle: 'Scan de QR-code of deel de betaallink met de klant.',
      open_link: 'Open betaallink',
      close: 'Sluit',
      invoice_created: 'Factuur {number} aangemaakt.',
      show_payment_link: 'Toon betaallink',
      payment_link_error: 'Kon de betaallink niet ophalen.',
      amount_due: 'Te betalen',
      show_lines: 'Bekijk regels ({count})',
      hide_lines: 'Verberg regels',
    },
  },

  // ===========================================================================
  // ZO Boekhouden
  // ===========================================================================
  zo_boekhouden: {
    name: 'ZO Boekhouden',
    description:
      'Koppel je administratie: facturen en betalingen gaan automatisch naar ZO Boekhouden. Bankbetalingen komen terug zodat facturen in FunnelFlow op ‘betaald’ komen.',

    status: {
      connected: 'Actief',
      not_connected: 'Niet gekoppeld',
      inactive: 'Inactief',
      active_message:
        'Koppeling actief. Nieuwe en gewijzigde facturen + Mollie-betalingen worden automatisch doorgestuurd.',
      empty_message:
        'Nog niet gekoppeld. Vraag de webhook-URL bij ZO Boekhouden en vul die hier in om te starten.',
    },

    settings: {
      webhook_url: 'Webhook-URL',
      webhook_url_info:
        'Endpoint van ZO waarop wij events sturen (invoice.updated, payment.received).',
      webhook_secret: 'Webhook-secret',
      webhook_secret_info: 'Gedeeld geheim voor HMAC-handtekening. Deel dit veilig met ZO.',
      is_active: 'Actief',
      is_active_info: 'Zet aan zodra de URL van ZO bekend is.',
      help: 'ZO haalt factuurdetails op via de External API (API-key van deze organisatie). Zonder actieve koppeling blijven facturen alleen in FunnelFlow.',
    },

    actions: {
      connect: 'Koppelen',
      manage: 'Beheer ZO Boekhouden',
      save: 'Opslaan',
      disconnect: 'Koppeling verwijderen',
    },

    save: {
      success: 'ZO Boekhouden-instellingen opgeslagen.',
      error: 'Kon ZO Boekhouden-instellingen niet opslaan.',
    },

    disconnect: {
      title: 'ZO Boekhouden-koppeling verwijderen?',
      description: 'Facturen en betalingen worden dan niet meer doorgestuurd naar ZO Boekhouden.',
      confirm: 'Verwijderen',
      success: 'ZO Boekhouden-koppeling verwijderd.',
      error: 'Kon ZO Boekhouden-koppeling niet verwijderen.',
    },
  },

  snelstart: {
    name: 'SnelStart',
    description:
      'Boek facturen automatisch in je SnelStart-administratie (relaties + verkoopboekingen).',

    status: {
      connected: 'Actief',
      not_connected: 'Niet gekoppeld',
      inactive: 'Inactief',
      active_message:
        'Koppeling actief. Facturen met factuurnummer worden als verkoopboeking naar SnelStart gestuurd.',
      empty_message:
        'Nog niet gekoppeld. Plak je maatwerksleutel uit SnelStart (Koppelingen → Maatwerk) om te starten.',
    },

    settings: {
      company: 'Administratie',
      connection_key: 'Maatwerksleutel',
      connection_key_info:
        'Sleutel uit SnelStart Web → Koppelingen → Maatwerk. Vereist pakket inZicht of inControle.',
      connection_key_placeholder_existing: 'Leeg laten om huidige sleutel te behouden',
      grootboek_hoog: 'Grootboek omzet hoog (21%)',
      grootboek_hoog_info: 'Verplicht voor sync van standaard BTW-regels.',
      grootboek_laag: 'Grootboek omzet laag (9%)',
      grootboek_laag_info: 'Optioneel; anders valt laag terug op hoog.',
      grootboek_nul: 'Grootboek omzet 0%',
      grootboek_nul_info: 'Optioneel voor vrijgestelde regels.',
      grootboek_empty: '— Kies een rekening —',
      is_active: 'Actief',
      is_active_info:
        'Zet uit om tijdelijk te stoppen met syncen zonder de koppeling te verwijderen.',
      help: 'FunnelFlow schrijft relaties en verkoopboekingen naar de SnelStart B2B API. Betalingen afletteren volgt later. Productie vereist certificering bij SnelStart.',
    },

    actions: {
      connect: 'Koppelen',
      manage: 'Beheer SnelStart',
      save: 'Opslaan',
      disconnect: 'Koppeling verwijderen',
    },

    save: {
      success: 'SnelStart-instellingen opgeslagen.',
      error: 'Kon SnelStart-instellingen niet opslaan.',
    },

    disconnect: {
      title: 'SnelStart-koppeling verwijderen?',
      description:
        'Facturen worden dan niet meer naar SnelStart geboekt. Bestaande boekingen in SnelStart blijven staan.',
      confirm: 'Verwijderen',
      success: 'SnelStart-koppeling verwijderd.',
      error: 'Kon SnelStart-koppeling niet verwijderen.',
    },
  },

  twinfield: {
    name: 'Twinfield',
    description:
      'Boek verzonden facturen automatisch in Twinfield (debiteur + verkoopboeking).',

    status: {
      connected: 'Actief',
      not_connected: 'Niet gekoppeld',
      inactive: 'Inactief',
      active_message:
        'Koppeling actief. Facturen met factuurnummer worden als verkoopboeking naar Twinfield gestuurd.',
      inactive_message:
        'Gekoppeld, nog niet actief. Kies een administratie, grootboek en btw-code en zet de koppeling aan.',
      empty_message:
        'Nog niet gekoppeld. Log in bij Twinfield om facturen automatisch te boeken.',
      reauth_message: 'Twinfield-sessie verlopen. Koppel opnieuw om door te gaan met boeken.',
      not_configured: 'Twinfield is nog niet geconfigureerd op de server.',
    },

    settings: {
      office: 'Administratie',
      office_info:
        'Wisselen van administratie wist grootboek, btw-codes en de koppeling tussen bestaande klanten en boekingen.',
      office_empty: '— Kies een administratie —',
      grootboek_hoog: 'Grootboek omzet hoog (21%)',
      grootboek_laag: 'Grootboek omzet laag (9%)',
      grootboek_nul: 'Grootboek omzet 0%',
      vat_hoog: 'Btw-code hoog (21%)',
      vat_laag: 'Btw-code laag (9%)',
      vat_nul: 'Btw-code 0%',
      journal: 'Dagboek',
      destiny: 'Boekingsstatus',
      destiny_info:
        'Concept kun je later nog aanpassen of verwijderen. Definitief staat direct in het grootboek.',
      destiny_temporary: 'Concept (aanbevolen)',
      destiny_final: 'Definitief',
      option_empty: '— Kies —',
      is_active: 'Actief',
      is_active_info:
        'Zet aan als administratie, grootboek hoog en btw-code hoog zijn gekozen.',
      activate_required: 'Kies een administratie, grootboek hoog en btw-code hoog.',
      help: 'FunnelFlow blijft de factuur versturen. Twinfield krijgt een debiteur en een verkoopboeking met het FunnelFlow-factuurnummer. Betalingen afletteren volgt later.',
    },

    actions: {
      connect: 'Koppel Twinfield',
      reconnect: 'Opnieuw koppelen',
      manage: 'Beheer Twinfield',
      save: 'Opslaan',
      disconnect: 'Koppeling verwijderen',
    },

    connect: {
      success: 'Twinfield is verbonden. Kies nu een administratie en grootboek.',
      failed: 'Verbinden met Twinfield is mislukt.',
      popup_blocked: 'Sta pop-ups toe om Twinfield te koppelen.',
    },

    save: {
      success: 'Twinfield-instellingen opgeslagen.',
      error: 'Kon Twinfield-instellingen niet opslaan.',
    },

    disconnect: {
      title: 'Twinfield-koppeling verwijderen?',
      description:
        'Facturen worden dan niet meer naar Twinfield geboekt. Bestaande boekingen in Twinfield blijven staan.',
      confirm: 'Verwijderen',
      success: 'Twinfield-koppeling verwijderd.',
      error: 'Kon Twinfield-koppeling niet verwijderen.',
    },
  },

  moneybird: {
    name: 'Moneybird',
    description: 'Stuur verzonden facturen automatisch naar Moneybird en haal betalingen terug op.',

    status: {
      connected: 'Actief',
      not_connected: 'Niet gekoppeld',
      inactive: 'Inactief',
      active_message:
        'Koppeling actief. Verzonden facturen worden als externe verkoopfactuur (incl. PDF) in Moneybird geboekt; betalingen die je daar registreert komen automatisch terug.',
      empty_message:
        'Nog niet gekoppeld. Maak in Moneybird een persoonlijk API-token aan (Mijn account → Ontwikkelaars) om te starten.',
    },

    settings: {
      administration: 'Administratie',
      administration_info:
        'Je token heeft toegang tot meerdere administraties. Kies waar de facturen geboekt moeten worden.',
      administration_empty: '— Kies een administratie —',
      administration_required: 'Kies een administratie.',
      administration_pick:
        'Kies hieronder de Moneybird-administratie en klik nogmaals op Koppelen.',
      api_token: 'API-token',
      api_token_info:
        'Persoonlijk API-token uit Moneybird (Mijn account → Ontwikkelaars → API-tokens). Vereiste rechten: Verkoopfacturen en Instellingen.',
      api_token_placeholder_existing: 'Leeg laten om huidige token te behouden',
      api_token_required: 'Vul een API-token in.',
      tax_rate_high: 'Btw-tarief hoog (21%)',
      tax_rate_low: 'Btw-tarief laag (9%)',
      tax_rate_zero: 'Btw-tarief 0%',
      tax_rate_reverse_charge: 'Btw-tarief verlegd',
      tax_rate_reverse_charge_info:
        'Gebruikt voor facturen met btw verlegd. Optioneel; anders valt dit terug op 0%.',
      ledger_account: 'Grootboekrekening omzet',
      ledger_account_info: 'Optioneel; leeg = standaard omzetrekening van Moneybird.',
      option_empty: '— Kies —',
      is_active: 'Actief',
      is_active_info:
        'Zet uit om tijdelijk te stoppen met syncen zonder de koppeling te verwijderen.',
      webhook_ok: 'Webhook geregistreerd: betalingen uit Moneybird komen automatisch binnen.',
      webhook_missing:
        'Webhook niet geregistreerd. Betalingen uit Moneybird worden dan niet automatisch opgehaald.',
      help: 'FunnelFlow blijft de afzender van de factuur; Moneybird ontvangt een externe verkoopfactuur met de FunnelFlow-PDF als bijlage. Betalingen via Mollie/iDEAL worden (nog) niet naar Moneybird gestuurd.',
    },

    actions: {
      connect: 'Koppelen',
      manage: 'Beheer Moneybird',
      save: 'Opslaan',
      disconnect: 'Koppeling verwijderen',
      register_webhook: 'Opnieuw registreren',
    },

    save: {
      success: 'Moneybird-instellingen opgeslagen.',
      error: 'Kon Moneybird-instellingen niet opslaan.',
    },

    webhook: {
      success: 'Webhook geregistreerd bij Moneybird.',
      error: 'Kon webhook niet registreren bij Moneybird.',
    },

    disconnect: {
      title: 'Moneybird-koppeling verwijderen?',
      description:
        'Facturen worden dan niet meer naar Moneybird gestuurd en betalingen niet meer opgehaald. Bestaande facturen in Moneybird blijven staan.',
      confirm: 'Verwijderen',
      success: 'Moneybird-koppeling verwijderd.',
      error: 'Kon Moneybird-koppeling niet verwijderen.',
    },
  },

  // ===========================================================================
  // Organization onboarding wizard
  // ===========================================================================
  onboarding: {
    actions: {
      next: 'Volgende',
      back: 'Terug',
      skip: 'Overslaan',
      finish: 'Afronden',
      upload_pdf: 'PDF uploaden',
    },
    fields: {
      company_name: 'Organisatienaam',
      logo: 'Logo',
      street: 'Straat',
      postal_code: 'Postcode',
      city: 'Plaats',
      phone: 'Telefoon',
      kvk: 'KVK-nummer',
      vat: 'BTW-nummer',
      iban: 'IBAN',
      terms_pdf: 'Algemene voorwaarden (PDF)',
      primary_color: 'Primaire kleur',
      accent_color: 'Accentkleur',
      reply_to_email: 'Reply-to e-mail',
      email: 'E-mailadres',
      role: 'Rol',
      team_emails: 'Teamleden uitnodigen',
    },
    steps: {
      company: {
        title: 'Vertel ons over je bedrijf',
        description:
          'Stuur binnen minuten een foutloze offerte de deur uit, met jouw branding, KvK en voorwaarden op elke offerte.',
        bullet_1: 'Offerte op naam met jouw logo en bedrijfsgegevens',
        bullet_2: 'Klanten accepteren je algemene voorwaarden direct online',
      },
      branding: {
        title: 'Huisstijl en e-mail',
        description: 'Automatische offertes in jouw stijl, klaar om digitaal te ondertekenen.',
        bullet_1: 'Offertes in jouw merkkleuren',
        bullet_2: 'Antwoorden van klanten komen op jouw reply-to adres',
      },
      products: {
        title: 'Welke testproducten?',
        description:
          'Bouw producten met variabelen en regels zodat klanten zelf een samenstelling maken.',
        bullet_1: 'Kies één of meer startproducten uit onze templates',
        bullet_2: 'Live prijsberekening op basis van opties en afmetingen',
      },
      team: {
        title: 'Nodig je team uit',
        description:
          'Alle klanten, communicatie en projecten op één plek waar je hele team mee werkt.',
        bullet_1: 'Sales en kantoor werken in hetzelfde CRM',
        bullet_2: 'Monteurs zien alleen hun werk op locatie',
      },
    },
    products: {
      hint: 'Selecteer de producten waarmee je wilt starten. Je kunt ze later aanpassen.',
    },
    team: {
      hint: "Nodig collega's uit zodat iedereen in hetzelfde systeem werkt.",
      emails_placeholder: 'naam@bedrijf.nl, collega@bedrijf.nl',
      emails_help: "Scheid meerdere e-mailadressen met komma's.",
      add_colleague: 'Nog een collega',
      role_admin: 'Kantoor / eigenaar: instellingen, team en offertes',
      role_member_label: 'Medewerker',
      role_member: 'Sales: leads, deals en offertes',
      role_installer_label: 'Monteur',
      role_installer: 'Veld: landt op Vandaag, geen instellingen',
    },
    checklist: {
      greeting: 'Hallo, {name}!',
      subtitle: 'Laten we je workspace inrichten.',
      progress: '{done} van {total} stappen afgerond',
      dismiss: 'Later verder',
      banner: {
        title: 'Rond je workspace in',
        subtitle: '{done} van {total} stappen afgerond',
        cta: 'Bekijk stappen',
      },
      steps: {
        profile: 'Bedrijfsprofiel',
        profile_description:
          'Je bedrijfsgegevens staan klaar. Pas ze aan via de organisatie-instellingen.',
        profile_cta: 'Naar instellingen',
        team: 'Team uitnodigen',
        team_description: "Nodig collega's uit zodat sales en montage in hetzelfde systeem werken.",
        team_cta: 'Team uitnodigen',
        products: 'Startproducten',
        products_description: 'Voeg producten toe zodat je configurator echte offertes kan maken.',
        products_cta: 'Naar producten',
        funnel: 'Eerste configurator publiceren',
        funnel_description: 'Publiceer je eerste funnel zodat klanten aanvragen kunnen doen.',
        funnel_cta: 'Naar funnels',
      },
    },
    errors: {
      company_name_required: 'Vul een organisatienaam in.',
      pdf_only: 'Alleen PDF-bestanden zijn toegestaan.',
      upload_failed: 'Upload mislukt.',
      save_failed: 'Opslaan mislukt. Probeer het opnieuw.',
      load_products: 'Kon testproducten niet laden.',
    },
  },

  // ===========================================================================
  // Platform Admin (Funnelflow team only)
  // ===========================================================================
  platform: {
    sidebar: {
      section: 'Funnelflow team',
      link: 'Platform admin',
    },
    nav: {
      overview: 'Overzicht',
      organizations: 'Organisaties',
      users: 'Gebruikers',
      billing: 'Billing',
      products: 'Producten',
      catalog: 'Catalogus',
      demo: 'Team seeden',
      audit: 'Audit log',
      exit: 'Terug naar app',
    },
    warning: {
      title: 'Je beheert hier ALLE organisaties.',
      body: 'Wees voorzichtig — alle wijzigingen worden gelogd en zijn direct zichtbaar voor klanten.',
    },
    impersonation: {
      banner_title: 'Je bent ingelogd als',
      exit: 'Stop impersonatie',
      exiting: 'Bezig met terugzetten…',
      exit_failed: 'Kon impersonatie niet stoppen.',
    },
    pickers: {
      search_organizations: 'Zoek een organisatie…',
      search_licenses: 'Kies een licentie…',
      search_placeholder: 'Zoeken…',
      loading: 'Laden…',
      no_results: 'Geen resultaten',
      selected: 'Geselecteerd',
      inactive: 'inactief',
    },
    relative: {
      just_now: 'zojuist',
      seconds: '{n} sec',
      minutes: '{n} min',
      hours: '{n} uur',
      days: '{n} dagen',
      months: '{n} mnd',
      years: '{n} jaar',
      ago: '{value} geleden',
      in: 'over {value}',
    },
    action_labels: {
      'billing.checkout_link.create': 'Stripe link aangemaakt',
      'billing.trial.extend': 'Trial verlengd',
      'products.copy_between_orgs': 'Producten gekopieerd',
      'user.impersonate.start': 'Ingelogd als gebruiker',
      'user.impersonate.end': 'Impersonation beëindigd',
      'organization.create': 'Organisatie aangemaakt',
      'organization.seed_demo': 'Demo-org geseeded',
      'organization.status.update': 'Org status gewijzigd',
      'license.manual.grant': 'Manuele licentie toegekend',
      'license.cancel': 'Licentie geannuleerd',
      'license.quantity.update': 'Aantal seats gewijzigd',
    },
    kpis: {
      title: 'KPIs',
      mrr: 'MRR',
      mrr_paying: 'MRR (betalend)',
      arr: 'ARR',
      mrr_added_30d: 'Nieuwe MRR (30d)',
      trial_mrr: 'Trial pipeline',
      trial_mrr_help:
        'Potentiële MRR als alle huidige trials zouden converteren — niet meegerekend in de echte MRR.',
      active_customers: 'Klanten',
      trials_active: 'Trials',
      trials_active_summary: '{n} trials actief',
      customers_summary: '{n} klanten',
      trials_ending_7d: 'Trial einde < 7d',
      new_signups_7d: 'Nieuw (7d)',
      new_signups_30d: 'Nieuw (30d)',
      churn_30d: 'Churn (30d)',
    },
    chart: {
      title: 'MRR over tijd',
      mrr_label: 'MRR (betalend)',
      trial_mrr_label: 'Trial MRR (potentieel)',
      load_failed: 'Kon grafiek niet laden.',
      empty: 'Nog geen historische data.',
      tooltip: {
        active_customers: 'Betalende klanten',
        trial_customers: 'Trial klanten',
      },
      interval: {
        weekly: 'Per week',
        monthly: 'Per maand',
      },
      range: {
        12: '12 weken',
        26: '26 weken',
        52: '52 weken',
      },
      disclaimer:
        'Historische MRR is geschat op basis van huidige subscription data — re-activaties en trial-conversies kloppen niet altijd retroactief. Voor exacte finance-cijfers zie de Stripe-rapportage.',
    },
    attention: {
      title: 'Action items',
      empty: 'Niets te doen — alles staat goed!',
      past_due: '{n} organisaties past_due',
      trials_ending_3d: '{n} trials lopen af binnen 3 dagen',
      orgs_without_license: '{n} actieve organisaties zonder licentie',
      suspended: '{n} organisaties geschorst',
      failed_jobs: "{n} failed jobs in queue '{queue}'",
      queue_unavailable: "Queue '{queue}' onbereikbaar (Redis hiccup)",
      view: 'Bekijk',
    },
    activity: {
      title: 'Recente activiteit',
      empty: 'Nog geen activiteit gelogd.',
      view_all: 'Bekijk alles',
      view_details: 'Details',
      load_failed: 'Kon stats niet laden.',
      generated_at: 'Bijgewerkt {value}',
    },
    landing: {
      title: 'Platform admin',
      description:
        'Tools voor het Funnelflow team om organisaties, gebruikers, billing en producten cross-tenant te beheren.',
      refresh: 'Vernieuwen',
      stats: {
        organizations: 'Organisaties',
        active: 'Actief',
        trials: 'Lopende trials',
      },
      tiles: {
        organizations: {
          title: 'Organisaties beheren',
          description: 'Lijst, status en details van alle organisaties.',
        },
        new_organization: {
          title: 'Nieuwe organisatie',
          description: 'Maak een organisatie aan en stuur een owner-uitnodiging.',
        },
        users: {
          title: 'Gebruikers + impersonatie',
          description: 'Zoek cross-org gebruikers en log in als een klant.',
        },
        checkout_link: {
          title: 'Stripe checkout link',
          description: 'Genereer een betaal-link met aanpasbare trial.',
        },
        trial_extend: {
          title: 'Trial verlengen',
          description: 'Schuif de trial-einddatum van een Stripe abonnement op.',
        },
        manual_license: {
          title: 'Manuele licentie',
          description: 'Geef een licentie zonder Stripe (partner / beta / intern).',
        },
        products_copy: {
          title: 'Producten kopiëren',
          description: 'Kopieer feeds, categorieën en producten tussen orgs.',
        },
        demo_seed: {
          title: 'Team seeden',
          description: 'Kopieer catalogus en pipeline naar een team met nepdata.',
        },
        audit: {
          title: 'Audit log',
          description: 'Bekijk welke admin wat heeft gedaan, met filters.',
        },
      },
    },
    organizations: {
      title: 'Organisaties',
      description: 'Lijst van alle Funnelflow organisaties.',
      new: 'Nieuwe organisatie',
      new_title: 'Nieuwe organisatie',
      new_description:
        'Maak een organisatie aan en stuur direct een uitnodiging naar de eerste owner.',
      back_to_list: 'Terug naar lijst',
      search_placeholder: 'Zoek op naam of slug…',
      empty_title: 'Geen organisaties gevonden',
      empty_description: 'Pas je filters aan of maak een nieuwe organisatie.',
      load_failed: 'Kon organisaties niet laden.',
      status: {
        all: 'Alles',
        active: 'Actief',
        suspended: 'Geschorst',
        archived: 'Gearchiveerd',
      },
      col: {
        name: 'Naam',
        status: 'Status',
        activity: 'Activiteit',
        members: 'Leden',
        base_license: 'Basis licentie',
        modules: 'Modules',
        created_at: 'Aangemaakt',
      },
      activity: {
        recent: 'Actief',
        quiet: 'Rustig',
        inactive: 'Inactief',
        unknown: 'Geen data',
        latest: 'Laatste activiteit',
        last_login: 'Login',
        last_proposal: 'Offerte',
        logins: 'Logins',
        proposals: 'Offertes',
        deals: 'Deals',
        orders: 'Bestellingen',
      },
      fields: {
        name: 'Naam',
        name_placeholder: 'Bijv. Acme BV',
        slug: 'Slug',
        slug_placeholder: 'acme-bv',
        slug_help: 'URL-vriendelijke ID. Wordt gebruikt in interne URLs.',
        owner_email: 'Owner e-mail',
        owner_email_placeholder: "owner{'@'}klant.nl",
        owner_role: 'Rol',
      },
      roles: {
        admin: 'Admin',
        owner: 'Owner',
      },
      create_submit: 'Organisatie aanmaken',
      create_success: 'Organisatie aangemaakt en uitnodiging verstuurd.',
      create_failed: 'Kon organisatie niet aanmaken.',
      result_title: 'Aangemaakt',
      invite_title: 'Owner uitnodiging',
      invite_existing:
        'Deze gebruiker bestond al — er is een uitnodiging naar de bestaande account verstuurd.',
      invite_new:
        'De owner ontvangt een mail om hun account te activeren. Kopieer de link hieronder als de mail niet aankomt.',
      invite_expires: 'Verloopt op',
      open_org: 'Open organisatie',
      create_another: 'Nog één aanmaken',
      actions: {
        new_link: 'Stripe link',
        extend_trial: 'Trial verlengen',
        manual_license: 'Manuele licentie',
        update_quantity: 'Aantal seats',
        cancel: 'Annuleren',
      },
      onboarding: {
        title: 'Onboarding',
        disable: 'Uitzetten',
        enable: 'Aanzetten',
        reset: 'Resetten',
        disable_title: 'Onboarding uitzetten?',
        disable_description: 'De wizard en checklist worden verborgen voor deze organisatie.',
        enable_title: 'Onboarding aanzetten?',
        enable_description: 'Onboarding volgt weer de normale regels (cutoff / pending).',
        reset_title: 'Onboarding resetten?',
        reset_description:
          'De admin van deze org ziet de intake opnieuw bij de volgende login. Bestaande data blijft behouden.',
        disable_success: 'Onboarding uitgezet.',
        enable_success: 'Onboarding aangezet.',
        reset_success: 'Onboarding gereset.',
        disable_failed: 'Kon onboarding niet uitzetten.',
        enable_failed: 'Kon onboarding niet aanzetten.',
        reset_failed: 'Kon onboarding niet resetten.',
        status: {
          grandfathered: 'Bestaande klant',
          pending: 'Intake open',
          completed: 'Afgerond',
          disabled: 'Uitgezet',
        },
      },
      sales_orders: {
        title: 'Verkooporder',
        on: 'Aan',
        off: 'Uit',
        hint: 'Projecten starten met een verkooporder, ook zonder offerte. De order is de bron voor scope en meerwerk.',
        enable: 'Aanzetten',
        disable: 'Uitzetten',
        enable_title: 'Verkooporder aanzetten?',
        enable_description:
          '{name} start projecten dan met de verkooporder-wizard, ook zonder offerte. De verkooporder wordt de bron voor de projectscope, en meerwerk kan pas als er een order is.',
        disable_title: 'Verkooporder uitzetten?',
        disable_description:
          '{name} start projecten dan weer vanuit een offerte. Bestaande verkooporders blijven staan, maar de scope volgt weer de offerte en meerwerk kan zonder order.',
        enabled_success: 'Verkooporder staat aan.',
        disabled_success: 'Verkooporder staat uit.',
        failed: 'Kon de verkooporder niet omzetten.',
      },
      detail: {
        slug: 'Slug',
        id: 'ID',
        members: 'Leden',
        subscriptions: 'Abonnementen',
        counts: 'Statistieken',
        no_members_title: 'Nog geen leden',
        no_members_description: 'Deze organisatie heeft nog geen actieve leden.',
        no_subs_title: 'Geen abonnementen',
        no_subs_description: 'Genereer een Stripe-link of geef een manuele licentie.',
        load_failed: 'Kon organisatie niet laden.',
        status_updated: 'Status bijgewerkt.',
        status_update_failed: 'Kon status niet bijwerken.',
        update_quantity_prompt: 'Nieuw aantal seats:',
        invalid_quantity: 'Ongeldig aantal.',
        quantity_updated: 'Aantal seats bijgewerkt.',
        quantity_update_failed: 'Kon aantal niet bijwerken.',
        cancel_title: 'Abonnement annuleren?',
        cancel_description:
          '"{name}" wordt geannuleerd. Voor base licenses worden ook alle modules opgezegd. Weet je het zeker?',
        cancel_confirm: 'Ja, annuleren',
        cancel_success: 'Abonnement geannuleerd.',
        cancel_failed: 'Kon niet annuleren.',
        this_subscription: 'dit abonnement',
        remove_member_action: 'Verwijderen',
        remove_member_title: 'Lid verwijderen uit team?',
        remove_member_description:
          '"{name}" wordt uit deze organisatie verwijderd. Het gebruikersaccount en andere teams blijven behouden. Weet je het zeker?',
        remove_member_confirm: 'Ja, verwijderen',
        remove_member_success: 'Lid verwijderd uit team.',
        remove_member_failed: 'Kon lid niet verwijderen.',
        remove_last_admin_blocked:
          'Dit is de laatste beheerder van de organisatie en kan niet worden verwijderd. Maak eerst een ander lid beheerder.',
        remove_last_member_blocked:
          'Dit is het laatste lid van de organisatie en kan niet worden verwijderd. Een organisatie moet minimaal één lid houden.',
      },
      counts: {
        forms: 'Funnels',
        deals: 'Deals',
        orders: 'Bestellingen',
        submissions: 'Aanvragen',
        products: 'Producten',
      },
    },
    users: {
      title: 'Gebruikers',
      description: 'Cross-org gebruikerszoekfunctie + impersonatie.',
      search: 'Zoeken',
      search_placeholder: 'Zoek op e-mail of naam…',
      search_failed: 'Zoeken mislukt.',
      empty_title: 'Geen gebruikers gevonden',
      empty_description: 'Probeer een ander e-mailadres of naam.',
      no_name: 'Geen naam',
      last_sign_in: 'Laatst ingelogd',
      impersonate: 'Login as',
      impersonate_confirm_title: 'Inloggen als gebruiker?',
      impersonate_confirm_description:
        'Je gaat inloggen als {label}. Je huidige sessie wordt bewaard en je kunt deze later herstellen via de banner bovenaan.',
      impersonate_confirm_submit: 'Ja, inloggen',
      impersonate_failed: 'Impersonatie is mislukt.',
      col: {
        email: 'E-mail',
        name: 'Naam',
        role: 'Rol',
      },
    },
    checkout: {
      title: 'Stripe checkout link',
      description:
        'Genereer een betaal-link voor een organisatie met optionele trial en price-overrides.',
      submit: 'Genereer link',
      success: 'Stripe link aangemaakt.',
      failed: 'Kon Stripe link niet genereren.',
      result_title: 'Resultaat',
      open_in_stripe: 'Open in Stripe',
      send_to_customer: 'Stuur naar klant',
      email_subject: 'Je Funnelflow betaal-link',
      email_body:
        'Hi,\n\nKlik op deze link om je abonnement af te ronden:\n{url}\n\nGroet,\nFunnelflow',
      trial_ends: 'Eerste factuur op {date}',
      advanced: 'Geavanceerd',
      no_modules: 'Geen modules beschikbaar.',
      trial: {
        default: 'Default (van licentie)',
        days: 'Aangepast aantal dagen',
        date: 'Specifieke datum',
        none: 'Geen trial',
      },
      fields: {
        organization: 'Organisatie',
        base_license: 'Basis licentie',
        quantity: 'Aantal seats',
        quantity_range: 'Minimaal {min}, maximaal {max}',
        quantity_min: 'Minimaal {min}',
        modules: 'Modules',
        trial: 'Trial',
        trial_days_hint: 'Aantal dagen voordat de eerste factuur volgt.',
        trial_days_unit: 'dagen',
        trial_date_hint: 'Datum waarop de eerste factuur wordt aangemaakt.',
        email_override: 'E-mail override',
        email_override_placeholder: "billing{'@'}klant.nl",
        email_override_help:
          'Stuur de Stripe customer naar dit mailadres in plaats van auto-lookup.',
        price_overrides: 'Price overrides',
        price_overrides_help: 'Vrij Stripe price ID per licentie voor maatwerk-deals.',
        success_url: 'Success URL',
        success_url_placeholder: 'https://app.getfunnelflow.com/billing/success',
        cancel_url: 'Cancel URL',
        cancel_url_placeholder: 'https://app.getfunnelflow.com/billing/cancel',
        note: 'Notitie',
        note_placeholder: 'Vrije tekst, opgeslagen in subscription.metadata',
      },
      errors: {
        no_organization: 'Kies eerst een organisatie.',
        no_license: 'Kies eerst een base license.',
      },
    },
    trial: {
      title: 'Trial verlengen',
      description: 'Schuif de eerste-factuurdatum van een Stripe abonnement op.',
      submit: 'Trial verlengen',
      success: 'Trial verlengd.',
      failed: 'Kon trial niet verlengen.',
      result_title: 'Resultaat',
      warning:
        'Werkt alleen voor organisaties met een actieve Stripe-subscription, niet voor manuele licenties.',
      fields: {
        new_trial_end: 'Nieuwe trial-einddatum',
        trial_end_hint: 'Datum waarop de eerste factuur wordt aangemaakt.',
      },
      errors: {
        no_stripe_sub: 'Geen actieve Stripe subscription gevonden voor deze organisatie.',
      },
    },
    manual_license: {
      title: 'Manuele licentie',
      description:
        'Geef een licentie zonder Stripe. Voor partner-deals, beta gebruikers of intern gebruik.',
      submit: 'Licentie toekennen',
      success: 'Licentie toegekend.',
      failed: 'Kon licentie niet toekennen.',
      warning:
        'Geen Stripe-betaling — verlenging gaat handmatig. Audit-log registreert wie en wanneer.',
      result_title: 'Resultaat',
      fields: {
        license: 'Licentie',
        quantity: 'Aantal seats',
        start_date: 'Startdatum',
        end_date: 'Einddatum',
        is_trial: 'Trial-licentie',
        is_trial_help: 'Markeer als trial in plaats van een betaalde licentie.',
      },
      errors: {
        conflict: 'Deze organisatie heeft al een actieve subscription voor deze licentie.',
      },
    },
    demo_seed: {
      title: 'Team seeden',
      description:
        'Kopieer formulieren, producten en pipeline van een bron-team naar een doel-team. Leads, deals, offertes en facturen worden verzonnen — echte klantdata blijft waar die is.',
      run_dry_run: 'Dry run preview',
      execute: 'Team seeden',
      dry_run_title: 'Dry run preview',
      executed_title: 'Team geseeded',
      success: 'Het team is klaar. Je kunt er nu naartoe schakelen.',
      failed: 'Seeden mislukt.',
      dry_run_failed: 'Dry run mislukt.',
      switch_failed: 'Kon niet naar het team schakelen.',
      open_demo: 'Open team',
      open_target: 'Open team',
      default_source: 'Akogo Zonwering',
      default_target: 'Zonwering Demo',
      warning:
        'Dit wist de bestaande inhoud van “{target}” en vult het team opnieuw. Het bron-team zelf blijft ongewijzigd.',
      confirm_title: 'Team opnieuw seeden?',
      confirm_description:
        '“{target}” wordt leeggehaald en opnieuw gevuld vanuit {source}, met verzonnen leads, deals, offertes en facturen. Doorgaan?',
      confirm_submit: 'Ja, seeden',
      fields: {
        source: 'Bron-team',
        source_hint: 'Leeg laten om Akogo Zonwering te gebruiken.',
        target: 'Doel-team',
        target_hint: 'Leeg laten om de gedeelde demo-org “Zonwering Demo” te gebruiken.',
      },
      copies: {
        structure: 'Wel: formulieren, producten, pipeline, offerte-templates.',
        fake_data: 'Wel: ~40 verzonnen leads en deals, verdeeld over de pipeline.',
        examples: 'Wel: voorbeeldoffertes en nepfacturen (zonder echte klantdata).',
        never: 'Niet: echte klanten, submissions, integraties, API-keys.',
      },
      errors: {
        same_org: 'Bron en doel mogen niet hetzelfde team zijn.',
      },
      counts: {
        forms: 'Formulieren',
        pipelines: 'Pipelines',
        stages: 'Stages',
        feeds: 'Feeds',
        categories: 'Categorieën',
        products: 'Producten',
        designs: 'Designs',
        leads: 'Leads',
        deals: 'Deals',
        proposals: 'Offertes',
        invoices: 'Facturen',
      },
    },
    products: {
      title: 'Producten kopiëren',
      description:
        'Kopieer categorieën, feeds, producten en upsell-koppelingen van organisatie A naar B — alles of een specifieke selectie.',
      run_dry_run: 'Dry run preview',
      execute: 'Echt uitvoeren',
      dry_run_title: 'Dry run preview',
      executed_title: 'Kopie afgerond',
      success: 'Producten gekopieerd.',
      failed: 'Kopie mislukt.',
      dry_run_failed: 'Dry run mislukt.',
      dry_run_label: 'Type',
      is_dry_run: 'Dry run',
      is_executed: 'Uitgevoerd',
      open_target: 'Open target organisatie',
      warning: 'Begin altijd met een dry run om te zien wat er gekopieerd wordt.',
      confirm_title: 'Producten kopiëren?',
      confirm_description:
        'Je gaat {products} producten en {categories} categorieën naar "{target}" kopiëren. Doorgaan?',
      confirm_submit: 'Ja, kopiëren',
      fields: {
        source: 'Bron organisatie',
        target: 'Doel organisatie',
      },
      counts: {
        categories: 'Categorieën',
        feeds: 'Feeds',
        products: 'Producten',
        category_links: 'Categorie-links',
        upsells_remapped: 'Upsells remapped',
      },
      errors: {
        same_org: 'Bron en doel mogen niet dezelfde organisatie zijn.',
        catalog_failed: 'Kon bron-catalogus niet laden.',
        no_selection: 'Selecteer minimaal één feed, categorie of product.',
      },

      // ---- Source catalog / selection ----
      selection: {
        title: 'Wat wil je kopiëren?',
        description:
          'Kies de hele catalogus of een specifieke selectie. Bij selectie worden de bijbehorende feeds en categorieën altijd automatisch meegenomen.',
        load_source_first: 'Kies eerst een bron-organisatie om de catalogus te laden.',
        loading_catalog: 'Catalogus laden…',
        empty: 'Bron-organisatie heeft geen producten.',
        feed_label: 'Feed',
        no_feed: 'Geen feed',
        no_image: 'Geen afbeelding',
        product_count: '{n} producten',
        search_placeholder: 'Zoek op titel of SKU…',
        select_all: 'Alles selecteren',
        deselect_all: 'Alles deselecteren',
        showing_first: 'Eerste {n} resultaten',
      },

      mode: {
        all: 'Hele catalogus',
        feeds: 'Per feed',
        categories: 'Per categorie',
        products: 'Per product',
      },

      summary: {
        title: 'Samenvatting',
        full_copy: 'Volledige catalogus wordt gekopieerd.',
        partial_copy: 'Selectie:',
        products: '{n} producten',
        feeds: '{n} feeds',
        categories: '{n} categorieën',
      },

      result: {
        mode_full: 'Volledige catalogus',
        mode_partial: 'Selectie',
        requested: 'Aangevraagd',
        resolved: 'Resolved',
        requested_products: '{n} product-IDs',
        requested_feeds: '{n} feed-IDs',
        requested_categories: '{n} categorie-IDs',
      },
    },
    audit: {
      title: 'Audit log',
      description: 'Alle wijzigingen vanuit /platform/* — success én error worden gelogd.',
      load_failed: 'Kon audit log niet laden.',
      empty_title: 'Geen audit log entries',
      empty_description: 'Pas je filters aan om resultaten te zien.',
      detail_title: 'Audit log details',
      filters: {
        action: 'Action',
        status: 'Status',
        from: 'Van',
        to: 'Tot',
        actor_user_id: 'Actor user ID',
        target_org: 'Target org ID',
        all_actions: 'Alle acties',
        all_statuses: 'Alle statussen',
      },
      col: {
        created_at: 'Tijd',
        actor: 'Actor',
        action: 'Action',
        status: 'Status',
        target_org: 'Target org',
      },
      actor: 'Actor',
      action: 'Action',
      target_org: 'Target organisatie',
      status: 'Status',
      created_at: 'Aangemaakt',
      payload: 'Payload',
      copy: 'Kopieer',
      copied: 'Gekopieerd',
    },
  },

  // ============================================================
  // Stats Dashboard
  // ============================================================
  stats_dashboard: {
    title: 'Stats',
    description: 'Omzet, funnel, marge en team in één overzicht',
    vat_note: 'Bedragen excl. BTW',
    nav_label: 'Stats',
    refresh: 'Vernieuwen',
    refresh_widget: 'Widget opnieuw laden',
    last_updated: 'Bijgewerkt {when}',
    load_failed: 'Stats laden mislukt',
    empty_data: 'Geen data in deze periode',

    // Filters in de header
    filters: {
      period_label: 'Periode',
      pipeline_label: 'Pipeline',
      pipeline_all: 'Alle pipelines',
      scope_label: 'Bereik',
      scope_organization: 'Organisatie',
      scope_user: 'Mijn data',
      custom_from: 'Van',
      custom_to: 'Tot',
    },
    periods: {
      '7d': 'Laatste 7 dagen',
      '30d': 'Laatste 30 dagen',
      '90d': 'Laatste 90 dagen',
      mtd: 'Deze maand',
      qtd: 'Dit kwartaal',
      ytd: 'Dit jaar',
      all: 'Alles',
      custom: 'Aangepast',
    },

    // Per-widget error states
    error: {
      timeout_title: 'Te traag om te laden',
      timeout_description:
        'Deze widget reageert traag — probeer het opnieuw of pas de periode aan.',
      failed_title: 'Kon widget niet laden',
      failed_description: 'Er ging iets mis bij het laden. Probeer het opnieuw.',
      retry: 'Opnieuw proberen',
    },

    // KPIs (§4)
    kpis: {
      title: "KPI's",
      sold: 'Verkocht',
      sold_hint: 'Geaccepteerde offertes in deze periode',
      sold_tooltip:
        'Verkochte omzet is de unieke verkoopwaarde excl. btw. Voorlopige en definitieve ' +
        'offertes binnen dezelfde deal tellen als één verkoop: de omzet blijft op de eerste ' +
        'acceptatiedatum staan, terwijl het bedrag en de productregels uit de huidige ' +
        'geaccepteerde definitieve offerte komen zodra die bestaat. Is er nog geen definitieve ' +
        'offerte, dan gebruiken we de huidige geaccepteerde voorlopige offerte. Meerwerk ' +
        'offertes tellen apart.',
      sold_tooltip:
        'Verkochte omzet is de unieke verkoopwaarde excl. btw. Voorlopige en definitieve ' +
        'offertes binnen dezelfde deal tellen als één verkoop: de omzet blijft op de eerste ' +
        'acceptatiedatum staan, terwijl het bedrag en de productregels uit de huidige ' +
        'geaccepteerde definitieve offerte komen zodra die bestaat. Is er nog geen ' +
        'definitieve offerte, dan gebruiken we de huidige geaccepteerde voorlopige offerte. ' +
        'Meerwerkoffertes tellen apart.',
      installed: 'Geïnstalleerd',
      installed_hint: 'Installaties afgerond in deze periode',
      installed_tooltip:
        'Omzet van installatie-werkbonnen die in deze periode zijn afgerond. Inmetingen tellen niet mee, en één project met meerdere montagebonnen wordt verdeeld zodat het bedrag niet dubbel telt.',
      planned: 'Gepland',
      planned_hint: 'Installaties met een afspraak in deze periode',
      planned_tooltip:
        'Omzet van installatie-werkbonnen waarvan de afspraak in deze periode valt. Bevestigde en voorlopige afspraken tellen beide. Inmetingen tellen niet mee.',
      collected: 'Geïnd',
      collected_hint: 'Betaalde facturen in deze periode',
      avg_ticket: 'Gem. ticket',
      avg_ticket_hint: 'Gemiddelde betaalde factuurwaarde',
      win_rate: 'Win rate',
      win_rate_hint: 'Gewonnen / (gewonnen + verloren)',
      counts: {
        accepted_proposals: '{n} offertes geaccepteerd',
        planned_work_orders: '{n} installaties in de planning',
        completed_work_orders: '{n} installaties afgerond',
        paid_invoices: '{n} facturen betaald',
        won_deals: '{n} gewonnen',
        lost_deals: '{n} verloren',
      },
    },

    // Funnel (§5)
    funnel: {
      title: 'Funnel',
      description: 'Van aanvraag tot betaling — conversies relatief aan #aanvragen.',
      conversion_short: 'Conv.',
      steps: {
        submissions: 'Aanvragen',
        deals: 'Deals',
        proposals_sent: 'Offertes verstuurd',
        proposals_accepted: 'Offertes geaccepteerd',
        invoices_created: 'Facturen aangemaakt',
        invoices_paid: 'Facturen betaald',
      },
    },

    // Revenue timeline (§6)
    revenue_timeline: {
      title: 'Omzet over tijd',
      description:
        'Kies verkocht, gepland of gerealiseerd voor de grafiek. Bedragen excl. BTW, per {interval}.',
      legend: {
        sold: 'Verkocht',
        planned: 'Gepland',
        realized: 'Gerealiseerd',
        ordered: 'Besteld',
        invoiced: 'Gefactureerd',
        paid: 'Ontvangen',
      },
      legend_hint: 'Klik om een serie te verbergen',
      interval: {
        daily: 'dag',
        weekly: 'week',
        monthly: 'maand',
      },
      // Bar-redesign (2026-05-13)
      hero_meta: 'Piek: {peakLabel} ({peakValue}) · gemiddeld {avg} per {interval}',
      of_sold: 'van verkocht',
      ratio_hint: '{ratio} van het verkochte bedrag bereikte deze fase',
    },

    // Pipeline (§7)
    pipeline: {
      title: 'Open pipeline',
      description: 'Wat staat er nu open per fase',
      no_open: 'Geen openstaande deals',
      column_count: 'deals',
      column_value: 'waarde',
      total_label: 'Totaal',
      total_format: '{count} deals · {value}',
    },

    // Health (§8)
    health: {
      title: 'Financiële gezondheid',
      description: 'Trailing-365-basis voor DSO en backlog',
      metrics: {
        dso: 'DSO',
        dso_hint: 'Days sales outstanding',
        sales_cycle: 'Verkoopcyclus',
        sales_cycle_hint: 'Gem. dagen van create tot won',
        backlog: 'Backlog',
        backlog_hint: 'Dagen omzet aan ongefactureerde opdrachten',
        accounts_receivable: 'Openstaand',
        accounts_receivable_hint: 'Niet-betaalde facturen',
        backlog_value: 'Backlog-waarde',
        backlog_value_hint: 'Niet-gefactureerde opdrachten',
        sold_backlog_value: 'Verkocht-backlog',
        sold_backlog_value_hint: 'Verkocht maar nog niet gefactureerd',
        sold_backlog_count: 'Open offertes',
        sold_backlog_count_hint: 'Geaccepteerd zonder factuur',
        sold_backlog_days: 'Verkocht-backlog dagen',
        sold_backlog_days_hint: 'Bij huidige run-rate',
        annual_revenue: 'Jaaromzet',
        annual_revenue_hint: 'Trailing 365 dagen',
      },
    },

    // Leaderboard (§9)
    leaderboard: {
      title: 'Toppers',
      sellers_title: 'Top verkopers',
      sellers_description: 'Op basis van geaccepteerde offertes',
      installers_title: 'Top monteurs',
      installers_description: 'Op basis van afgeronde werkbonnen',
      empty: 'Nog niemand op het scorebord',
      headers: {
        name: 'Naam',
        count: '#',
        value: 'Waarde',
      },
      count_orders: '{n} opdrachten',
      count_proposals: '{n} offertes',
    },

    reject_reasons: {
      title: 'Top afwijsredenen',
      description: 'Waarom offertes in deze periode zijn afgewezen',
      empty: 'Nog geen afwijzingen in deze periode',
      count_proposals: '{n} offertes',
      total: '{n} afgewezen · {value}',
    },

    // Installer stats (§10)
    products: {
      title: 'Producten',
      description: 'Verkocht en gefactureerd per product en categorie',
      tab_products: 'Top producten',
      tab_categories: 'Per categorie',
      empty: 'Geen producten in deze periode',
      headers: {
        rank: '#',
        product: 'Product',
        category: 'Categorie',
        sold: 'Verkocht',
        invoiced: 'Gefactureerd',
        units: 'Units',
        share: 'Aandeel',
      },
      totals: {
        sold: 'Totaal verkocht',
        invoiced: 'Totaal gefactureerd',
        products_with_id: 'Unieke producten',
        unknown: 'Onbekend',
        unknown_share: '{share} zonder product-link',
      },
      concentration: {
        top_n: 'Top {n} = {share} van verkocht',
        single: 'Top product = {share} van verkocht',
      },
      legend: {
        sold: 'Verkocht',
        invoiced: 'Gefactureerd',
      },
      donut_center: 'Verkocht',
      unknown_product: 'Onbekend product',
      no_category: 'Geen categorie',
      sold_breakdown: '{units} units · {proposals} offertes',
      invoiced_breakdown: '{units} units · {proposals} offertes',
    },
    installer_stats: {
      title: 'Monteur-stats',
      description: 'Per monteur per dag — gemiddelde factuurwaarde + uren',
      headers: {
        name: 'Monteur',
        work_orders: 'Werkbonnen',
        total_value: 'Totaal',
        avg_per_day: 'Gem. €/dag',
        hours: 'Uren',
        days: 'Dagen',
      },
      empty: 'Geen monteurs met werk in deze periode',
      filter_label: 'Monteur',
      filter_all: 'Alle monteurs',
    },

    // ============================================================
    // Margin widgets (2026-05-12)
    // Reads from proposal_items.metadata.margin_snapshot — only
    // stamped on proposals created after the migration, so coverage
    // is initially low and grows organically.
    // ============================================================
    margin_group: {
      title: 'Brutomarge',
      subtitle: 'Op basis van regels met margin-snapshot',
    },
    margin_totals: {
      title: 'Brutomarge',
      description: 'Omzet, kostprijs en marge in deze periode vs. vorige',
      empty: 'Brutomarge wordt zichtbaar zodra je nieuwe offertes accepteert',
      headline_label: 'Brutomarge in deze periode',
      margin_on_revenue: '{margin} op {revenue} omzet',
      delta_vs_previous: '{delta} vs. vorige periode',
      no_previous_period: 'Geen vorige periode om mee te vergelijken',
      no_previous_period_short: 'Geen vorige periode',
      previous_period_revenue: 'Op {revenue} omzet',
      cells: {
        revenue: 'Omzet',
        cost: 'Kostprijs',
        margin_value: 'Margebedrag',
        previous_margin_pct: 'Vorige marge%',
      },
      coverage: {
        ok_title: 'Op basis van {pct} van de regels',
        warn_title: 'Slechts {pct} van de regels',
        unknown_title: 'Coverage onbekend',
        detail: '{covered} van {total} regels met snapshot',
      },
    },
    margin_products: {
      title: 'Marge per product',
      description: 'Beste en slechtste marges in deze periode',
      empty: 'Nog geen producten met margin-data in deze periode',
      best_title: 'Top marge',
      best_hint: 'Beste marge eerst',
      best_empty: 'Nog geen producten met positieve marge',
      worst_title: 'Laagste marge',
      worst_hint: 'Slechtste marge eerst',
      worst_empty: 'Geen producten onder de aandacht',
      unknown_product: 'Onbekend product',
      totals: {
        product_count: 'Unieke producten',
        revenue: 'Omzet',
        margin: 'Margebedrag',
      },
      meta: {
        revenue: '{value} omzet',
        cost: '{value} kosten',
        units: '{n} units',
      },
      flag_below_min: 'Onder {min} min.',
    },
    margin_under_threshold: {
      title: 'Onder minimum marge',
      description: 'Offerteregels waarvan de marge onder de drempel zit',
      empty: 'Geen min. marge ingesteld op je producten',
      all_clear_title: 'Geen offertes onder de minimum marge',
      all_clear_description:
        'Alle geaccepteerde regels in deze periode halen of overschrijden hun drempel. Goed werk!',
      unknown_product: 'Onbekend product',
      qty_x: '{n} stuks',
      totals: {
        flagged_count: 'Gemarkeerde regels',
        flagged_value: 'Bedrag in alarm',
        flagged_margin_loss: 'Geschat marge-verlies',
      },
      headers: {
        date: 'Datum',
        product: 'Product',
        applied: 'Toegepast',
        min: 'Min.',
        gap: 'Gap',
        amount: 'Bedrag',
      },
    },

    // ============================================================
    // Forecast widget (Phase 3 — 2026-05-12)
    // Reads from /dashboard/stats/forecast. Driven by the annual
    // target configured in Settings → Forecast & doelen.
    // ============================================================
    forecast: {
      title: 'Prognose {year}',
      title_window: 'Prognose binnen filter',
      description: 'Doel vs. verkocht, gepland en gerealiseerd',
      description_window: 'Doel vs. werkelijk binnen de geselecteerde periode',
      empty_no_target: 'Stel een omzetdoel in om je voortgang hier te volgen',
      annual_target: 'Jaardoel',
      ytd_sold: 'YTD verkocht',
      ytd_planned: 'YTD gepland',
      ytd_realized: 'YTD gerealiseerd',
      ytd_target: 'YTD doel',
      ytd_gap: 'Verschil',
      // Window-mode summary labels
      window_sold: 'Verkocht',
      window_planned: 'Gepland',
      window_realized: 'Gerealiseerd',
      window_target: 'Doel periode',
      window_gap: 'Verschil',
      pace: 'Status',
      legend: {
        target: 'Doel (cumulatief)',
        sold: 'Werkelijk verkocht',
        planned: 'Gepland',
        realized: 'Gerealiseerd',
      },
      status: {
        ahead: '{delta} boven schema',
        on_track: 'Op schema',
        behind: '{delta} achter schema',
        achieved: 'Doel behaald',
        missed: 'Doel niet gehaald',
        no_target: 'Geen doel ingesteld',
      },
      // Mode toggle (window-mode delta 2026-05-13)
      mode: {
        year: 'Jaar',
        window: 'Filter',
      },
      mode_aria: 'Forecast weergavemodus',
      // Auto-bucket interval label (used in pattern footer)
      interval: {
        daily: 'per dag',
        weekly: 'per week',
        monthly: 'per maand',
      },
      projection_distribution: 'Projectie EOY',
      projection_linear: 'Lineaire projectie',
      above_target: 'boven doel',
      below_target: 'onder doel',
      pattern_used: 'Patroon',
    },
  },

  documents: {
    title: 'Documenten',
    add: 'Document toevoegen',
    uploading: 'Uploaden...',
    empty_title: 'Nog geen documenten',
    empty_deal: 'Upload contracten, tekeningen of andere bestanden. Ze gaan mee naar het project.',
    empty_project:
      'Hier staat de getekende offerte, plus documenten van de deal en bestanden die je zelf uploadt.',
    signed_proposal: 'Getekende offerte',
    signed_proforma: 'Getekende pro forma',
    signed_additional: 'Getekende meerwerkofferte',
    uploaded: 'Geüpload',
    from_deal: 'Vanuit deal',
    from_project: 'Vanuit project',
    download: 'Downloaden',
    delete: 'Verwijderen',
    delete_title: 'Document verwijderen?',
    delete_description: '"{name}" verdwijnt ook bij de gekoppelde deal of het project.',
    delete_confirm: 'Ja, verwijder',
    deleted: 'Document verwijderd',
    load_failed: 'Documenten laden mislukt',
    upload_failed: 'Uploaden mislukt',
    download_failed: 'Downloaden mislukt',
    delete_failed: 'Verwijderen mislukt',
  },
};
